// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-fetch';
import type { GetAuth0EmailVerificationStatusData, GetAuth0EmailVerificationStatusResponses, ResendAuth0VerificationEmailData, ResendAuth0VerificationEmailResponses, GeneratePasswordResetUrlData, GeneratePasswordResetUrlResponses, GetCheckMailingAddressData, GetCheckMailingAddressResponses, GetLicenseTypesData, GetLicenseTypesResponses, GetLicenseTypesErrors, GetFeeStructureFriendlyNamesData, GetFeeStructureFriendlyNamesResponses, GetLicenseTypeQuestionsData, GetLicenseTypeQuestionsResponses, GetLicenseTypeQuestionsErrors, GetLicenseTypeConfigurationData, GetLicenseTypeConfigurationResponses, GetLicenseTypeConfigurationErrors, GetNonRegistrantLicensesData, GetNonRegistrantLicensesResponses, GetNonRegistrantLicensesErrors, GetNonRegistrantLicenseStatsData, GetNonRegistrantLicenseStatsResponses, GetNonRegistrantLicenseStatsErrors, GetNonRegistrantLicenseFilterValuesData, GetNonRegistrantLicenseFilterValuesResponses, GetNonRegistrantLicenseFilterValuesErrors, GetNonRegistrantLicenseMapPinsData, GetNonRegistrantLicenseMapPinsResponses, GetNonRegistrantLicenseMapPinsErrors, ExportNonRegistrantLicensesData, ExportNonRegistrantLicensesResponses, ExportNonRegistrantLicensesErrors, GetNonRegistrantLicenseListQuestionColumnsData, GetNonRegistrantLicenseListQuestionColumnsResponses, GetNonRegistrantLicenseListQuestionColumnsErrors, GetNonRegistrantRegistrantAccountsData, GetNonRegistrantRegistrantAccountsResponses, GetNonRegistrantRegistrantAccountsErrors, SearchRegistrantAccountsData, SearchRegistrantAccountsResponses, SearchRegistrantAccountsErrors, GetNonRegistrantRegistrantAccountData, GetNonRegistrantRegistrantAccountResponses, GetNonRegistrantRegistrantAccountErrors, GetNonRegistrantRegistrantAccountLoginIdentitiesData, GetNonRegistrantRegistrantAccountLoginIdentitiesResponses, GetNonRegistrantRegistrantAccountLoginIdentitiesErrors, GetNonRegistrantOrganizationsData, GetNonRegistrantOrganizationsResponses, GetNonRegistrantOrganizationsErrors, GetNonRegistrantOrganizationData, GetNonRegistrantOrganizationResponses, GetNonRegistrantOrganizationErrors, GetInspectionsData, GetInspectionsResponses, GetInspectionsErrors, GetLicenseDetailsData, GetLicenseDetailsResponses, GetLicenseDetailsErrors, UpdateLicenseData, UpdateLicenseResponses, UpdateLicenseErrors, GetLicenseHistoryData, GetLicenseHistoryResponses, GetLicenseHistoryErrors, GetLicenseQuestionAnswerHistoryData, GetLicenseQuestionAnswerHistoryResponses, GetLicenseQuestionAnswerHistoryErrors, ListLicenseNotificationEmailsData, ListLicenseNotificationEmailsResponses, ListLicenseNotificationEmailsErrors, GetLicenseNotificationEmailData, GetLicenseNotificationEmailResponses, GetLicenseNotificationEmailErrors, UpdateLicenseAdditionalQuestionsData, UpdateLicenseAdditionalQuestionsResponses, UpdateLicenseAdditionalQuestionsErrors, UpdateLicenseRegistrantData, UpdateLicenseRegistrantResponses, UpdateLicenseRegistrantErrors, DeriveLicenseFromPaymentsData, DeriveLicenseFromPaymentsResponses, DeriveLicenseFromPaymentsErrors, ApproveLicenseData, ApproveLicenseResponses, ApproveLicenseErrors, CreateLicenseModificationRequestData, CreateLicenseModificationRequestResponses, CreateLicenseModificationRequestErrors, ApproveLicenseModificationRequestData, ApproveLicenseModificationRequestResponses, ApproveLicenseModificationRequestErrors, DenyLicenseModificationRequestData, DenyLicenseModificationRequestResponses, DenyLicenseModificationRequestErrors, CancelLicenseData, CancelLicenseResponses, CancelLicenseErrors, GetLicenseDeregistrationQuestionsData, GetLicenseDeregistrationQuestionsResponses, GetLicenseDeregistrationQuestionsErrors, StartDeregisterLicenseData, StartDeregisterLicenseResponses, StartDeregisterLicenseErrors, GetNonRegistrantLicenseCommentsData, GetNonRegistrantLicenseCommentsResponses, GetNonRegistrantLicenseCommentsErrors, CreateLicenseCommentData, CreateLicenseCommentResponses, CreateLicenseCommentErrors, ResolveRegistryNotificationData, ResolveRegistryNotificationResponses, ResolveRegistryNotificationErrors, FlagComplianceIssueData, FlagComplianceIssueResponses, FlagComplianceIssueErrors, ClearComplianceIssueData, ClearComplianceIssueResponses, ClearComplianceIssueErrors, UploadSharedAnswerFileData, UploadSharedAnswerFileResponses, UploadSharedAnswerFileErrors, DeleteLicenseCommentData, DeleteLicenseCommentResponses, DeleteLicenseCommentErrors, GetNonRegistrantLicensePaymentsData, GetNonRegistrantLicensePaymentsResponses, GetNonRegistrantLicensePaymentsErrors, MakeSharedLicensePaymentData, MakeSharedLicensePaymentResponses, MakeSharedLicensePaymentErrors, GetPaymentReceiptTemplateAvailableData, GetPaymentReceiptTemplateAvailableResponses, GetPaymentReceiptTemplateAvailableErrors, GetRegistrationCertificateTemplateAvailableData, GetRegistrationCertificateTemplateAvailableResponses, GetRegistrationCertificateTemplateAvailableErrors, GetLicenseRegistrationCertificatePdfData, GetLicenseRegistrationCertificatePdfResponses, GetLicenseRegistrationCertificatePdfErrors, GetLicensePaymentReceiptOptionsData, GetLicensePaymentReceiptOptionsResponses, GetLicensePaymentReceiptOptionsErrors, GetLicensePaymentReceiptPdfData, GetLicensePaymentReceiptPdfResponses, GetLicensePaymentReceiptPdfErrors, GetInspectionPaymentReceiptPdfData, GetInspectionPaymentReceiptPdfResponses, GetInspectionPaymentReceiptPdfErrors, RejectLicenseData, RejectLicenseResponses, RejectLicenseErrors, PreviewLicenseTransferData, PreviewLicenseTransferResponses, PreviewLicenseTransferErrors, TransferLicenseData, TransferLicenseResponses, TransferLicenseErrors, CreateManualPaymentData, CreateManualPaymentResponses, CreateManualPaymentErrors, GetManualPaymentAvailablePeriodsData, GetManualPaymentAvailablePeriodsResponses, GetManualPaymentAvailablePeriodsErrors, UpdateLicensePaymentPeriodData, UpdateLicensePaymentPeriodResponses, UpdateLicensePaymentPeriodErrors, DeleteManualPaymentData, DeleteManualPaymentResponses, DeleteManualPaymentErrors, UpdateManualPaymentData, UpdateManualPaymentResponses, UpdateManualPaymentErrors, GetAdminUsersData, GetAdminUsersResponses, GetAdminUsersErrors, CreateAdminUserData, CreateAdminUserResponses, CreateAdminUserErrors, GetOperatorAccessData, GetOperatorAccessResponses, GetAdminUserData, GetAdminUserResponses, GetAdminUserErrors, UpdateAdminUserData, UpdateAdminUserResponses, UpdateAdminUserErrors, GetAllLicenseTypeQuestionsData, GetAllLicenseTypeQuestionsResponses, GetAllLicenseTypeQuestionsErrors, CreateLicenseTypeQuestionData, CreateLicenseTypeQuestionResponses, CreateLicenseTypeQuestionErrors, GetLicenseTypeQuestionData, GetLicenseTypeQuestionResponses, GetLicenseTypeQuestionErrors, UpdateLicenseTypeQuestionData, UpdateLicenseTypeQuestionResponses, UpdateLicenseTypeQuestionErrors, GetPartiesData, GetPartiesResponses, GetPartiesErrors, CreatePartyData, CreatePartyResponses, CreatePartyErrors, GetPartyData, GetPartyResponses, GetPartyErrors, UpdatePartyData, UpdatePartyResponses, UpdatePartyErrors, GetPreviousPropertyManagersData, GetPreviousPropertyManagersResponses, GetPreviousPropertyManagersErrors, GetQuestionOptionsData, GetQuestionOptionsResponses, GetQuestionOptionsErrors, CreateQuestionOptionData, CreateQuestionOptionResponses, CreateQuestionOptionErrors, GetQuestionOptionData, GetQuestionOptionResponses, GetQuestionOptionErrors, UpdateQuestionOptionData, UpdateQuestionOptionResponses, UpdateQuestionOptionErrors, LookupParcelByAddressData, LookupParcelByAddressResponses, LookupParcelByAddressErrors, LookupParcelByApnData, LookupParcelByApnResponses, LookupParcelByApnErrors, GenerateReportData, GenerateReportResponses, GenerateReportErrors, GetAnswerFileData, GetAnswerFileResponses, GetAnswerFileErrors, GetFeesForNewLicenseData, GetFeesForNewLicenseResponses, GetFeesForNewLicenseErrors, GetFeesForRenewalData, GetFeesForRenewalResponses, GetFeesForRenewalErrors, GetFeesForPaymentData, GetFeesForPaymentResponses, GetFeesForPaymentErrors, UpdateInspectionData, UpdateInspectionResponses, UpdateInspectionErrors, UploadTempFileData, UploadTempFileResponses, UploadTempFileErrors, GetAttomForeclosureCaseDetailsData, GetAttomForeclosureCaseDetailsResponses, GetAttomForeclosureCaseDetailsErrors, FetchLiveLinkUrlData, FetchLiveLinkUrlResponses, FetchLiveLinkUrlErrors, SearchRegistrantsForImpersonationData, SearchRegistrantsForImpersonationResponses, SearchRegistrantsForImpersonationErrors, GetRegistrantAccountData, GetRegistrantAccountResponses, UpdateRegistrantAccountData, UpdateRegistrantAccountResponses, UpdateRegistrantAccountErrors, GetRegistrantAccountUsersData, GetRegistrantAccountUsersResponses, AddSecondaryUserData, AddSecondaryUserResponses, AddSecondaryUserErrors, GetRegistrantOrgPaymentAccountData, GetRegistrantOrgPaymentAccountResponses, UpdateRegistrantOrgPaymentAccountData, UpdateRegistrantOrgPaymentAccountResponses, UpdateRegistrantOrgPaymentAccountErrors, UpdateRegistrantAccountLoginIdentityAccountsContactData, UpdateRegistrantAccountLoginIdentityAccountsContactResponses, UpdateRegistrantAccountLoginIdentityAccountsContactErrors, UpdateRegistrantLoginIdentityInspectionAccessData, UpdateRegistrantLoginIdentityInspectionAccessResponses, UpdateRegistrantLoginIdentityInspectionAccessErrors, UpdateRegistrantAccountUserAccountsContactData, UpdateRegistrantAccountUserAccountsContactResponses, UpdateRegistrantAccountUserAccountsContactErrors, UpdateRegistrantAccountUserInspectionAccessData, UpdateRegistrantAccountUserInspectionAccessResponses, UpdateRegistrantAccountUserInspectionAccessErrors, GetRegistrantLicensesData, GetRegistrantLicensesResponses, GetRegistrantLicensesErrors, CreateLicenseData, CreateLicenseResponses, CreateLicenseErrors, ListActiveLicensesByPropertyData, ListActiveLicensesByPropertyResponses, ListActiveLicensesByPropertyErrors, GetRegistrantLicenseStatsData, GetRegistrantLicenseStatsResponses, GetRegistrantLicenseStatsErrors, GetRegistrantLicenseFilterValuesData, GetRegistrantLicenseFilterValuesResponses, GetRegistrantLicenseFilterValuesErrors, GetRegistrantLicenseJurisdictionOptionsData, GetRegistrantLicenseJurisdictionOptionsResponses, GetRegistrantLicenseJurisdictionOptionsErrors, GetRegistrantLicenseMapPinsData, GetRegistrantLicenseMapPinsResponses, GetRegistrantLicenseMapPinsErrors, ExportRegistrantLicensesData, ExportRegistrantLicensesResponses, ExportRegistrantLicensesErrors, GetRegistrantUnregisteredPropertiesData, GetRegistrantUnregisteredPropertiesResponses, GetRegistrantUnregisteredPropertiesErrors, GetLicenseCommentsData, GetLicenseCommentsResponses, GetLicenseCommentsErrors, CreateRegistrantLicenseCommentData, CreateRegistrantLicenseCommentResponses, CreateRegistrantLicenseCommentErrors, GetLicensePaymentsData, GetLicensePaymentsResponses, GetLicensePaymentsErrors, MakeLicensePaymentData, MakeLicensePaymentResponses, MakeLicensePaymentErrors, CreatePendingPaymentRecordsData, CreatePendingPaymentRecordsResponses, CreatePendingPaymentRecordsErrors, GetBulkPaymentFeesData, GetBulkPaymentFeesResponses, GetBulkPaymentFeesErrors, CreateBulkPendingPaymentRecordsData, CreateBulkPendingPaymentRecordsResponses, CreateBulkPendingPaymentRecordsErrors, MakeBulkLicensePaymentData, MakeBulkLicensePaymentResponses, MakeBulkLicensePaymentErrors, CreateBulkCheckPaymentData, CreateBulkCheckPaymentResponses, CreateBulkCheckPaymentErrors, CreateRegistrantCheckPaymentData, CreateRegistrantCheckPaymentResponses, CreateRegistrantCheckPaymentErrors, CreateBulkInvoicePaymentData, CreateBulkInvoicePaymentResponses, CreateBulkInvoicePaymentErrors, CreateRegistrantInvoicePaymentData, CreateRegistrantInvoicePaymentResponses, CreateRegistrantInvoicePaymentErrors, GetRegistrantPaymentsData, GetRegistrantPaymentsResponses, GetRegistrantInvoicesData, GetRegistrantInvoicesResponses, GetRegistrantPaymentProcessorPaymentDetailData, GetRegistrantPaymentProcessorPaymentDetailResponses, GetRegistrantPaymentProcessorPaymentDetailErrors, GetRegistrantPaymentDetailData, GetRegistrantPaymentDetailResponses, GetRegistrantPaymentDetailErrors, GetRegistrantInvoicePdfData, GetRegistrantInvoicePdfResponses, GetRegistrantInvoicePdfErrors, CancelRegistrantPaymentData, CancelRegistrantPaymentResponses, CancelRegistrantPaymentErrors, RenewLicenseData, RenewLicenseResponses, RenewLicenseErrors, GetStripeCheckoutSessionUrlData, GetStripeCheckoutSessionUrlResponses, GetStripeCheckoutSessionUrlErrors, GetLicenseFromCheckoutSessionData, GetLicenseFromCheckoutSessionResponses, GetLicenseFromCheckoutSessionErrors, AbandonStripeCheckoutSessionData, AbandonStripeCheckoutSessionResponses, AbandonStripeCheckoutSessionErrors, GetStripePortalUrlData, GetStripePortalUrlResponses, GetStripePortalUrlErrors, CancelSecondaryUserInviteData, CancelSecondaryUserInviteResponses, CancelSecondaryUserInviteErrors, GetRegistrantAccountUserData, GetRegistrantAccountUserResponses, GetRegistrantAccountUserErrors, UpdateRegistrantAccountUserData, UpdateRegistrantAccountUserResponses, UpdateRegistrantAccountUserErrors, DisableSecondaryUserData, DisableSecondaryUserResponses, DisableSecondaryUserErrors, ReenableSecondaryUserData, ReenableSecondaryUserResponses, ReenableSecondaryUserErrors, TransferPrimaryOwnershipData, TransferPrimaryOwnershipResponses, TransferPrimaryOwnershipErrors, UpdateRegistrantAccountUserAdminData, UpdateRegistrantAccountUserAdminResponses, UpdateRegistrantAccountUserAdminErrors, UpdateRegistrantAccountUserCanMakePaymentsData, UpdateRegistrantAccountUserCanMakePaymentsResponses, UpdateRegistrantAccountUserCanMakePaymentsErrors, GetPendingInviteInfoData, GetPendingInviteInfoResponses, AcceptPendingInviteData, AcceptPendingInviteResponses, RejectPendingInviteData, RejectPendingInviteResponses, UploadAnswerFileData, UploadAnswerFileResponses, UploadAnswerFileErrors, ListInspectionPortalLicensesData, ListInspectionPortalLicensesResponses, ListInspectionPortalLicensesErrors, ListInspectionDispatchLicensesData, ListInspectionDispatchLicensesResponses, ListInspectionOrgUsersData, ListInspectionOrgUsersResponses, ListInspectionOrgUsersErrors, ListInspectionImpersonationCandidatesData, ListInspectionImpersonationCandidatesResponses, ListInspectionImpersonationCandidatesErrors, BulkAssignInspectionsData, BulkAssignInspectionsResponses, BulkAssignInspectionsErrors, EnsureInspectionLicenseAccessData, EnsureInspectionLicenseAccessResponses, EnsureInspectionLicenseAccessErrors, UnassignInspectionData, UnassignInspectionResponses, UnassignInspectionErrors, InviteInspectionUserData, InviteInspectionUserResponses, InviteInspectionUserErrors, DisableInspectionUserData, DisableInspectionUserResponses, DisableInspectionUserErrors, UploadInspectionAnswerFileData, UploadInspectionAnswerFileResponses, UploadInspectionAnswerFileErrors, GetInspectionServerTimeData, GetInspectionServerTimeResponses, GetJurisdictionInspectionLogoKeyData, GetJurisdictionInspectionLogoKeyResponses, GetJurisdictionInspectionLogoKeyErrors, GetOmtAmsAccessData, GetOmtAmsAccessResponses, SearchOmtAmsPartiesForImpersonationData, SearchOmtAmsPartiesForImpersonationResponses, SearchOmtAmsPartiesForImpersonationErrors, GetOmtAmsAccountData, GetOmtAmsAccountResponses, GetOmtAmsLicensesData, GetOmtAmsLicensesResponses, GetOmtAmsLicensesErrors, GetOmtAmsLicenseStatsData, GetOmtAmsLicenseStatsResponses, GetOmtAmsLicenseStatsErrors, GetOmtAmsLicenseFilterValuesData, GetOmtAmsLicenseFilterValuesResponses, GetOmtAmsLicenseFilterValuesErrors, GetOmtAmsLicenseMapPinsData, GetOmtAmsLicenseMapPinsResponses, GetOmtAmsLicenseMapPinsErrors, GetOmtAmsLicenseCommentsData, GetOmtAmsLicenseCommentsResponses, GetOmtAmsLicenseCommentsErrors, GetOmtAmsLicensePaymentsData, GetOmtAmsLicensePaymentsResponses, GetOmtAmsLicensePaymentsErrors, GetOmtAmsInvoicesData, GetOmtAmsInvoicesResponses, GetOmtAmsAccountUsersData, GetOmtAmsAccountUsersResponses, AddOmtAmsSecondaryUserData, AddOmtAmsSecondaryUserResponses, AddOmtAmsSecondaryUserErrors, CancelOmtAmsSecondaryUserInviteData, CancelOmtAmsSecondaryUserInviteResponses, CancelOmtAmsSecondaryUserInviteErrors, DisableOmtAmsSecondaryUserData, DisableOmtAmsSecondaryUserResponses, DisableOmtAmsSecondaryUserErrors, ReenableOmtAmsSecondaryUserData, ReenableOmtAmsSecondaryUserResponses, ReenableOmtAmsSecondaryUserErrors, UpdateOmtAmsAccountUserAdminData, UpdateOmtAmsAccountUserAdminResponses, UpdateOmtAmsAccountUserAdminErrors, GetOmtAmsPendingInviteInfoData, GetOmtAmsPendingInviteInfoResponses, AcceptOmtAmsPendingInviteData, AcceptOmtAmsPendingInviteResponses, RejectOmtAmsPendingInviteData, RejectOmtAmsPendingInviteResponses, GetJurisdictionsData, GetJurisdictionsResponses, GetJurisdictionsErrors, CreateJurisdictionData, CreateJurisdictionResponses, CreateJurisdictionErrors, GetJurisdictionData, GetJurisdictionResponses, GetJurisdictionErrors, UpdateJurisdictionData, UpdateJurisdictionResponses, UpdateJurisdictionErrors, DryrunJurisdictionCreationData, DryrunJurisdictionCreationResponses, DryrunJurisdictionCreationErrors, CreateJurisdictionsData, CreateJurisdictionsResponses, CreateJurisdictionsErrors, UpdateJurisdictionThemeColorData, UpdateJurisdictionThemeColorResponses, UpdateJurisdictionThemeColorErrors, ClearJurisdictionLogoData, ClearJurisdictionLogoResponses, ClearJurisdictionLogoErrors, UploadJurisdictionLogoData, UploadJurisdictionLogoResponses, UploadJurisdictionLogoErrors, ListOperatorInspectionImpersonationCandidatesData, ListOperatorInspectionImpersonationCandidatesResponses, ListOperatorInspectionImpersonationCandidatesErrors, GetJurisdictionBrandingData, GetJurisdictionBrandingResponses, GetJurisdictionBrandingErrors, RefreshJurisdictionBrandingData, RefreshJurisdictionBrandingResponses, RefreshJurisdictionBrandingErrors, CreateOrdinanceVersionData, CreateOrdinanceVersionResponses, CreateOrdinanceVersionErrors, DeleteOrdinanceVersionData, DeleteOrdinanceVersionResponses, DeleteOrdinanceVersionErrors, UpdateOrdinanceVersionData, UpdateOrdinanceVersionResponses, UpdateOrdinanceVersionErrors, ExportOrdinancesCsvData, ExportOrdinancesCsvResponses, DryrunOrdinanceImportData, DryrunOrdinanceImportResponses, DryrunOrdinanceImportErrors, ApplyOrdinanceImportData, ApplyOrdinanceImportResponses, ApplyOrdinanceImportErrors, LookupJurisdictionByFipsCodeData, LookupJurisdictionByFipsCodeResponses, LookupJurisdictionByFipsCodeErrors, LookupJurisdictionByTigerCodeData, LookupJurisdictionByTigerCodeResponses, LookupJurisdictionByTigerCodeErrors, FuzzySearchJurisdictionsByNameData, FuzzySearchJurisdictionsByNameResponses, FuzzySearchJurisdictionsByNameErrors, OperatorGetRegistrantByEmailData, OperatorGetRegistrantByEmailResponses, OperatorGetRegistrantByEmailErrors, ListLicenseLinkCandidatesData, ListLicenseLinkCandidatesResponses, ListLicenseLinkCandidatesErrors, LinkLicenseData, LinkLicenseResponses, LinkLicenseErrors, OperatorCreateLicenseData, OperatorCreateLicenseResponses, OperatorCreateLicenseErrors, ListSavedImportMappingsData, ListSavedImportMappingsResponses, ListSavedImportMappingsErrors, CreateSavedImportMappingData, CreateSavedImportMappingResponses, CreateSavedImportMappingErrors, DeleteSavedImportMappingData, DeleteSavedImportMappingResponses, DeleteSavedImportMappingErrors, UpdateSavedImportMappingData, UpdateSavedImportMappingResponses, UpdateSavedImportMappingErrors, ApplySavedImportMappingData, ApplySavedImportMappingResponses, ApplySavedImportMappingErrors, GetTempFileHeadersAndRowCountsData, GetTempFileHeadersAndRowCountsResponses, GetTempFileHeadersAndRowCountsErrors, GetJurisdictionFieldMappingForTempFileData, GetJurisdictionFieldMappingForTempFileResponses, GetJurisdictionFieldMappingForTempFileErrors, GetOrdinanceFieldMappingForTempFileData, GetOrdinanceFieldMappingForTempFileResponses, GetOrdinanceFieldMappingForTempFileErrors, GetLicenseFieldMappingForTempFileData, GetLicenseFieldMappingForTempFileResponses, GetLicenseFieldMappingForTempFileErrors, GetGovernmentUserFieldMappingForTempFileData, GetGovernmentUserFieldMappingForTempFileResponses, GetGovernmentUserFieldMappingForTempFileErrors, DryrunGovernmentUserUpsertData, DryrunGovernmentUserUpsertResponses, DryrunGovernmentUserUpsertErrors, UpsertGovernmentUsersData, UpsertGovernmentUsersResponses, UpsertGovernmentUsersErrors, DryrunLicenseCreationData, DryrunLicenseCreationResponses, DryrunLicenseCreationErrors, CreateLicensesData, CreateLicensesResponses, CreateLicensesErrors, GetQuestionFieldMappingForTempFileData, GetQuestionFieldMappingForTempFileResponses, GetQuestionFieldMappingForTempFileErrors, GetQuestionGroupFieldMappingForTempFileData, GetQuestionGroupFieldMappingForTempFileResponses, GetQuestionGroupFieldMappingForTempFileErrors, DryrunQuestionCreationData, DryrunQuestionCreationResponses, DryrunQuestionCreationErrors, CreateQuestionsData, CreateQuestionsResponses, CreateQuestionsErrors, DryrunQuestionGroupCreationData, DryrunQuestionGroupCreationResponses, DryrunQuestionGroupCreationErrors, CreateQuestionGroupsData, CreateQuestionGroupsResponses, CreateQuestionGroupsErrors, GetPartyFieldMappingForTempFileData, GetPartyFieldMappingForTempFileResponses, GetPartyFieldMappingForTempFileErrors, DryrunPartyCreationData, DryrunPartyCreationResponses, DryrunPartyCreationErrors, CreatePartiesData, CreatePartiesResponses, CreatePartiesErrors, GetCaseNumberFieldMappingForTempFileData, GetCaseNumberFieldMappingForTempFileResponses, GetCaseNumberFieldMappingForTempFileErrors, DryrunCaseNumberImportData, DryrunCaseNumberImportResponses, DryrunCaseNumberImportErrors, ApplyCaseNumberImportData, ApplyCaseNumberImportResponses, ApplyCaseNumberImportErrors, PreviewBulkServiceTransferData, PreviewBulkServiceTransferResponses, PreviewBulkServiceTransferErrors, CommitBulkServiceTransferData, CommitBulkServiceTransferResponses, CommitBulkServiceTransferErrors, GetHeraConfigurationEndpointOperatorHeraConfigurationGetData, GetHeraConfigurationEndpointOperatorHeraConfigurationGetResponses, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutData, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutResponses, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutErrors, GetManualCheckPaymentsData, GetManualCheckPaymentsResponses, GetManualCheckPaymentsErrors, GetManualCheckPaymentDetailData, GetManualCheckPaymentDetailResponses, GetManualCheckPaymentDetailErrors, CancelManualCheckPaymentData, CancelManualCheckPaymentResponses, CancelManualCheckPaymentErrors, FinaliseManualCheckPaymentData, FinaliseManualCheckPaymentResponses, FinaliseManualCheckPaymentErrors, MarkManualCheckPaymentDepositedData, MarkManualCheckPaymentDepositedResponses, MarkManualCheckPaymentDepositedErrors, GetRefundAllocationsData, GetRefundAllocationsResponses, GetRefundAllocationsErrors, GetRefundAllocationDetailData, GetRefundAllocationDetailResponses, GetRefundAllocationDetailErrors, FinaliseRefundAllocationData, FinaliseRefundAllocationResponses, FinaliseRefundAllocationErrors, GetManualInvoicePaymentsData, GetManualInvoicePaymentsResponses, GetManualInvoicePaymentsErrors, GenerateOperatorInvoicesData, GenerateOperatorInvoicesResponses, GenerateOperatorInvoicesErrors, GetManualInvoicePaymentDetailData, GetManualInvoicePaymentDetailResponses, GetManualInvoicePaymentDetailErrors, GetManualInvoicePaymentPdfData, GetManualInvoicePaymentPdfResponses, GetManualInvoicePaymentPdfErrors, CancelManualInvoicePaymentData, CancelManualInvoicePaymentResponses, CancelManualInvoicePaymentErrors, FinaliseManualInvoicePaymentData, FinaliseManualInvoicePaymentResponses, FinaliseManualInvoicePaymentErrors, UpdateRegistrantLoginIdentityOperatorData, UpdateRegistrantLoginIdentityOperatorResponses, UpdateRegistrantLoginIdentityOperatorErrors, UpdateOperatorRegistrantAccountAccountsContactData, UpdateOperatorRegistrantAccountAccountsContactResponses, UpdateOperatorRegistrantAccountAccountsContactErrors, OperatorDisableRegistrantUserData, OperatorDisableRegistrantUserResponses, OperatorDisableRegistrantUserErrors, OperatorReenableRegistrantUserData, OperatorReenableRegistrantUserResponses, OperatorReenableRegistrantUserErrors, OperatorTransferPrimaryOwnershipData, OperatorTransferPrimaryOwnershipResponses, OperatorTransferPrimaryOwnershipErrors, OperatorAcceptPendingRegistrantInviteData, OperatorAcceptPendingRegistrantInviteResponses, OperatorAcceptPendingRegistrantInviteErrors, CreateLicenseTypeData, CreateLicenseTypeResponses, CreateLicenseTypeErrors, GetLicenseTypeData, GetLicenseTypeResponses, GetLicenseTypeErrors, UpdateLicenseTypeData, UpdateLicenseTypeResponses, UpdateLicenseTypeErrors, GetAffectedJurisdictionsCountData, GetAffectedJurisdictionsCountResponses, GetAffectedJurisdictionsCountErrors, CascadeJurisdictionStatusData, CascadeJurisdictionStatusResponses, CascadeJurisdictionStatusErrors, GetAllTemplateDocumentsStatusData, GetAllTemplateDocumentsStatusResponses, GetAllTemplateDocumentsStatusErrors, DeleteTemplateDocumentEndpointData, DeleteTemplateDocumentEndpointResponses, DeleteTemplateDocumentEndpointErrors, CreateTemplateDocumentEndpointData, CreateTemplateDocumentEndpointResponses, CreateTemplateDocumentEndpointErrors, GetAllJurisdictionDocumentsStatusData, GetAllJurisdictionDocumentsStatusResponses, GetAllJurisdictionDocumentsStatusErrors, GetJurisdictionConfigurationQuestionGroupsData, GetJurisdictionConfigurationQuestionGroupsResponses, GetJurisdictionConfigurationQuestionGroupsErrors, UpdateJurisdictionConfigurationQuestionGroupsData, UpdateJurisdictionConfigurationQuestionGroupsResponses, UpdateJurisdictionConfigurationQuestionGroupsErrors, DeleteJurisdictionDocumentEndpointData, DeleteJurisdictionDocumentEndpointResponses, DeleteJurisdictionDocumentEndpointErrors, CreateJurisdictionDocumentEndpointData, CreateJurisdictionDocumentEndpointResponses, CreateJurisdictionDocumentEndpointErrors, GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetData, GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetResponses, GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetErrors, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostResponses, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostErrors, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteData, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteResponses, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteErrors, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchData, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchResponses, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchErrors, GetQuestionGroupJurisdictionsData, GetQuestionGroupJurisdictionsResponses, GetQuestionGroupJurisdictionsErrors, UpdateQuestionGroupJurisdictionsData, UpdateQuestionGroupJurisdictionsResponses, UpdateQuestionGroupJurisdictionsErrors, GetOperatorLicenseFeeAnalysisData, GetOperatorLicenseFeeAnalysisResponses, GetOperatorLicenseFeeAnalysisErrors, GetOperatorRevenueAuditData, GetOperatorRevenueAuditResponses, GetOperatorRevenueAuditErrors, GetOperatorRevenueAuditStripeCashData, GetOperatorRevenueAuditStripeCashResponses, GetOperatorRevenueAuditStripeCashErrors, GetOperatorPortalKpisData, GetOperatorPortalKpisResponses, GetOperatorPortalKpisErrors, GetOperatorPortalPaymentPeriodsData, GetOperatorPortalPaymentPeriodsResponses, GetOperatorPortalPaymentPeriodsErrors, GetOperatorPortalTrendsData, GetOperatorPortalTrendsResponses, GetOperatorPortalTrendsErrors, GetOperatorSystemUsageData, GetOperatorSystemUsageResponses, GetOperatorSystemUsageErrors, GetOperatorSystemUsageDetailData, GetOperatorSystemUsageDetailResponses, GetOperatorSystemUsageDetailErrors, GetOperatorPortalForeclosureVsRegistrationsData, GetOperatorPortalForeclosureVsRegistrationsResponses, GetOperatorPortalForeclosureVsRegistrationsErrors, GetOperatorPortalNotifiedRenewalsData, GetOperatorPortalNotifiedRenewalsResponses, GetOperatorPortalNotifiedRenewalsErrors, GetOperatorPortalNeedsAttentionComplianceData, GetOperatorPortalNeedsAttentionComplianceResponses, GetOperatorPortalNeedsAttentionComplianceErrors, GetOperatorPortalComplianceTrendsData, GetOperatorPortalComplianceTrendsResponses, GetOperatorPortalComplianceTrendsErrors, StreamOperatorPortalTrendRegistrationsData, StreamOperatorPortalTrendRegistrationsResponses, StreamOperatorPortalTrendRegistrationsErrors, StreamOperatorPortalTrendInspectionsData, StreamOperatorPortalTrendInspectionsResponses, StreamOperatorPortalTrendInspectionsErrors, StreamOperatorPortalTrendPaymentsData, StreamOperatorPortalTrendPaymentsResponses, StreamOperatorPortalTrendPaymentsErrors, StreamOperatorPortalTrendInspectionFeesData, StreamOperatorPortalTrendInspectionFeesResponses, StreamOperatorPortalTrendInspectionFeesErrors, StreamOperatorPortalTrendRefundsData, StreamOperatorPortalTrendRefundsResponses, StreamOperatorPortalTrendRefundsErrors, StreamOperatorPortalTrendRemittanceData, StreamOperatorPortalTrendRemittanceResponses, StreamOperatorPortalTrendRemittanceErrors, StreamOperatorPortalForecastData, StreamOperatorPortalForecastResponses, StreamOperatorPortalForecastErrors, GetOperatorPortalPaymentLagData, GetOperatorPortalPaymentLagResponses, GetOperatorPortalPaymentLagErrors, GetOperatorPortalActivityData, GetOperatorPortalActivityResponses, GetOperatorPortalActivityErrors, GetOperatorHubspotScorecardData, GetOperatorHubspotScorecardResponses, GetOperatorHubspotClosedDealsByWeekData, GetOperatorHubspotClosedDealsByWeekResponses, GetOperatorLeadershipRenewalComplianceData, GetOperatorLeadershipRenewalComplianceResponses, GetOperatorLeadershipReceivablesOverdueData, GetOperatorLeadershipReceivablesOverdueResponses, GetOperatorLeadershipRegistrationsRenewalsInitiatedData, GetOperatorLeadershipRegistrationsRenewalsInitiatedResponses, GetOperatorLeadershipHeraRemittanceData, GetOperatorLeadershipHeraRemittanceResponses, GetInfoSystemJurisdictionSummariesData, GetInfoSystemJurisdictionSummariesResponses, GetInfoSystemLicensesData, GetInfoSystemLicensesResponses, GetInfoSystemLicensesErrors, GetAttomTaxAssessorStatusData, GetAttomTaxAssessorStatusResponses, GetAttomTaxAssessorStatusErrors, GetAttomIntegrationStatusData, GetAttomIntegrationStatusResponses, GetNextForeclosureLenderPromptData, GetNextForeclosureLenderPromptResponses, GetNextForeclosureLenderPromptErrors, SubmitForeclosureInstigatorLabelData, SubmitForeclosureInstigatorLabelResponses, SubmitForeclosureInstigatorLabelErrors, UndoForeclosureInstigatorLabelData, UndoForeclosureInstigatorLabelResponses, GetForeclosureInstigatorMetricsData, GetForeclosureInstigatorMetricsResponses, SetForeclosureInstigatorGoldData, SetForeclosureInstigatorGoldResponses, SetForeclosureInstigatorGoldErrors, AdjudicateForeclosureInstigatorData, AdjudicateForeclosureInstigatorResponses, AdjudicateForeclosureInstigatorErrors, GetOperatorForeclosureCasesData, GetOperatorForeclosureCasesResponses, GetOperatorForeclosureCasesErrors, GetOperatorForeclosureCaseFilterValuesData, GetOperatorForeclosureCaseFilterValuesResponses, GetOperatorForeclosureCaseFilterValuesErrors, GetOperatorForeclosureCaseMapPinsData, GetOperatorForeclosureCaseMapPinsResponses, GetOperatorForeclosureCaseMapPinsErrors, GetOperatorForeclosureReviewStatusSummaryData, GetOperatorForeclosureReviewStatusSummaryResponses, GetOperatorForeclosureCaseChartDataData, GetOperatorForeclosureCaseChartDataResponses, GetOperatorForeclosureCaseChartDataErrors, SuggestOperatorForeclosureCasePartiesData, SuggestOperatorForeclosureCasePartiesResponses, SuggestOperatorForeclosureCasePartiesErrors, SuggestOperatorForeclosureCaseReviewData, SuggestOperatorForeclosureCaseReviewResponses, SuggestOperatorForeclosureCaseReviewErrors, GetOperatorForeclosureLicenseAssignmentCandidatesData, GetOperatorForeclosureLicenseAssignmentCandidatesResponses, GetOperatorForeclosureLicenseAssignmentCandidatesErrors, AssignOperatorForeclosureLicensesData, AssignOperatorForeclosureLicensesResponses, AssignOperatorForeclosureLicensesErrors, GetOperatorForeclosureLicenseMatchesData, GetOperatorForeclosureLicenseMatchesResponses, GetOperatorForeclosureLicenseMatchesErrors, LinkOperatorForeclosureCaseToLicenseData, LinkOperatorForeclosureCaseToLicenseResponses, LinkOperatorForeclosureCaseToLicenseErrors, UpdateOperatorForeclosureCaseReviewData, UpdateOperatorForeclosureCaseReviewResponses, UpdateOperatorForeclosureCaseReviewErrors, GetOperatorForeclosureCaseReviewHistoryData, GetOperatorForeclosureCaseReviewHistoryResponses, GetOperatorForeclosureCaseReviewHistoryErrors, PreflightOperatorBulkCreateUnregisteredData, PreflightOperatorBulkCreateUnregisteredResponses, PreflightOperatorBulkCreateUnregisteredErrors, BulkCreateOperatorUnregisteredFromCasesData, BulkCreateOperatorUnregisteredFromCasesResponses, BulkCreateOperatorUnregisteredFromCasesErrors, GetOperatorForeclosureUnregisteredMatchData, GetOperatorForeclosureUnregisteredMatchResponses, GetOperatorForeclosureUnregisteredMatchErrors, LinkOperatorForeclosureCaseToUnregisteredData, LinkOperatorForeclosureCaseToUnregisteredResponses, LinkOperatorForeclosureCaseToUnregisteredErrors, OperatorAddressResolutionLookupData, OperatorAddressResolutionLookupResponses, OperatorAddressResolutionLookupErrors, OperatorAddressResolutionSaveData, OperatorAddressResolutionSaveResponses, OperatorAddressResolutionSaveErrors, GetResidentialOwnerAccessData, GetResidentialOwnerAccessResponses, ListResidentialOwnerJurisdictionsData, ListResidentialOwnerJurisdictionsResponses, ListResidentialOwnerMailingAddressesData, ListResidentialOwnerMailingAddressesResponses, ListResidentialOwnerMailingAddressesErrors, GetResidentialOwnerMailingAddressData, GetResidentialOwnerMailingAddressResponses, GetResidentialOwnerMailingAddressErrors, UpdateResidentialOwnerMailingAddressData, UpdateResidentialOwnerMailingAddressResponses, UpdateResidentialOwnerMailingAddressErrors, UnlinkResidentialOwnerMailingAddressData, UnlinkResidentialOwnerMailingAddressResponses, UnlinkResidentialOwnerMailingAddressErrors, LinkResidentialOwnerMailingAddressesData, LinkResidentialOwnerMailingAddressesResponses, LinkResidentialOwnerMailingAddressesErrors, ListResidentialOwnerCompaniesData, ListResidentialOwnerCompaniesResponses, ListResidentialOwnerCompaniesErrors, GetResidentialOwnerCompanyData, GetResidentialOwnerCompanyResponses, GetResidentialOwnerCompanyErrors, UpdateResidentialOwnerCompanyData, UpdateResidentialOwnerCompanyResponses, UpdateResidentialOwnerCompanyErrors, GetResidentialOwnerMailingAddressHistoryData, GetResidentialOwnerMailingAddressHistoryResponses, GetResidentialOwnerMailingAddressHistoryErrors, ConfirmResidentialOwnerCompanyFieldsData, ConfirmResidentialOwnerCompanyFieldsResponses, ConfirmResidentialOwnerCompanyFieldsErrors, RejectResidentialOwnerCompanyFieldsData, RejectResidentialOwnerCompanyFieldsResponses, RejectResidentialOwnerCompanyFieldsErrors, MergeResidentialOwnerCompaniesData, MergeResidentialOwnerCompaniesResponses, MergeResidentialOwnerCompaniesErrors, EnqueueResidentialOwnerRefreshData, EnqueueResidentialOwnerRefreshResponses, EnqueueResidentialOwnerRefreshErrors, EnqueueResidentialOwnerEnrichmentData, EnqueueResidentialOwnerEnrichmentResponses, EnqueueResidentialOwnerEnrichmentErrors, ListResidentialOwnerJobsData, ListResidentialOwnerJobsResponses, ListResidentialOwnerJobsErrors, CancelResidentialOwnerJobData, CancelResidentialOwnerJobResponses, CancelResidentialOwnerJobErrors, GetLatestResidentialOwnerRefreshRunData, GetLatestResidentialOwnerRefreshRunResponses, GetLatestResidentialOwnerRefreshRunErrors, ListCompanyQuestionTabsData, ListCompanyQuestionTabsResponses, ListCompanyQuestionAnswersData, ListCompanyQuestionAnswersResponses, ListCompanyQuestionAnswersErrors, RewriteCompanyQuestionAnswersData, RewriteCompanyQuestionAnswersResponses, RewriteCompanyQuestionAnswersErrors, GetStrListingsData, GetStrListingsResponses, GetStrListingsErrors, GetStrListingFilterValuesData, GetStrListingFilterValuesResponses, GetStrListingFilterValuesErrors, GetStrListingMapPinsData, GetStrListingMapPinsResponses, GetStrListingMapPinsErrors, GetStrPropertiesData, GetStrPropertiesResponses, GetStrPropertiesErrors, GetStrPropertyFilterValuesData, GetStrPropertyFilterValuesResponses, GetStrPropertyFilterValuesErrors, GetStrPropertyMapPinsData, GetStrPropertyMapPinsResponses, GetStrPropertyMapPinsErrors, GetStrPropertyDetailData, GetStrPropertyDetailResponses, GetStrPropertyDetailErrors, GetNextStrAddressMappingData, GetNextStrAddressMappingResponses, GetNextStrAddressMappingErrors, GetStrAddressMappingCitiesData, GetStrAddressMappingCitiesResponses, GetStrAddressMappingTargetData, GetStrAddressMappingTargetResponses, GetStrAddressMappingTargetErrors, ConfirmStrAddressMappingData, ConfirmStrAddressMappingResponses, ConfirmStrAddressMappingErrors, LookupStrAttomParcelData, LookupStrAttomParcelResponses, LookupStrAttomParcelErrors, SkipStrAddressMappingData, SkipStrAddressMappingResponses, SkipStrAddressMappingErrors, UndoStrAddressMappingData, UndoStrAddressMappingResponses, GetStrAddressMappingNearbyData, GetStrAddressMappingNearbyResponses, GetStrAddressMappingNearbyErrors, SuggestStrUnitClassificationsData, SuggestStrUnitClassificationsResponses, SuggestStrUnitClassificationsErrors, SetStrListingUnitCategoryData, SetStrListingUnitCategoryResponses, SetStrListingUnitCategoryErrors, SetStrPropertyUnitCategoryData, SetStrPropertyUnitCategoryResponses, SetStrPropertyUnitCategoryErrors, GetNextStrDedupPairData, GetNextStrDedupPairResponses, GetNextStrDedupPairErrors, SubmitStrDedupLabelData, SubmitStrDedupLabelResponses, SubmitStrDedupLabelErrors, UndoStrDedupLabelData, UndoStrDedupLabelResponses, LookupStrDedupListingData, LookupStrDedupListingResponses, LookupStrDedupListingErrors, LoadManualStrDedupPairData, LoadManualStrDedupPairResponses, LoadManualStrDedupPairErrors, GetStrDedupMetricsData, GetStrDedupMetricsResponses, ListGovernmentStrPropertiesData, ListGovernmentStrPropertiesResponses, ListGovernmentStrPropertiesErrors, GetGovernmentStrPropertyFilterValuesData, GetGovernmentStrPropertyFilterValuesResponses, GetGovernmentStrPropertyFilterValuesErrors, ListGovernmentStrPropertyPinsData, ListGovernmentStrPropertyPinsResponses, ListGovernmentStrPropertyPinsErrors, GetGovernmentStrPropertyData, GetGovernmentStrPropertyResponses, GetGovernmentStrPropertyErrors, SearchGovernmentUsersForImpersonationData, SearchGovernmentUsersForImpersonationResponses, SearchGovernmentUsersForImpersonationErrors, GetGovernmentImpersonationMeData, GetGovernmentImpersonationMeResponses, GetGovernmentJurisdictionData, GetGovernmentJurisdictionResponses, GetGovernmentJurisdictionErrors, GetGovernmentLicenseTypeConfigurationsData, GetGovernmentLicenseTypeConfigurationsResponses, GetGovernmentLicenseTypeConfigurationsErrors, CreateGovernmentOrdinanceVersionData, CreateGovernmentOrdinanceVersionResponses, CreateGovernmentOrdinanceVersionErrors, DeleteGovernmentOrdinanceVersionData, DeleteGovernmentOrdinanceVersionResponses, DeleteGovernmentOrdinanceVersionErrors, UpdateGovernmentOrdinanceVersionData, UpdateGovernmentOrdinanceVersionResponses, UpdateGovernmentOrdinanceVersionErrors, ExportGovernmentOrdinancesCsvData, ExportGovernmentOrdinancesCsvResponses, DryrunGovernmentOrdinanceImportData, DryrunGovernmentOrdinanceImportResponses, DryrunGovernmentOrdinanceImportErrors, ApplyGovernmentOrdinanceImportData, ApplyGovernmentOrdinanceImportResponses, ApplyGovernmentOrdinanceImportErrors, ListGovernmentSavedImportMappingsData, ListGovernmentSavedImportMappingsResponses, ListGovernmentSavedImportMappingsErrors, CreateGovernmentSavedImportMappingData, CreateGovernmentSavedImportMappingResponses, CreateGovernmentSavedImportMappingErrors, GetGovernmentOrdinanceFieldMappingForTempFileData, GetGovernmentOrdinanceFieldMappingForTempFileResponses, GetGovernmentOrdinanceFieldMappingForTempFileErrors, GetGovernmentPortalKpisData, GetGovernmentPortalKpisResponses, GetGovernmentPortalKpisErrors, GetGovernmentPortalTrendsData, GetGovernmentPortalTrendsResponses, GetGovernmentPortalTrendsErrors, GetGovernmentPortalForeclosureVsRegistrationsData, GetGovernmentPortalForeclosureVsRegistrationsResponses, GetGovernmentPortalForeclosureVsRegistrationsErrors, GetGovernmentPortalNotifiedRenewalsData, GetGovernmentPortalNotifiedRenewalsResponses, GetGovernmentPortalNotifiedRenewalsErrors, GetGovernmentPortalComplianceTrendsData, GetGovernmentPortalComplianceTrendsResponses, GetGovernmentPortalComplianceTrendsErrors, StreamGovernmentPortalTrendRegistrationsData, StreamGovernmentPortalTrendRegistrationsResponses, StreamGovernmentPortalTrendRegistrationsErrors, StreamGovernmentPortalTrendInspectionsData, StreamGovernmentPortalTrendInspectionsResponses, StreamGovernmentPortalTrendInspectionsErrors, StreamGovernmentPortalTrendPaymentsData, StreamGovernmentPortalTrendPaymentsResponses, StreamGovernmentPortalTrendPaymentsErrors, StreamGovernmentPortalTrendInspectionFeesData, StreamGovernmentPortalTrendInspectionFeesResponses, StreamGovernmentPortalTrendInspectionFeesErrors, StreamGovernmentPortalTrendRefundsData, StreamGovernmentPortalTrendRefundsResponses, StreamGovernmentPortalTrendRefundsErrors, StreamGovernmentPortalTrendRemittanceData, StreamGovernmentPortalTrendRemittanceResponses, StreamGovernmentPortalTrendRemittanceErrors, GetGovernmentPortalPaymentLagData, GetGovernmentPortalPaymentLagResponses, GetGovernmentPortalPaymentLagErrors, GetGovernmentPortalActivityData, GetGovernmentPortalActivityResponses, GetGovernmentPortalActivityErrors, UpdateRegistrantLoginIdentityGovernmentData, UpdateRegistrantLoginIdentityGovernmentResponses, UpdateRegistrantLoginIdentityGovernmentErrors, UpdateGovernmentRegistrantAccountAccountsContactData, UpdateGovernmentRegistrantAccountAccountsContactResponses, UpdateGovernmentRegistrantAccountAccountsContactErrors, GetGovernmentForeclosureCasesData, GetGovernmentForeclosureCasesResponses, GetGovernmentForeclosureCasesErrors, GetGovernmentForeclosureCaseFilterValuesData, GetGovernmentForeclosureCaseFilterValuesResponses, GetGovernmentForeclosureCaseFilterValuesErrors, GetGovernmentForeclosureCaseMapPinsData, GetGovernmentForeclosureCaseMapPinsResponses, GetGovernmentForeclosureCaseMapPinsErrors, GetGovernmentForeclosureCaseChartDataData, GetGovernmentForeclosureCaseChartDataResponses, SuggestGovernmentForeclosureCasePartiesData, SuggestGovernmentForeclosureCasePartiesResponses, SuggestGovernmentForeclosureCasePartiesErrors, SuggestGovernmentForeclosureCaseReviewData, SuggestGovernmentForeclosureCaseReviewResponses, SuggestGovernmentForeclosureCaseReviewErrors, GetGovernmentForeclosureLicenseAssignmentCandidatesData, GetGovernmentForeclosureLicenseAssignmentCandidatesResponses, GetGovernmentForeclosureLicenseAssignmentCandidatesErrors, AssignGovernmentForeclosureLicensesData, AssignGovernmentForeclosureLicensesResponses, AssignGovernmentForeclosureLicensesErrors, GetGovernmentForeclosureLicenseMatchesData, GetGovernmentForeclosureLicenseMatchesResponses, GetGovernmentForeclosureLicenseMatchesErrors, LinkGovernmentForeclosureCaseToLicenseData, LinkGovernmentForeclosureCaseToLicenseResponses, LinkGovernmentForeclosureCaseToLicenseErrors, UpdateGovernmentForeclosureCaseReviewData, UpdateGovernmentForeclosureCaseReviewResponses, UpdateGovernmentForeclosureCaseReviewErrors, GetGovernmentForeclosureCaseReviewHistoryData, GetGovernmentForeclosureCaseReviewHistoryResponses, GetGovernmentForeclosureCaseReviewHistoryErrors, PreflightGovernmentBulkCreateUnregisteredData, PreflightGovernmentBulkCreateUnregisteredResponses, PreflightGovernmentBulkCreateUnregisteredErrors, BulkCreateGovernmentUnregisteredFromCasesData, BulkCreateGovernmentUnregisteredFromCasesResponses, BulkCreateGovernmentUnregisteredFromCasesErrors, GetGovernmentForeclosureUnregisteredMatchData, GetGovernmentForeclosureUnregisteredMatchResponses, GetGovernmentForeclosureUnregisteredMatchErrors, LinkGovernmentForeclosureCaseToUnregisteredData, LinkGovernmentForeclosureCaseToUnregisteredResponses, LinkGovernmentForeclosureCaseToUnregisteredErrors, GetUnregisteredPropertiesData, GetUnregisteredPropertiesResponses, GetUnregisteredPropertiesErrors, CreateUnregisteredPropertyData, CreateUnregisteredPropertyResponses, CreateUnregisteredPropertyErrors, DeleteUnregisteredPropertyData, DeleteUnregisteredPropertyResponses, DeleteUnregisteredPropertyErrors, GetUnregisteredPropertyData, GetUnregisteredPropertyResponses, GetUnregisteredPropertyErrors, UpdateUnregisteredPropertyData, UpdateUnregisteredPropertyResponses, UpdateUnregisteredPropertyErrors, ListUnregisteredSavedImportMappingsData, ListUnregisteredSavedImportMappingsResponses, CreateUnregisteredSavedImportMappingData, CreateUnregisteredSavedImportMappingResponses, CreateUnregisteredSavedImportMappingErrors, DeleteUnregisteredSavedImportMappingData, DeleteUnregisteredSavedImportMappingResponses, DeleteUnregisteredSavedImportMappingErrors, UpdateUnregisteredSavedImportMappingData, UpdateUnregisteredSavedImportMappingResponses, UpdateUnregisteredSavedImportMappingErrors, ApplyUnregisteredSavedImportMappingData, ApplyUnregisteredSavedImportMappingResponses, ApplyUnregisteredSavedImportMappingErrors, GetUnregisteredFieldMappingForTempFileData, GetUnregisteredFieldMappingForTempFileResponses, GetUnregisteredFieldMappingForTempFileErrors, DryrunUnregisteredCreationData, DryrunUnregisteredCreationResponses, DryrunUnregisteredCreationErrors, CreateUnregisteredPropertiesData, CreateUnregisteredPropertiesResponses, CreateUnregisteredPropertiesErrors, GetUnregisteredCommentsData, GetUnregisteredCommentsResponses, GetUnregisteredCommentsErrors, CreateUnregisteredCommentData, CreateUnregisteredCommentResponses, CreateUnregisteredCommentErrors, CheckApnRegisteredData, CheckApnRegisteredResponses, CheckApnRegisteredErrors, GetTitleAccountData, GetTitleAccountResponses, UpdateTitleAccountData, UpdateTitleAccountResponses, UpdateTitleAccountErrors, GetTitleAccountUsersData, GetTitleAccountUsersResponses, GetTitleAccountUsersErrors, AddTitleAccountUserData, AddTitleAccountUserResponses, AddTitleAccountUserErrors, CancelTitleAccountInviteData, CancelTitleAccountInviteResponses, CancelTitleAccountInviteErrors, DisableTitleAccountUserData, DisableTitleAccountUserResponses, DisableTitleAccountUserErrors, ReenableTitleAccountUserData, ReenableTitleAccountUserResponses, ReenableTitleAccountUserErrors, MakeTitleAccountPrimaryData, MakeTitleAccountPrimaryResponses, MakeTitleAccountPrimaryErrors, UpdateTitleAccountUserAdminData, UpdateTitleAccountUserAdminResponses, UpdateTitleAccountUserAdminErrors, GetTitlePendingInviteData, GetTitlePendingInviteResponses, AcceptTitlePendingInviteData, AcceptTitlePendingInviteResponses, RejectTitlePendingInviteData, RejectTitlePendingInviteResponses, SearchTitleAccountsForImpersonationData, SearchTitleAccountsForImpersonationResponses, SearchTitleAccountsForImpersonationErrors, SearchOperatorTitleAccountsData, SearchOperatorTitleAccountsResponses, SearchOperatorTitleAccountsErrors, CreateOperatorTitleAccountData, CreateOperatorTitleAccountResponses, CreateOperatorTitleAccountErrors, LookupTitleRequestAddressData, LookupTitleRequestAddressResponses, LookupTitleRequestAddressErrors, CreateTitleRequestData, CreateTitleRequestResponses, CreateTitleRequestErrors, ClaimTitleRequestData, ClaimTitleRequestResponses, ClaimTitleRequestErrors, ListMyTitleRequestsData, ListMyTitleRequestsResponses, GetMyTitleRequestData, GetMyTitleRequestResponses, GetMyTitleRequestErrors, AddMyTitleRequestCommentData, AddMyTitleRequestCommentResponses, AddMyTitleRequestCommentErrors, RequestFurtherTitleReviewData, RequestFurtherTitleReviewResponses, RequestFurtherTitleReviewErrors, CancelMyTitleRequestData, CancelMyTitleRequestResponses, CancelMyTitleRequestErrors, GetMyTitleRequestAttachmentData, GetMyTitleRequestAttachmentResponses, GetMyTitleRequestAttachmentErrors, ListOperatorTitleRequestsData, ListOperatorTitleRequestsResponses, GetOperatorTitleRequestData, GetOperatorTitleRequestResponses, GetOperatorTitleRequestErrors, UpdateOperatorTitleRequestData, UpdateOperatorTitleRequestResponses, UpdateOperatorTitleRequestErrors, CancelOperatorTitleRequestData, CancelOperatorTitleRequestResponses, CancelOperatorTitleRequestErrors, AddOperatorTitleRequestCommentData, AddOperatorTitleRequestCommentResponses, AddOperatorTitleRequestCommentErrors, SendTitleRequestPropertyCompliantData, SendTitleRequestPropertyCompliantResponses, SendTitleRequestPropertyCompliantErrors, DraftTitleRequestPropertyNonCompliantData, DraftTitleRequestPropertyNonCompliantResponses, DraftTitleRequestPropertyNonCompliantErrors, SendTitleRequestPropertyNonCompliantData, SendTitleRequestPropertyNonCompliantResponses, SendTitleRequestPropertyNonCompliantErrors, GetOperatorTitleRequestAttachmentData, GetOperatorTitleRequestAttachmentResponses, GetOperatorTitleRequestAttachmentErrors, ListPublicCommunitiesData, ListPublicCommunitiesResponses, ListPublicRegistrationCommunitiesData, ListPublicRegistrationCommunitiesResponses, ListPublicRegistrationCommunitiesErrors, GetPublicJurisdictionData, GetPublicJurisdictionResponses, GetPublicJurisdictionErrors, ListPublicLicenseTypesData, ListPublicLicenseTypesResponses, GetPublicHeraConfigurationData, GetPublicHeraConfigurationResponses, ListPublicJurisdictionPagesData, ListPublicJurisdictionPagesResponses, GetPublicJurisdictionPageData, GetPublicJurisdictionPageResponses, GetPublicJurisdictionPageErrors, GetPublicJurisdictionPageLogoData, GetPublicJurisdictionPageLogoResponses, GetPublicJurisdictionPageLogoErrors, GetPublicDemoPlaceSealData, GetPublicDemoPlaceSealResponses, GetPublicDemoPlaceSealErrors, ListPublicDemoStateTopPlacesData, ListPublicDemoStateTopPlacesResponses, ListPublicDemoStateTopPlacesErrors, ListPublicDemoHeraCustomersHeatmapData, ListPublicDemoHeraCustomersHeatmapResponses, ListPublicDemoHeraCustomersHeatmapErrors, ResolvePublicDemoPlaceData, ResolvePublicDemoPlaceResponses, ResolvePublicDemoPlaceErrors, ResolvePublicDemoPlaceAtData, ResolvePublicDemoPlaceAtResponses, ResolvePublicDemoPlaceAtErrors, GetPublicDemoPlaceSummaryData, GetPublicDemoPlaceSummaryResponses, GetPublicDemoPlaceSummaryErrors, GetPublicDemoPlaceHubSpotCompanyData, GetPublicDemoPlaceHubSpotCompanyResponses, GetPublicDemoPlaceHubSpotCompanyErrors, CreatePublicDemoPlaceHubSpotCompanyData, CreatePublicDemoPlaceHubSpotCompanyResponses, CreatePublicDemoPlaceHubSpotCompanyErrors, GetPublicDemoPlaceEventsData, GetPublicDemoPlaceEventsResponses, GetPublicDemoPlaceEventsErrors, GetPublicDemoPlaceBoundaryData, GetPublicDemoPlaceBoundaryResponses, GetPublicDemoPlaceBoundaryErrors, EmailPublicDemoPlaceSummaryData, EmailPublicDemoPlaceSummaryResponses, EmailPublicDemoPlaceSummaryErrors, ListJurisdictionRegionsData, ListJurisdictionRegionsResponses, ListJurisdictionRegionsErrors, CreateJurisdictionRegionData, CreateJurisdictionRegionResponses, CreateJurisdictionRegionErrors, GetJurisdictionRegionBoundaryData, GetJurisdictionRegionBoundaryResponses, GetJurisdictionRegionBoundaryErrors, PreviewJurisdictionRegionUploadData, PreviewJurisdictionRegionUploadResponses, PreviewJurisdictionRegionUploadErrors, CommitJurisdictionRegionUploadData, CommitJurisdictionRegionUploadResponses, CommitJurisdictionRegionUploadErrors, PromptJurisdictionRegionsData, PromptJurisdictionRegionsResponses, PromptJurisdictionRegionsErrors, CommandJurisdictionRegionsData, CommandJurisdictionRegionsResponses, CommandJurisdictionRegionsErrors, DownloadRegionDraftShapefileData, DownloadRegionDraftShapefileResponses, DownloadRegionDraftShapefileErrors, DeleteJurisdictionRegionData, DeleteJurisdictionRegionResponses, DeleteJurisdictionRegionErrors, UpdateJurisdictionRegionData, UpdateJurisdictionRegionResponses, UpdateJurisdictionRegionErrors, DownloadJurisdictionRegionShapefileData, DownloadJurisdictionRegionShapefileResponses, DownloadJurisdictionRegionShapefileErrors, CheckHealthData, CheckHealthResponses, CheckHealthErrors, OnAuth0LoginData, OnAuth0LoginResponses, OnAuth0LoginErrors, OnStripeEventData, OnStripeEventResponses, OnStripeEventErrors, OnHubSpotCompanyEventData, OnHubSpotCompanyEventResponses, ListHubSpotCompanyGeofipsOptionsData, ListHubSpotCompanyGeofipsOptionsResponses, ListHubSpotCompanyGeofipsOptionsErrors, SelectHubSpotCompanyGeofipsData, SelectHubSpotCompanyGeofipsResponses, SelectHubSpotCompanyGeofipsErrors, OnHubSpotContactEventData, OnHubSpotContactEventResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Auth0 Email Verification Status Endpoint
 * Get the email verification status for the Auth0 user.
 */
export const getAuth0EmailVerificationStatus = <ThrowOnError extends boolean = false>(options?: Options<GetAuth0EmailVerificationStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAuth0EmailVerificationStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/auth0/email_verification_status',
        ...options
    });
};

/**
 * Resend Auth0 Verification Email Endpoint
 * Resend the verification email for the Auth0 user.
 */
export const resendAuth0VerificationEmail = <ThrowOnError extends boolean = false>(options?: Options<ResendAuth0VerificationEmailData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ResendAuth0VerificationEmailResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/auth0/resend_verification_email',
        ...options
    });
};

/**
 * Generate Auth0 Password Reset Url Endpoint
 * Generate a password reset URL for the Auth0 user.
 */
export const generatePasswordResetUrl = <ThrowOnError extends boolean = false>(options?: Options<GeneratePasswordResetUrlData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GeneratePasswordResetUrlResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/auth0/password_reset_url',
        ...options
    });
};

/**
 * Get Check Mailing Address Endpoint
 * Get the HERA address for mailing checks (used in check payment instructions).
 */
export const getCheckMailingAddress = <ThrowOnError extends boolean = false>(options?: Options<GetCheckMailingAddressData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCheckMailingAddressResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/check-mailing-address',
        ...options
    });
};

/**
 * Get License Types Endpoint
 * Get all license types.
 */
export const getLicenseTypes = <ThrowOnError extends boolean = false>(options?: Options<GetLicenseTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetLicenseTypesResponses, GetLicenseTypesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/license_types',
        ...options
    });
};

/**
 * Get Fee Structure Friendly Names Endpoint
 * Return display names (and optional hints) for every registration/inspection fee structure.
 */
export const getFeeStructureFriendlyNames = <ThrowOnError extends boolean = false>(options?: Options<GetFeeStructureFriendlyNamesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetFeeStructureFriendlyNamesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/enum_friendly_names/fee_structure',
        ...options
    });
};

/**
 * Get License Type Questions Endpoint
 * Get all questions for a license type.
 */
export const getLicenseTypeQuestions = <ThrowOnError extends boolean = false>(options: Options<GetLicenseTypeQuestionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseTypeQuestionsResponses, GetLicenseTypeQuestionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/license_types/{license_type_id}/jurisdictions/{jurisdiction_id}/questions',
        ...options
    });
};

/**
 * Get License Type Configuration Endpoint
 * Returns a list of available license periods for a given license type, jurisdiction and initial date.
 *
 * This is used by the registrant flow to fetch the questions to display during registration.
 */
export const getLicenseTypeConfiguration = <ThrowOnError extends boolean = false>(options: Options<GetLicenseTypeConfigurationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseTypeConfigurationResponses, GetLicenseTypeConfigurationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/license_types/{license_type_id}/jurisdictions/{jurisdiction_id}/configuration',
        ...options
    });
};

/**
 * Get Licenses Endpoint
 * Return one page of non-registrant licenses as JSON.
 */
export const getNonRegistrantLicenses = <ThrowOnError extends boolean = false>(options?: Options<GetNonRegistrantLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNonRegistrantLicensesResponses, GetNonRegistrantLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses',
        ...options
    });
};

/**
 * Get License Stats Endpoint
 * Dashboard tile aggregates for the non-deleted, header-scoped set.
 */
export const getNonRegistrantLicenseStats = <ThrowOnError extends boolean = false>(options?: Options<GetNonRegistrantLicenseStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNonRegistrantLicenseStatsResponses, GetNonRegistrantLicenseStatsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/stats',
        ...options
    });
};

/**
 * Get License Filter Values Endpoint
 * Distinct display strings for one list column's filter popover.
 */
export const getNonRegistrantLicenseFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetNonRegistrantLicenseFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNonRegistrantLicenseFilterValuesResponses, GetNonRegistrantLicenseFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/filter-values',
        ...options
    });
};

/**
 * Get License Map Pins Endpoint
 * Pins or clusters for matching licenses that have coordinates.
 */
export const getNonRegistrantLicenseMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetNonRegistrantLicenseMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNonRegistrantLicenseMapPinsResponses, GetNonRegistrantLicenseMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/map-pins',
        ...options
    });
};

/**
 * Export Licenses Endpoint
 * All licenses matching the current list filters/sort (not just one page).
 */
export const exportNonRegistrantLicenses = <ThrowOnError extends boolean = false>(options?: Options<ExportNonRegistrantLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExportNonRegistrantLicensesResponses, ExportNonRegistrantLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/export',
        ...options
    });
};

/**
 * Get License List Question Columns Endpoint
 * List question-backed columns for the non-registrant licenses list.
 *
 * Columns come from questions flagged "show in list" (per field for
 * contact-shaped questions). Each license list row carries the matching
 * values in ``question_column_values``.
 */
export const getNonRegistrantLicenseListQuestionColumns = <ThrowOnError extends boolean = false>(options?: Options<GetNonRegistrantLicenseListQuestionColumnsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNonRegistrantLicenseListQuestionColumnsResponses, GetNonRegistrantLicenseListQuestionColumnsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/question-columns',
        ...options
    });
};

/**
 * Get Non Registrant Registrant Accounts Endpoint
 * List all registrant accounts for operator and government portals.
 *
 * Jurisdiction filtering is intentionally not applied. Registrant pickers and
 * the registrants list must include accounts that have not yet licensed in a
 * given jurisdiction. ``jurisdiction_ids`` is accepted for API compatibility
 * but ignored.
 *
 * ``primaries_only`` limits the list to primary contacts: accounts that are
 * not secondary members and not pending an organization invite.
 */
export const getNonRegistrantRegistrantAccounts = <ThrowOnError extends boolean = false>(options?: Options<GetNonRegistrantRegistrantAccountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNonRegistrantRegistrantAccountsResponses, GetNonRegistrantRegistrantAccountsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/registrant_accounts',
        ...options
    });
};

/**
 * Search Registrant Accounts Endpoint
 * Search registrant accounts by email, name, or company for operator pickers.
 *
 * Lives on the shared router so the operator portal can call it with an
 * operator-audience token. The registrant-router equivalent only accepts
 * registrant-audience tokens and 401s from the operator portal.
 */
export const searchRegistrantAccounts = <ThrowOnError extends boolean = false>(options?: Options<SearchRegistrantAccountsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SearchRegistrantAccountsResponses, SearchRegistrantAccountsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/registrant_accounts/search',
        ...options
    });
};

/**
 * Get Non Registrant Registrant Account Endpoint
 * Get a single registrant account by id. Government users only if account has a license in their jurisdiction.
 */
export const getNonRegistrantRegistrantAccount = <ThrowOnError extends boolean = false>(options: Options<GetNonRegistrantRegistrantAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNonRegistrantRegistrantAccountResponses, GetNonRegistrantRegistrantAccountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/registrant_accounts/{registrant_account_id}',
        ...options
    });
};

/**
 * Get Non Registrant Registrant Account Login Identities Endpoint
 * Portal login identities for the registrant org (invoice / accounts-contact toggles).
 */
export const getNonRegistrantRegistrantAccountLoginIdentities = <ThrowOnError extends boolean = false>(options: Options<GetNonRegistrantRegistrantAccountLoginIdentitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNonRegistrantRegistrantAccountLoginIdentitiesResponses, GetNonRegistrantRegistrantAccountLoginIdentitiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/registrant_accounts/{registrant_account_id}/login-identities',
        ...options
    });
};

/**
 * Get Non Registrant Organizations Endpoint
 * List organizations (primary accounts that have at least one secondary). Government see only those in their jurisdiction.
 */
export const getNonRegistrantOrganizations = <ThrowOnError extends boolean = false>(options?: Options<GetNonRegistrantOrganizationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNonRegistrantOrganizationsResponses, GetNonRegistrantOrganizationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/organizations',
        ...options
    });
};

/**
 * Get Non Registrant Organization Endpoint
 * Get organization detail: primary account and all registrants (primary + secondaries).
 */
export const getNonRegistrantOrganization = <ThrowOnError extends boolean = false>(options: Options<GetNonRegistrantOrganizationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNonRegistrantOrganizationResponses, GetNonRegistrantOrganizationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/organizations/{organization_id}',
        ...options
    });
};

/**
 * Get Inspections Endpoint
 * Get all inspections, optionally filtered by jurisdiction.
 */
export const getInspections = <ThrowOnError extends boolean = false>(options?: Options<GetInspectionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetInspectionsResponses, GetInspectionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/inspections',
        ...options
    });
};

/**
 * Get License Details Endpoint
 * Get the details of a registrant's license.
 */
export const getLicenseDetails = <ThrowOnError extends boolean = false>(options: Options<GetLicenseDetailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseDetailsResponses, GetLicenseDetailsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}',
        ...options
    });
};

/**
 * Update License Endpoint
 * Update a license.
 */
export const updateLicense = <ThrowOnError extends boolean = false>(options: Options<UpdateLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateLicenseResponses, UpdateLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get License History Endpoint
 * Return who changed what on a license, from the database audit log.
 */
export const getLicenseHistory = <ThrowOnError extends boolean = false>(options: Options<GetLicenseHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseHistoryResponses, GetLicenseHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/history',
        ...options
    });
};

/**
 * Get License Question Answer History Endpoint
 * Return typed additional-question changes visible to the current user.
 */
export const getLicenseQuestionAnswerHistory = <ThrowOnError extends boolean = false>(options: Options<GetLicenseQuestionAnswerHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseQuestionAnswerHistoryResponses, GetLicenseQuestionAnswerHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/question-answer-history',
        ...options
    });
};

/**
 * List License Notification Emails Endpoint
 * List sent upcoming-renewal and needs-attention emails for this license.
 */
export const listLicenseNotificationEmails = <ThrowOnError extends boolean = false>(options: Options<ListLicenseNotificationEmailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListLicenseNotificationEmailsResponses, ListLicenseNotificationEmailsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/notification-emails',
        ...options
    });
};

/**
 * Get License Notification Email Endpoint
 * Return the stored body of a notification email linked to this license.
 */
export const getLicenseNotificationEmail = <ThrowOnError extends boolean = false>(options: Options<GetLicenseNotificationEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseNotificationEmailResponses, GetLicenseNotificationEmailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/notification-emails/{email_id}',
        ...options
    });
};

/**
 * Update License Additional Questions Endpoint
 * Update registration additional questions (e.g. NAC) for a license.
 *
 * Registrants, operators, and government users may call this when they have
 * license access (same rules as get license details). Operators previously
 * hit the registrant-only route and failed JWT audience validation.
 */
export const updateLicenseAdditionalQuestions = <ThrowOnError extends boolean = false>(options: Options<UpdateLicenseAdditionalQuestionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateLicenseAdditionalQuestionsResponses, UpdateLicenseAdditionalQuestionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/additional_questions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update License Registrant Endpoint
 * Correct the registrant assigned to a license without transferring it.
 */
export const updateLicenseRegistrant = <ThrowOnError extends boolean = false>(options: Options<UpdateLicenseRegistrantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateLicenseRegistrantResponses, UpdateLicenseRegistrantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/registrant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Derive License From Payments Endpoint
 * Derive renewal, approval, and status fields from payment history.
 */
export const deriveLicenseFromPayments = <ThrowOnError extends boolean = false>(options: Options<DeriveLicenseFromPaymentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DeriveLicenseFromPaymentsResponses, DeriveLicenseFromPaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/derive-from-payments',
        ...options
    });
};

/**
 * Approve License Endpoint
 * Approve a license.
 */
export const approveLicense = <ThrowOnError extends boolean = false>(options: Options<ApproveLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveLicenseResponses, ApproveLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/approvals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create License Modification Request Endpoint
 * Stage a change without updating the certificate until it is approved.
 */
export const createLicenseModificationRequest = <ThrowOnError extends boolean = false>(options: Options<CreateLicenseModificationRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLicenseModificationRequestResponses, CreateLicenseModificationRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/modification-requests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Approve License Modification Request Endpoint
 * Copy the staged answers onto the license and refresh the certificate.
 */
export const approveLicenseModificationRequest = <ThrowOnError extends boolean = false>(options: Options<ApproveLicenseModificationRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveLicenseModificationRequestResponses, ApproveLicenseModificationRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/modification-requests/{request_id}/approvals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Deny License Modification Request Endpoint
 * Leave the certificate unchanged and tell the registrant it is still valid.
 */
export const denyLicenseModificationRequest = <ThrowOnError extends boolean = false>(options: Options<DenyLicenseModificationRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DenyLicenseModificationRequestResponses, DenyLicenseModificationRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/modification-requests/{request_id}/denials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cancel License Endpoint
 * Cancel a license.
 */
export const cancelLicense = <ThrowOnError extends boolean = false>(options: Options<CancelLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelLicenseResponses, CancelLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/cancelations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get License Deregistration Questions Endpoint
 * Get deregistration questions for a license (for the deregistration flow).
 */
export const getLicenseDeregistrationQuestions = <ThrowOnError extends boolean = false>(options: Options<GetLicenseDeregistrationQuestionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseDeregistrationQuestionsResponses, GetLicenseDeregistrationQuestionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/deregistration-questions',
        ...options
    });
};

/**
 * Start Deregister License Endpoint
 * Start deregistration: set effective end date and answers, create $25 fee; user then pays.
 */
export const startDeregisterLicense = <ThrowOnError extends boolean = false>(options: Options<StartDeregisterLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StartDeregisterLicenseResponses, StartDeregisterLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/deregister',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get License Comments Endpoint
 * Get all comments for a license.
 */
export const getNonRegistrantLicenseComments = <ThrowOnError extends boolean = false>(options: Options<GetNonRegistrantLicenseCommentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNonRegistrantLicenseCommentsResponses, GetNonRegistrantLicenseCommentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/comments',
        ...options
    });
};

/**
 * Create License Comment Endpoint
 * Create a comment for a license.
 */
export const createLicenseComment = <ThrowOnError extends boolean = false>(options: Options<CreateLicenseCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLicenseCommentResponses, CreateLicenseCommentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resolve Registry Notification Endpoint
 * Clear a registrant notify-Hera comment without changing license status.
 */
export const resolveRegistryNotification = <ThrowOnError extends boolean = false>(options: Options<ResolveRegistryNotificationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResolveRegistryNotificationResponses, ResolveRegistryNotificationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/comments/{comment_id}/resolve-registry-notification',
        ...options
    });
};

/**
 * Flag Compliance Issue Endpoint
 * Flag a compliance issue. License status is unchanged.
 */
export const flagComplianceIssue = <ThrowOnError extends boolean = false>(options: Options<FlagComplianceIssueData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FlagComplianceIssueResponses, FlagComplianceIssueErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/compliance-issues',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clear Compliance Issue Endpoint
 * Clear the active compliance issue when this party type raised it.
 */
export const clearComplianceIssue = <ThrowOnError extends boolean = false>(options: Options<ClearComplianceIssueData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClearComplianceIssueResponses, ClearComplianceIssueErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/compliance-issues/clear',
        ...options
    });
};

/**
 * Upload Shared Answer File Endpoint
 * Upload a comment or answer file and return its storage token.
 */
export const uploadSharedAnswerFile = <ThrowOnError extends boolean = false>(options: Options<UploadSharedAnswerFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadSharedAnswerFileResponses, UploadSharedAnswerFileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/answer_files/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Delete License Comment Endpoint
 * Delete a comment for a license.
 */
export const deleteLicenseComment = <ThrowOnError extends boolean = false>(options: Options<DeleteLicenseCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteLicenseCommentResponses, DeleteLicenseCommentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/comments/{comment_id}',
        ...options
    });
};

/**
 * Get License Payments Endpoint
 * Get the payments for a license.
 */
export const getNonRegistrantLicensePayments = <ThrowOnError extends boolean = false>(options: Options<GetNonRegistrantLicensePaymentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetNonRegistrantLicensePaymentsResponses, GetNonRegistrantLicensePaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/payments',
        ...options
    });
};

/**
 * Make Shared License Payment Endpoint
 * Make payment for a license (shared endpoint for all user types).
 */
export const makeSharedLicensePayment = <ThrowOnError extends boolean = false>(options: Options<MakeSharedLicensePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MakeSharedLicensePaymentResponses, MakeSharedLicensePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Payment Receipt Template Available Endpoint
 * True when a usable global license-type receipt template exists in Drive and a parent folder is available.
 *
 * Soft-deleted (deregistered / cancelled) licenses are included so the Payments
 * card can still offer receipt download.
 *
 * Soft-deleted global template rows are ignored; the linked Drive file must be a non-trashed Google Doc
 * the service account can read.
 *
 * The parent folder for generated receipts is ``HERA__GOOGLE_DRIVE__DOCS_FOLDER_ID`` when set;
 * otherwise the jurisdiction's configured folder when set; otherwise the global templates folder
 * (``HERA__GOOGLE_DRIVE__TEMPLATES_FOLDER_ID``).
 */
export const getPaymentReceiptTemplateAvailable = <ThrowOnError extends boolean = false>(options: Options<GetPaymentReceiptTemplateAvailableData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPaymentReceiptTemplateAvailableResponses, GetPaymentReceiptTemplateAvailableErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/payment-receipt-template-available',
        ...options
    });
};

/**
 * Get Registration Certificate Template Available Endpoint
 * True when a usable global registration certificate template exists and a Drive output folder is available.
 *
 * Soft-deleted (deregistered / cancelled) licenses are included so the certificate
 * download remains available on inactive registration details.
 */
export const getRegistrationCertificateTemplateAvailable = <ThrowOnError extends boolean = false>(options: Options<GetRegistrationCertificateTemplateAvailableData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRegistrationCertificateTemplateAvailableResponses, GetRegistrationCertificateTemplateAvailableErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/registration-certificate-template-available',
        ...options
    });
};

/**
 * Get License Registration Certificate Pdf Endpoint
 * Generate or refresh a filled registration certificate (Google Doc template) and return the PDF.
 *
 * Google Drive stores the filled Doc/PDF as ``registration-certificate-{license_id}``.
 * The browser download name is the property address when available.
 * Soft-deleted (deregistered / cancelled) licenses are included.
 */
export const getLicenseRegistrationCertificatePdf = <ThrowOnError extends boolean = false>(options: Options<GetLicenseRegistrationCertificatePdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseRegistrationCertificatePdfResponses, GetLicenseRegistrationCertificatePdfErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/registration-certificate',
        ...options
    });
};

/**
 * Get License Payment Receipt Options Endpoint
 * Tell the client whether this transaction spans multiple properties.
 */
export const getLicensePaymentReceiptOptions = <ThrowOnError extends boolean = false>(options: Options<GetLicensePaymentReceiptOptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicensePaymentReceiptOptionsResponses, GetLicensePaymentReceiptOptionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/payments/{payment_id}/receipt-options',
        ...options
    });
};

/**
 * Get License Payment Receipt Pdf Endpoint
 * Generate or reuse a filled payment receipt and return the PDF (download filename set).
 */
export const getLicensePaymentReceiptPdf = <ThrowOnError extends boolean = false>(options: Options<GetLicensePaymentReceiptPdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicensePaymentReceiptPdfResponses, GetLicensePaymentReceiptPdfErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/payments/{payment_id}/receipt',
        ...options
    });
};

/**
 * Get Inspection Payment Receipt Pdf Endpoint
 * Return PDF receipt for an inspection payment (combined with license fees when paid together).
 */
export const getInspectionPaymentReceiptPdf = <ThrowOnError extends boolean = false>(options: Options<GetInspectionPaymentReceiptPdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInspectionPaymentReceiptPdfResponses, GetInspectionPaymentReceiptPdfErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/inspection-payments/{inspection_payment_id}/receipt',
        ...options
    });
};

/**
 * Reject License Endpoint
 * Reject a license.
 */
export const rejectLicense = <ThrowOnError extends boolean = false>(options: Options<RejectLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RejectLicenseResponses, RejectLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/rejections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Preview License Transfer Endpoint
 * Preview path/fee outcomes for a service transfer without writing.
 */
export const previewLicenseTransfer = <ThrowOnError extends boolean = false>(options: Options<PreviewLicenseTransferData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PreviewLicenseTransferResponses, PreviewLicenseTransferErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/transfers/preview',
        ...options
    });
};

/**
 * Transfer License Endpoint
 * Service-transfer a license: create linked successor and close the prior row.
 */
export const transferLicense = <ThrowOnError extends boolean = false>(options: Options<TransferLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TransferLicenseResponses, TransferLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/transfers',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Manual Payment Endpoint
 * Create a manual payment for a license.
 */
export const createManualPayment = <ThrowOnError extends boolean = false>(options: Options<CreateManualPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateManualPaymentResponses, CreateManualPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/manual_payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Manual Payment Available Periods Endpoint
 * Get the available periods for a manual payment for a license.
 */
export const getManualPaymentAvailablePeriods = <ThrowOnError extends boolean = false>(options: Options<GetManualPaymentAvailablePeriodsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetManualPaymentAvailablePeriodsResponses, GetManualPaymentAvailablePeriodsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/manual_payments/available_periods',
        ...options
    });
};

/**
 * Update License Payment Period Endpoint
 * Update period start and end dates on any license payment, including card payments.
 */
export const updateLicensePaymentPeriod = <ThrowOnError extends boolean = false>(options: Options<UpdateLicensePaymentPeriodData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateLicensePaymentPeriodResponses, UpdateLicensePaymentPeriodErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/payments/{payment_id}/period',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Manual Payment Endpoint
 * Delete a manual payment for a license.
 */
export const deleteManualPayment = <ThrowOnError extends boolean = false>(options: Options<DeleteManualPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteManualPaymentResponses, DeleteManualPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/manual_payments/{payment_id}',
        ...options
    });
};

/**
 * Update Manual Payment Endpoint
 * Update a manual payment for a license.
 */
export const updateManualPayment = <ThrowOnError extends boolean = false>(options: Options<UpdateManualPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateManualPaymentResponses, UpdateManualPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/licenses/{license_id}/manual_payments/{payment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Admin Users Endpoint
 * Get all admin users.
 */
export const getAdminUsers = <ThrowOnError extends boolean = false>(options?: Options<GetAdminUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAdminUsersResponses, GetAdminUsersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/users',
        ...options
    });
};

/**
 * Create Admin User Endpoint
 * Create an admin user.
 */
export const createAdminUser = <ThrowOnError extends boolean = false>(options: Options<CreateAdminUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAdminUserResponses, CreateAdminUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Access Endpoint
 * Return Admin and Sales for the operator identified by the access token.
 *
 * Sales Commission Admin uses this. Matching the Auth0 email claim against the
 * user directory misses operators whose stored email differs, and a
 * jurisdiction-scoped directory omits operators entirely.
 */
export const getOperatorAccess = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorAccessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorAccessResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/operator/access',
        ...options
    });
};

/**
 * Get Admin User Endpoint
 * Get an admin user.
 */
export const getAdminUser = <ThrowOnError extends boolean = false>(options: Options<GetAdminUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAdminUserResponses, GetAdminUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/users/{user_id}',
        ...options
    });
};

/**
 * Update Admin User Endpoint
 * Update an admin user.
 */
export const updateAdminUser = <ThrowOnError extends boolean = false>(options: Options<UpdateAdminUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateAdminUserResponses, UpdateAdminUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/users/{user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get All Questions Endpoint
 * Get all questions.
 *
 * Operators can see all questions. Government users can see all global questions
 * and jurisdiction-specific questions for their own jurisdiction.
 */
export const getAllLicenseTypeQuestions = <ThrowOnError extends boolean = false>(options?: Options<GetAllLicenseTypeQuestionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllLicenseTypeQuestionsResponses, GetAllLicenseTypeQuestionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/questions',
        ...options
    });
};

/**
 * Create Question Endpoint
 * Create a question.
 */
export const createLicenseTypeQuestion = <ThrowOnError extends boolean = false>(options: Options<CreateLicenseTypeQuestionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLicenseTypeQuestionResponses, CreateLicenseTypeQuestionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/questions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Question Endpoint
 * Get a single license question.
 */
export const getLicenseTypeQuestion = <ThrowOnError extends boolean = false>(options: Options<GetLicenseTypeQuestionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseTypeQuestionResponses, GetLicenseTypeQuestionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/questions/{question_scope}/{question_id}',
        ...options
    });
};

/**
 * Update Question Endpoint
 * Update a question.
 */
export const updateLicenseTypeQuestion = <ThrowOnError extends boolean = false>(options: Options<UpdateLicenseTypeQuestionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateLicenseTypeQuestionResponses, UpdateLicenseTypeQuestionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/questions/{question_scope}/{question_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Parties Endpoint
 * List party records, optionally including soft-deleted.
 *
 * Secondaries and pending invitees are omitted: OMT/AMS selection always
 * uses primary accounts.
 */
export const getParties = <ThrowOnError extends boolean = false>(options?: Options<GetPartiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPartiesResponses, GetPartiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/parties',
        ...options
    });
};

/**
 * Create Party Endpoint
 * Create a party record.
 */
export const createParty = <ThrowOnError extends boolean = false>(options: Options<CreatePartyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePartyResponses, CreatePartyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/parties',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Party Endpoint
 * Get a single party record.
 */
export const getParty = <ThrowOnError extends boolean = false>(options: Options<GetPartyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPartyResponses, GetPartyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/parties/{party_id}',
        ...options
    });
};

/**
 * Update Party Endpoint
 * Update a party record (including soft delete/restore).
 */
export const updateParty = <ThrowOnError extends boolean = false>(options: Options<UpdatePartyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdatePartyResponses, UpdatePartyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/parties/{party_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Previous Property Managers Endpoint
 * Company contacts already used on other registrations in the same account.
 *
 * Registrants are limited to their own confirmed account network. Operators
 * may request any account. Government users, and operators viewing as
 * government, may request an account only when that account has a license
 * in their jurisdiction.
 */
export const getPreviousPropertyManagers = <ThrowOnError extends boolean = false>(options?: Options<GetPreviousPropertyManagersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPreviousPropertyManagersResponses, GetPreviousPropertyManagersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/previous_property_managers',
        ...options
    });
};

/**
 * List Question Options Endpoint
 * List question options, optionally filtered by question_id or party_id.
 *
 * Registrants may only list by question_id (for fixed-list name/address/contact
 * questions during registration); they cannot filter by party_id or include deleted.
 */
export const getQuestionOptions = <ThrowOnError extends boolean = false>(options?: Options<GetQuestionOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetQuestionOptionsResponses, GetQuestionOptionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/question_options',
        ...options
    });
};

/**
 * Create Question Option Endpoint
 * Create a question option (link a question to a party for auto-complete).
 */
export const createQuestionOption = <ThrowOnError extends boolean = false>(options: Options<CreateQuestionOptionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateQuestionOptionResponses, CreateQuestionOptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/question_options',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Question Option Endpoint
 * Get a single question option.
 */
export const getQuestionOption = <ThrowOnError extends boolean = false>(options: Options<GetQuestionOptionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetQuestionOptionResponses, GetQuestionOptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/question_options/{option_id}',
        ...options
    });
};

/**
 * Update Question Option Endpoint
 * Update a question option (e.g. soft delete).
 */
export const updateQuestionOption = <ThrowOnError extends boolean = false>(options: Options<UpdateQuestionOptionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateQuestionOptionResponses, UpdateQuestionOptionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/question_options/{option_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Property Lookup Endpoint
 * Lookup a property by address.
 */
export const lookupParcelByAddress = <ThrowOnError extends boolean = false>(options: Options<LookupParcelByAddressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LookupParcelByAddressResponses, LookupParcelByAddressErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/parcel_lookups/address',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Apn Lookup Endpoint
 * Lookup a property by APN.
 */
export const lookupParcelByApn = <ThrowOnError extends boolean = false>(options: Options<LookupParcelByApnData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LookupParcelByApnResponses, LookupParcelByApnErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/parcel_lookups/apn',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate Report
 * Generate a government report.
 */
export const generateReport = <ThrowOnError extends boolean = false>(options: Options<GenerateReportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateReportResponses, GenerateReportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/reports',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Answer File Endpoint
 * Get an answer file by token.
 *
 * Comment attachments are limited to users who can access that license.
 * Other answer files stay available to any authenticated portal user.
 */
export const getAnswerFile = <ThrowOnError extends boolean = false>(options: Options<GetAnswerFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAnswerFileResponses, GetAnswerFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/answer_files/{token}',
        ...options
    });
};

/**
 * Get Fees For New License Endpoint
 * Returns a list of periods and fees for a new license.
 */
export const getFeesForNewLicense = <ThrowOnError extends boolean = false>(options: Options<GetFeesForNewLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFeesForNewLicenseResponses, GetFeesForNewLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/fees/new_license/{license_type_id}/{jurisdiction_id}',
        ...options
    });
};

/**
 * Get Fees For Renewal Endpoint
 * Returns a list of periods and fees for a license renewal.
 *
 * Only returns periods with outstanding balances (fee > 0 or late_fee > 0).
 * This includes all periods with payments (including current period) as well as
 * future payable periods that still have amounts due.
 *
 * For renewal and reapply flows, fee-affecting answers can be provided to
 * recalculate fees before they are saved on the license. Omitted answers are
 * read from the license instead of being treated as unanswered, so callers that
 * only want the license's current fees (e.g. the period compliance card) match
 * what the fee engine charges.
 */
export const getFeesForRenewal = <ThrowOnError extends boolean = false>(options: Options<GetFeesForRenewalData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFeesForRenewalResponses, GetFeesForRenewalErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/fees/renewals/{license_id}',
        ...options
    });
};

/**
 * Get Fees For Payment Endpoint
 * Returns a list of periods and fees for a license payment.
 *
 * This endpoint is called by the Pay Now button and only returns historical
 * unpaid periods (periods before renewal_date), not renewal periods.
 * Also deletes any existing pending payment records to ensure a clean slate
 * for the complete payment screen.
 */
export const getFeesForPayment = <ThrowOnError extends boolean = false>(options: Options<GetFeesForPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFeesForPaymentResponses, GetFeesForPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/fees/payments/{license_id}',
        ...options
    });
};

/**
 * Update Inspection Endpoint
 * Update an inspection (reassign, complete, etc.).
 */
export const updateInspection = <ThrowOnError extends boolean = false>(options: Options<UpdateInspectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateInspectionResponses, UpdateInspectionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/inspections/{inspection_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upload Temp File Endpoint
 * Upload a temp file, save it, and return a token identifying the file.
 */
export const uploadTempFile = <ThrowOnError extends boolean = false>(options: Options<UploadTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadTempFileResponses, UploadTempFileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/tempfiles/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get Attom Foreclosure Case Details Endpoint
 * Look up ATTOM foreclosure case summary and foreclosure/recorder documents.
 */
export const getAttomForeclosureCaseDetails = <ThrowOnError extends boolean = false>(options: Options<GetAttomForeclosureCaseDetailsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAttomForeclosureCaseDetailsResponses, GetAttomForeclosureCaseDetailsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/attom/foreclosure-case-details',
        ...options
    });
};

/**
 * Fetch Live Link Url Endpoint
 * Proxy a Live Link POST encrypt/fetch URL and return its JSON body.
 *
 * Browser clients cannot call third-party clerk endpoints directly (CORS), so
 * authenticated Hera users resolve POST live links through this endpoint.
 */
export const fetchLiveLinkUrl = <ThrowOnError extends boolean = false>(options: Options<FetchLiveLinkUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FetchLiveLinkUrlResponses, FetchLiveLinkUrlErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/shared/live-link/fetch',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Search Registrants For Impersonation Endpoint
 * Search registrant accounts by email, name, or company (operators only).
 */
export const searchRegistrantsForImpersonation = <ThrowOnError extends boolean = false>(options?: Options<SearchRegistrantsForImpersonationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SearchRegistrantsForImpersonationResponses, SearchRegistrantsForImpersonationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/impersonation/search-registrants',
        ...options
    });
};

/**
 * Get Registrant Account Endpoint
 * Get the registrant account.
 *
 * For secondary accounts, also includes primary account name and company_name.
 */
export const getRegistrantAccount = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantAccountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account',
        ...options
    });
};

/**
 * Update Registrant Account Endpoint
 * Update the registrant account.
 */
export const updateRegistrantAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountResponses, UpdateRegistrantAccountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Registrant Account Users Endpoint
 * Get all users (primary and secondary) for the registrant account.
 *
 * If the logged-in account is a secondary account (has primary_id set), returns
 * all users linked to that primary account. Otherwise, returns all users linked
 * to the logged-in account.
 *
 * Returns the primary account and all secondary accounts where primary_id
 * or primary_id_pending equals the primary account ID.
 * Accounts with primary_id_pending but not primary_id have status "pending".
 */
export const getRegistrantAccountUsers = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantAccountUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantAccountUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users',
        ...options
    });
};

/**
 * Add Secondary User Endpoint
 * Add a secondary user to the registrant account by email address.
 *
 * Creates a new secondary account if one doesn't exist, or updates the existing
 * account's primary_id_pending to link it to the current account. The user will
 * be     asked to confirm the link when they next log in.
 */
export const addSecondaryUser = <ThrowOnError extends boolean = false>(options: Options<AddSecondaryUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddSecondaryUserResponses, AddSecondaryUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Registrant Org Payment Account Endpoint
 * Return the effective company Stripe billing account and eligible members.
 */
export const getRegistrantOrgPaymentAccount = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantOrgPaymentAccountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantOrgPaymentAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/payment-account',
        ...options
    });
};

/**
 * Update Registrant Org Payment Account Endpoint
 * Set the single company Stripe billing account.
 */
export const updateRegistrantOrgPaymentAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantOrgPaymentAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantOrgPaymentAccountResponses, UpdateRegistrantOrgPaymentAccountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/payment-account',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Account Login Identity Accounts Contact Endpoint
 * Set accounts-contact for a portal login in this registrant org.
 */
export const updateRegistrantAccountLoginIdentityAccountsContact = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountLoginIdentityAccountsContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountLoginIdentityAccountsContactResponses, UpdateRegistrantAccountLoginIdentityAccountsContactErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/login-identities/{login_identity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Login Identity Inspection Access Endpoint
 * Toggle registrant-portal access and all-inspections access for an org user.
 *
 * Primary accounts cannot turn off their own registrant portal access.
 * Primary dual-portal identities are always forced to ALL inspections.
 */
export const updateRegistrantLoginIdentityInspectionAccess = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantLoginIdentityInspectionAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantLoginIdentityInspectionAccessResponses, UpdateRegistrantLoginIdentityInspectionAccessErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/login-identities/{login_identity_id}/inspection-access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Account User Accounts Contact Endpoint
 * Set invoice / accounts-contact for a network user (portal login and/or pre-login).
 */
export const updateRegistrantAccountUserAccountsContact = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountUserAccountsContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountUserAccountsContactResponses, UpdateRegistrantAccountUserAccountsContactErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/accounts-contact',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Account User Inspection Access Endpoint
 * Set portal access for a network user (portal logins and/or pre-login).
 */
export const updateRegistrantAccountUserInspectionAccess = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountUserInspectionAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountUserInspectionAccessResponses, UpdateRegistrantAccountUserInspectionAccessErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/inspection-access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Registrant Licenses Endpoint
 * Get one page of the registrant's licenses.
 */
export const getRegistrantLicenses = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantLicensesResponses, GetRegistrantLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses',
        ...options
    });
};

/**
 * Create License Endpoint
 * Create a new registrant license, or transfer from an existing active license.
 */
export const createLicense = <ThrowOnError extends boolean = false>(options: Options<CreateLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLicenseResponses, CreateLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Active Licenses By Property Endpoint
 * List transferable licenses matching a registrant's property details.
 */
export const listActiveLicensesByProperty = <ThrowOnError extends boolean = false>(options: Options<ListActiveLicensesByPropertyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListActiveLicensesByPropertyResponses, ListActiveLicensesByPropertyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/active-by-property',
        ...options
    });
};

/**
 * Get Registrant License Stats Endpoint
 * Registrant dashboard tile aggregates (header scope only).
 */
export const getRegistrantLicenseStats = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantLicenseStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantLicenseStatsResponses, GetRegistrantLicenseStatsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/stats',
        ...options
    });
};

/**
 * Get Registrant License Filter Values Endpoint
 * Distinct display strings for one registrant list column.
 */
export const getRegistrantLicenseFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetRegistrantLicenseFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRegistrantLicenseFilterValuesResponses, GetRegistrantLicenseFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/filter-values',
        ...options
    });
};

/**
 * Get Registrant License Jurisdiction Options Endpoint
 * Jurisdictions the registrant holds licenses in, named for the filter.
 */
export const getRegistrantLicenseJurisdictionOptions = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantLicenseJurisdictionOptionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantLicenseJurisdictionOptionsResponses, GetRegistrantLicenseJurisdictionOptionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/jurisdiction-options',
        ...options
    });
};

/**
 * Get Registrant License Map Pins Endpoint
 * Pins or clusters for the registrant's matching licenses with coordinates.
 */
export const getRegistrantLicenseMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantLicenseMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantLicenseMapPinsResponses, GetRegistrantLicenseMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/map-pins',
        ...options
    });
};

/**
 * Export Registrant Licenses Endpoint
 * All registrant licenses matching the current list filters/sort.
 */
export const exportRegistrantLicenses = <ThrowOnError extends boolean = false>(options?: Options<ExportRegistrantLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExportRegistrantLicensesResponses, ExportRegistrantLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/export',
        ...options
    });
};

/**
 * Get Registrant Unregistered Properties Endpoint
 * One sortable/filterable page of the organization's unregistered properties.
 */
export const getRegistrantUnregisteredProperties = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantUnregisteredPropertiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantUnregisteredPropertiesResponses, GetRegistrantUnregisteredPropertiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/unregistered-properties',
        ...options
    });
};

/**
 * Get License Comments Endpoint
 * Get comments visible to the registrant.
 */
export const getLicenseComments = <ThrowOnError extends boolean = false>(options: Options<GetLicenseCommentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseCommentsResponses, GetLicenseCommentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/comments',
        ...options
    });
};

/**
 * Create Registrant License Comment Endpoint
 * Add a registrant comment, optionally notifying Hera or resolving an issue.
 */
export const createRegistrantLicenseComment = <ThrowOnError extends boolean = false>(options: Options<CreateRegistrantLicenseCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRegistrantLicenseCommentResponses, CreateRegistrantLicenseCommentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get License Payments Endpoint
 * Get the payments for a license.
 */
export const getLicensePayments = <ThrowOnError extends boolean = false>(options: Options<GetLicensePaymentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicensePaymentsResponses, GetLicensePaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/payments',
        ...options
    });
};

/**
 * Make License Payment Endpoint
 * Make payment for a license using existing pending payment records.
 */
export const makeLicensePayment = <ThrowOnError extends boolean = false>(options: Options<MakeLicensePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MakeLicensePaymentResponses, MakeLicensePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Pending Payment Records Endpoint
 * Create pending payment records for a license with user-adjusted amounts.
 *
 * This endpoint deletes any existing pending payment processor records
 * and creates new ones with the specified amounts. After calling this,
 * you can call makeLicensePayment to initiate the Stripe checkout session.
 */
export const createPendingPaymentRecords = <ThrowOnError extends boolean = false>(options: Options<CreatePendingPaymentRecordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePendingPaymentRecordsResponses, CreatePendingPaymentRecordsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/pending-payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Bulk Payment Fees Endpoint
 * Get fees for Pay Later bulk-payment cohort licenses (bulk payment screen).
 *
 * Loads only licenses that can appear on this screen (Pay Later selected + payable
 * statuses). Missing, dirty, or stale runtime cache rows for that subset are
 * recomputed in **parallel**, each in its **own** database transaction. Fresh cache
 * rows (including payable ones) are reused so opening bulk pay after the dashboard
 * does not recompute every license.
 *
 * The optional query params carry the registrant dashboard's global filters
 * (jurisdiction / license type / registrant / AMS). They narrow the cohort *before*
 * the expensive per-license work, so a filtered dashboard also means a faster and
 * matching bulk payment screen. ``ams_question_id`` is the question the dashboard
 * filtered AMS on; it is widened to every question behind that AMS column so this
 * screen keeps the same properties the dashboard showed.
 */
export const getBulkPaymentFees = <ThrowOnError extends boolean = false>(options?: Options<GetBulkPaymentFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetBulkPaymentFeesResponses, GetBulkPaymentFeesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/bulk-payment-fees',
        ...options
    });
};

/**
 * Create Bulk Pending Payment Records Endpoint
 * Create pending payment records for multiple licenses (for bulk payment).
 */
export const createBulkPendingPaymentRecords = <ThrowOnError extends boolean = false>(options: Options<CreateBulkPendingPaymentRecordsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBulkPendingPaymentRecordsResponses, CreateBulkPendingPaymentRecordsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/bulk-pending-payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Make Bulk License Payment Endpoint
 * Create one Stripe checkout session for all pending payment records.
 */
export const makeBulkLicensePayment = <ThrowOnError extends boolean = false>(options: Options<MakeBulkLicensePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MakeBulkLicensePaymentResponses, MakeBulkLicensePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/bulk-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Bulk Check Payment Endpoint
 * Create one check payment for all given licenses (bulk), with processing fee apportioned.
 */
export const createBulkCheckPayment = <ThrowOnError extends boolean = false>(options: Options<CreateBulkCheckPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBulkCheckPaymentResponses, CreateBulkCheckPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/bulk-check-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Registrant Check Payment Endpoint
 * Create check payment records and return the manual transaction ID.
 */
export const createRegistrantCheckPayment = <ThrowOnError extends boolean = false>(options: Options<CreateRegistrantCheckPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRegistrantCheckPaymentResponses, CreateRegistrantCheckPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/check-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Bulk Invoice Payment Endpoint
 * Create one invoice for multiple owned licenses (no processing fees on invoice lines).
 */
export const createBulkInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<CreateBulkInvoicePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateBulkInvoicePaymentResponses, CreateBulkInvoicePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/bulk-invoice-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Registrant Invoice Payment Endpoint
 * Create invoice lines for one license (no processing fees on invoice lines).
 */
export const createRegistrantInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<CreateRegistrantInvoicePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateRegistrantInvoicePaymentResponses, CreateRegistrantInvoicePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/invoice-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Registrant Payments Endpoint
 * List payments (check payments) for the current registrant account.
 */
export const getRegistrantPayments = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantPaymentsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/payments',
        ...options
    });
};

/**
 * Get Registrant Invoices Endpoint
 * List operator-issued invoices (paid and unpaid) for the registrant network.
 */
export const getRegistrantInvoices = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrantInvoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRegistrantInvoicesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/invoices',
        ...options
    });
};

/**
 * Get Registrant Payment Processor Detail Endpoint
 * Get detail for one card/ACH payment (view only).
 */
export const getRegistrantPaymentProcessorPaymentDetail = <ThrowOnError extends boolean = false>(options: Options<GetRegistrantPaymentProcessorPaymentDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRegistrantPaymentProcessorPaymentDetailResponses, GetRegistrantPaymentProcessorPaymentDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/payments/payment-processor/{payment_processor_transaction_id}',
        ...options
    });
};

/**
 * Get Registrant Payment Detail Endpoint
 * Get detail for one payment (view only).
 */
export const getRegistrantPaymentDetail = <ThrowOnError extends boolean = false>(options: Options<GetRegistrantPaymentDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRegistrantPaymentDetailResponses, GetRegistrantPaymentDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/payments/{manual_transaction_id}',
        ...options
    });
};

/**
 * Get Registrant Invoice Pdf Endpoint
 * Generate or reuse a filled invoice (Google Doc template) and return the PDF.
 */
export const getRegistrantInvoicePdf = <ThrowOnError extends boolean = false>(options: Options<GetRegistrantInvoicePdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRegistrantInvoicePdfResponses, GetRegistrantInvoicePdfErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/invoices/{manual_transaction_id}/pdf',
        ...options
    });
};

/**
 * Cancel Registrant Payment Endpoint
 * Cancel an awaiting check or invoice payment.
 */
export const cancelRegistrantPayment = <ThrowOnError extends boolean = false>(options: Options<CancelRegistrantPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelRegistrantPaymentResponses, CancelRegistrantPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/payments/{manual_transaction_id}/cancel',
        ...options
    });
};

/**
 * Renew License Endpoint
 * Renew a license.
 */
export const renewLicense = <ThrowOnError extends boolean = false>(options: Options<RenewLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RenewLicenseResponses, RenewLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/licenses/{license_id}/renewals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Stripe Checkout Session Url Endpoint
 * Get the URL for a checkout session.
 */
export const getStripeCheckoutSessionUrl = <ThrowOnError extends boolean = false>(options: Options<GetStripeCheckoutSessionUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStripeCheckoutSessionUrlResponses, GetStripeCheckoutSessionUrlErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/stripe/checkout_sessions/{checkout_session_id}/url',
        ...options
    });
};

/**
 * Get License From Checkout Session Endpoint
 * Get license ID from checkout session.
 */
export const getLicenseFromCheckoutSession = <ThrowOnError extends boolean = false>(options: Options<GetLicenseFromCheckoutSessionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseFromCheckoutSessionResponses, GetLicenseFromCheckoutSessionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/stripe/checkout_sessions/{checkout_session_id}/license',
        ...options
    });
};

/**
 * Abandon Stripe Checkout Session Endpoint
 * Abandon a pending Stripe checkout and restore Pay Later state when applicable.
 */
export const abandonStripeCheckoutSession = <ThrowOnError extends boolean = false>(options: Options<AbandonStripeCheckoutSessionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AbandonStripeCheckoutSessionResponses, AbandonStripeCheckoutSessionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/stripe/checkout_sessions/{checkout_session_id}/abandon',
        ...options
    });
};

/**
 * Get Stripe Portal Url Endpoint
 * Get a URL to the Stripe Customer Portal for the registrant.
 *
 * Personal and organization billing both use the company billing-account
 * Stripe customer. ``organization_billing`` is retained for API compatibility.
 */
export const getStripePortalUrl = <ThrowOnError extends boolean = false>(options: Options<GetStripePortalUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStripePortalUrlResponses, GetStripePortalUrlErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/stripe/portal_url',
        ...options
    });
};

/**
 * Cancel Secondary User Invite Endpoint
 * Cancel a pending invite for a secondary user by clearing primary_id_pending.
 *
 * This removes the user from the pending users list. Only works if the user
 * has primary_id_pending set to the current account's ID.
 */
export const cancelSecondaryUserInvite = <ThrowOnError extends boolean = false>(options: Options<CancelSecondaryUserInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CancelSecondaryUserInviteResponses, CancelSecondaryUserInviteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}',
        ...options
    });
};

/**
 * Get Registrant Account User Endpoint
 * Get a specific user (primary or secondary) for the registrant account.
 *
 * Includes disabled (soft-deleted) users so org admins can view details.
 * Only allows getting users that are linked to the logged-in account's primary account.
 */
export const getRegistrantAccountUser = <ThrowOnError extends boolean = false>(options: Options<GetRegistrantAccountUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRegistrantAccountUserResponses, GetRegistrantAccountUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}',
        ...options
    });
};

/**
 * Update Registrant Account User Endpoint
 * Update a secondary user account.
 *
 * Only allows updating secondary accounts that are linked to the logged-in account's primary account.
 * Primary accounts cannot be updated through this endpoint (use /account instead).
 */
export const updateRegistrantAccountUser = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountUserResponses, UpdateRegistrantAccountUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Disable Secondary User Endpoint
 * Disable (soft delete) a secondary user account.
 *
 * This will prevent the secondary user from logging in, but the primary user
 * will still be able to see all their previous registrations.
 */
export const disableSecondaryUser = <ThrowOnError extends boolean = false>(options: Options<DisableSecondaryUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DisableSecondaryUserResponses, DisableSecondaryUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/disable',
        ...options
    });
};

/**
 * Reenable Secondary User Endpoint
 * Re-enable (undelete) a disabled secondary user account.
 *
 * This will allow the secondary user to log in again.
 */
export const reenableSecondaryUser = <ThrowOnError extends boolean = false>(options: Options<ReenableSecondaryUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReenableSecondaryUserResponses, ReenableSecondaryUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/reenable',
        ...options
    });
};

/**
 * Transfer Primary Ownership Endpoint
 * Transfer primary account ownership to a secondary user.
 *
 * This endpoint allows the current primary user to transfer ownership to a
 * secondary user. The transfer:
 * - Sets primary_id for the current primary user and all other secondary users
 * (including deleted ones) to the new primary user
 * - Clears the primary_id for the new primary user
 * - Copies address fields and company_name from current primary
 * to new primary user
 * - Keeps the existing billing member unless ``move_billing_to_new_primary`` is
 * set, in which case the incoming primary is billed instead
 *
 * Stripe customer IDs are never moved or cleared, so saved cards and bank
 * accounts stay with whichever member owns them.
 *
 * Only organization admins can transfer ownership.
 */
export const transferPrimaryOwnership = <ThrowOnError extends boolean = false>(options: Options<TransferPrimaryOwnershipData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TransferPrimaryOwnershipResponses, TransferPrimaryOwnershipErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/make-primary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Account User Admin Endpoint
 * Grant or revoke org admin on a secondary user. The primary cannot lose admin.
 */
export const updateRegistrantAccountUserAdmin = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountUserAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountUserAdminResponses, UpdateRegistrantAccountUserAdminErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/admin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Account User Can Make Payments Endpoint
 * Grant or revoke pay-now for an org user, including admins and the primary.
 */
export const updateRegistrantAccountUserCanMakePayments = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantAccountUserCanMakePaymentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantAccountUserCanMakePaymentsResponses, UpdateRegistrantAccountUserCanMakePaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/users/{user_id}/can-make-payments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Pending Invite Info Endpoint
 * Get information about a pending invite to join another account.
 *
 * Returns the primary account details if primary_id_pending is set.
 */
export const getPendingInviteInfo = <ThrowOnError extends boolean = false>(options?: Options<GetPendingInviteInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPendingInviteInfoResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/pending-invite',
        ...options
    });
};

/**
 * Accept Pending Invite Endpoint
 * Accept a pending invite to join another account.
 *
 * Sets primary_id to primary_id_pending and clears primary_id_pending.
 */
export const acceptPendingInvite = <ThrowOnError extends boolean = false>(options?: Options<AcceptPendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AcceptPendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/accept-invite',
        ...options
    });
};

/**
 * Reject Pending Invite Endpoint
 * Reject a pending invite to join another account.
 *
 * Clears the primary_id_pending value.
 */
export const rejectPendingInvite = <ThrowOnError extends boolean = false>(options?: Options<RejectPendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RejectPendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/account/reject-invite',
        ...options
    });
};

/**
 * Upload Answer File Endpoint
 * Upload an answer file, save it, and return a token identifying the file.
 */
export const uploadAnswerFile = <ThrowOnError extends boolean = false>(options: Options<UploadAnswerFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadAnswerFileResponses, UploadAnswerFileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/registrant/answer_files/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * List Inspection Portal Licenses
 * List licenses for the inspection portal Requires/Complete queues.
 */
export const listInspectionPortalLicenses = <ThrowOnError extends boolean = false>(options?: Options<ListInspectionPortalLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListInspectionPortalLicensesResponses, ListInspectionPortalLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/licenses',
        ...options
    });
};

/**
 * List Inspection Dispatch Licenses
 * Licenses requiring inspection that the current manager may assign.
 */
export const listInspectionDispatchLicenses = <ThrowOnError extends boolean = false>(options?: Options<ListInspectionDispatchLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListInspectionDispatchLicensesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/dispatch/licenses',
        ...options
    });
};

/**
 * List Inspection Org Users
 * List registrant users in the org for assign/invite pickers.
 */
export const listInspectionOrgUsers = <ThrowOnError extends boolean = false>(options?: Options<ListInspectionOrgUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListInspectionOrgUsersResponses, ListInspectionOrgUsersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/org_users',
        ...options
    });
};

/**
 * List Inspection Impersonation Candidates
 * Operator: users that can be opened in the inspection portal for a license.
 */
export const listInspectionImpersonationCandidates = <ThrowOnError extends boolean = false>(options: Options<ListInspectionImpersonationCandidatesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListInspectionImpersonationCandidatesResponses, ListInspectionImpersonationCandidatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/impersonation/candidates',
        ...options
    });
};

/**
 * Bulk Assign Inspections
 * Assign pending inspections and grant license access (last-write-wins).
 */
export const bulkAssignInspections = <ThrowOnError extends boolean = false>(options: Options<BulkAssignInspectionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BulkAssignInspectionsResponses, BulkAssignInspectionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/assign',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Ensure Inspection License Access
 * Ensure the current user can open given licenses in the inspection portal.
 *
 * Forces registrant identities to ALL access. SELECTED identities receive
 * unioned license grants. Does not change inspection assignees.
 *
 * Operators open the inspection SPA via impersonation and do not need grants
 * mutated here (including when coming from the registrant portal Perform CTA).
 */
export const ensureInspectionLicenseAccess = <ThrowOnError extends boolean = false>(options: Options<EnsureInspectionLicenseAccessData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnsureInspectionLicenseAccessResponses, EnsureInspectionLicenseAccessErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/ensure-access',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unassign Inspection Endpoint
 * Clear assignee; revoke selected grant when applicable.
 */
export const unassignInspection = <ThrowOnError extends boolean = false>(options: Options<UnassignInspectionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnassignInspectionResponses, UnassignInspectionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/inspections/{inspection_id}/unassign',
        ...options
    });
};

/**
 * Invite Inspection User
 * Invite an inspection user into the registrant org.
 *
 * New invites create a Registrant-Portal identity (``inspection_only``) without
 * pre-creating an Auth0 user — the email deep-link uses Create account (signup).
 * Existing Registrant-Portal users are linked/granted only.
 */
export const inviteInspectionUser = <ThrowOnError extends boolean = false>(options: Options<InviteInspectionUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InviteInspectionUserResponses, InviteInspectionUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Disable Inspection User
 * Soft-disable an inspection user and clear their assignments.
 */
export const disableInspectionUser = <ThrowOnError extends boolean = false>(options: Options<DisableInspectionUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DisableInspectionUserResponses, DisableInspectionUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/users/{user_id}/disable',
        ...options
    });
};

/**
 * Upload Inspection Answer File
 * Upload an answer file for inspection workflow (image/video/document).
 */
export const uploadInspectionAnswerFile = <ThrowOnError extends boolean = false>(options: Options<UploadInspectionAnswerFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadInspectionAnswerFileResponses, UploadInspectionAnswerFileErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/answer_files/upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get Inspection Server Time
 * Return the server's current UTC time for capture clock synchronization.
 */
export const getInspectionServerTime = <ThrowOnError extends boolean = false>(options?: Options<GetInspectionServerTimeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetInspectionServerTimeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/time',
        ...options
    });
};

/**
 * Get Jurisdiction Inspection Logo Key
 * Return the GCS key for a jurisdiction logo (if set).
 */
export const getJurisdictionInspectionLogoKey = <ThrowOnError extends boolean = false>(options: Options<GetJurisdictionInspectionLogoKeyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJurisdictionInspectionLogoKeyResponses, GetJurisdictionInspectionLogoKeyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/inspection/jurisdictions/{jurisdiction_id}/logo_key',
        ...options
    });
};

/**
 * Get Omt Ams Access
 * Return portal access, org role, and whether this org is listed on licenses.
 */
export const getOmtAmsAccess = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsAccessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsAccessResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/access',
        ...options
    });
};

/**
 * Search Omt Ams Parties For Impersonation
 * Search parties by email, name, or company (operators only).
 */
export const searchOmtAmsPartiesForImpersonation = <ThrowOnError extends boolean = false>(options?: Options<SearchOmtAmsPartiesForImpersonationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SearchOmtAmsPartiesForImpersonationResponses, SearchOmtAmsPartiesForImpersonationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/impersonation/search-parties',
        ...options
    });
};

/**
 * Get Omt Ams Account
 * Read-only profile for the OMT/AMS portal.
 */
export const getOmtAmsAccount = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsAccountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account',
        ...options
    });
};

/**
 * Get Omt Ams Licenses
 * Page of licenses where the email is listed as OMT and/or AMS.
 */
export const getOmtAmsLicenses = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsLicensesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsLicensesResponses, GetOmtAmsLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/licenses',
        ...options
    });
};

/**
 * Get Omt Ams License Stats
 * Dashboard tile aggregates for the OMT/AMS-scoped licenses.
 */
export const getOmtAmsLicenseStats = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsLicenseStatsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsLicenseStatsResponses, GetOmtAmsLicenseStatsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/licenses/stats',
        ...options
    });
};

/**
 * Get Omt Ams License Filter Values
 * Facet values for an OMT/AMS license-list column.
 */
export const getOmtAmsLicenseFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetOmtAmsLicenseFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOmtAmsLicenseFilterValuesResponses, GetOmtAmsLicenseFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/licenses/filter-values',
        ...options
    });
};

/**
 * Get Omt Ams License Map Pins
 * Pins or clusters for OMT/AMS-scoped licenses.
 */
export const getOmtAmsLicenseMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsLicenseMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsLicenseMapPinsResponses, GetOmtAmsLicenseMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/licenses/map-pins',
        ...options
    });
};

/**
 * Get Omt Ams License Comments
 * Read-only comments for an OMT/AMS-scoped license.
 */
export const getOmtAmsLicenseComments = <ThrowOnError extends boolean = false>(options: Options<GetOmtAmsLicenseCommentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOmtAmsLicenseCommentsResponses, GetOmtAmsLicenseCommentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/licenses/{license_id}/comments',
        ...options
    });
};

/**
 * Get Omt Ams License Payments
 * Read-only payments for an OMT/AMS-scoped license.
 */
export const getOmtAmsLicensePayments = <ThrowOnError extends boolean = false>(options: Options<GetOmtAmsLicensePaymentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOmtAmsLicensePaymentsResponses, GetOmtAmsLicensePaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/licenses/{license_id}/payments',
        ...options
    });
};

/**
 * Get Omt Ams Invoices
 * Invoices for registrant accounts that own the visible OMT/AMS licenses.
 */
export const getOmtAmsInvoices = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsInvoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsInvoicesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/invoices',
        ...options
    });
};

/**
 * Get Omt Ams Account Users
 * List primary and secondary users for the OMT/AMS org.
 */
export const getOmtAmsAccountUsers = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsAccountUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsAccountUsersResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/users',
        ...options
    });
};

/**
 * Add Omt Ams Secondary User
 * Invite a secondary OMT/AMS user. The org primary cannot be changed.
 */
export const addOmtAmsSecondaryUser = <ThrowOnError extends boolean = false>(options: Options<AddOmtAmsSecondaryUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddOmtAmsSecondaryUserResponses, AddOmtAmsSecondaryUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cancel Omt Ams Secondary User Invite
 * Cancel a pending invite by clearing primary_id_pending.
 */
export const cancelOmtAmsSecondaryUserInvite = <ThrowOnError extends boolean = false>(options: Options<CancelOmtAmsSecondaryUserInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CancelOmtAmsSecondaryUserInviteResponses, CancelOmtAmsSecondaryUserInviteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/users/{user_id}',
        ...options
    });
};

/**
 * Disable Omt Ams Secondary User
 * Disable a secondary OMT/AMS user. The primary cannot be disabled.
 */
export const disableOmtAmsSecondaryUser = <ThrowOnError extends boolean = false>(options: Options<DisableOmtAmsSecondaryUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DisableOmtAmsSecondaryUserResponses, DisableOmtAmsSecondaryUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/users/{user_id}/disable',
        ...options
    });
};

/**
 * Reenable Omt Ams Secondary User
 * Re-enable a disabled secondary OMT/AMS user.
 */
export const reenableOmtAmsSecondaryUser = <ThrowOnError extends boolean = false>(options: Options<ReenableOmtAmsSecondaryUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReenableOmtAmsSecondaryUserResponses, ReenableOmtAmsSecondaryUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/users/{user_id}/reenable',
        ...options
    });
};

/**
 * Update Omt Ams Account User Admin
 * Grant or revoke admin on a secondary. The primary always stays admin.
 */
export const updateOmtAmsAccountUserAdmin = <ThrowOnError extends boolean = false>(options: Options<UpdateOmtAmsAccountUserAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOmtAmsAccountUserAdminResponses, UpdateOmtAmsAccountUserAdminErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/users/{user_id}/admin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Omt Ams Pending Invite Info
 * Return the inviting primary org when this user has a pending invite.
 */
export const getOmtAmsPendingInviteInfo = <ThrowOnError extends boolean = false>(options?: Options<GetOmtAmsPendingInviteInfoData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOmtAmsPendingInviteInfoResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/pending-invite',
        ...options
    });
};

/**
 * Accept Omt Ams Pending Invite
 * Accept a pending invite. The inviting primary is never changed.
 */
export const acceptOmtAmsPendingInvite = <ThrowOnError extends boolean = false>(options?: Options<AcceptOmtAmsPendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AcceptOmtAmsPendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/accept-invite',
        ...options
    });
};

/**
 * Reject Omt Ams Pending Invite
 * Reject a pending invite and remain a standalone primary.
 */
export const rejectOmtAmsPendingInvite = <ThrowOnError extends boolean = false>(options?: Options<RejectOmtAmsPendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RejectOmtAmsPendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/omt-ams/account/reject-invite',
        ...options
    });
};

/**
 * Get Jurisdictions Endpoint
 * Get all jurisdictions.
 */
export const getJurisdictions = <ThrowOnError extends boolean = false>(options?: Options<GetJurisdictionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetJurisdictionsResponses, GetJurisdictionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions',
        ...options
    });
};

/**
 * Create Jurisdiction Endpoint
 * Create a jurisdiction.
 *
 * New jurisdictions start with branding ``pending``; when enabled, seal,
 * color, and website are looked up in the background after the response.
 */
export const createJurisdiction = <ThrowOnError extends boolean = false>(options: Options<CreateJurisdictionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateJurisdictionResponses, CreateJurisdictionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Jurisdiction Endpoint
 * Get a jurisdiction by ID.
 */
export const getJurisdiction = <ThrowOnError extends boolean = false>(options: Options<GetJurisdictionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJurisdictionResponses, GetJurisdictionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}',
        ...options
    });
};

/**
 * Update Jurisdiction Endpoint
 * Update a jurisdiction + associated license type configurations.
 */
export const updateJurisdiction = <ThrowOnError extends boolean = false>(options: Options<UpdateJurisdictionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateJurisdictionResponses, UpdateJurisdictionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Dryrun Jurisdiction Creation Endpoint
 * Dry run jurisdiction creation from uploaded file using field mappings.
 */
export const dryrunJurisdictionCreation = <ThrowOnError extends boolean = false>(options: Options<DryrunJurisdictionCreationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunJurisdictionCreationResponses, DryrunJurisdictionCreationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/bulk_create/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Jurisdictions Endpoint
 * Create jurisdictions and license type configs from uploaded file using field mappings.
 */
export const createJurisdictions = <ThrowOnError extends boolean = false>(options: Options<CreateJurisdictionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateJurisdictionsResponses, CreateJurisdictionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/bulk_create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Jurisdiction Theme Color
 * Set or clear the brand color for a jurisdiction.
 */
export const updateJurisdictionThemeColor = <ThrowOnError extends boolean = false>(options: Options<UpdateJurisdictionThemeColorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateJurisdictionThemeColorResponses, UpdateJurisdictionThemeColorErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/theme-color',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Clear Jurisdiction Logo
 * Clear the jurisdiction seal or logo; pages fall back to generic branding.
 */
export const clearJurisdictionLogo = <ThrowOnError extends boolean = false>(options: Options<ClearJurisdictionLogoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ClearJurisdictionLogoResponses, ClearJurisdictionLogoErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/logo',
        ...options
    });
};

/**
 * Upload Jurisdiction Logo
 * Upload or replace the city/county seal or logo for this jurisdiction.
 */
export const uploadJurisdictionLogo = <ThrowOnError extends boolean = false>(options: Options<UploadJurisdictionLogoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadJurisdictionLogoResponses, UploadJurisdictionLogoErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/logo',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * List Operator Inspection Impersonation Candidates
 * List registrant/inspector users for opening the inspection portal as.
 */
export const listOperatorInspectionImpersonationCandidates = <ThrowOnError extends boolean = false>(options: Options<ListOperatorInspectionImpersonationCandidatesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListOperatorInspectionImpersonationCandidatesResponses, ListOperatorInspectionImpersonationCandidatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/{license_id}/inspection-impersonation-candidates',
        ...options
    });
};

/**
 * Get Jurisdiction Branding
 * Branding values, where each came from, and which an operator set by hand.
 */
export const getJurisdictionBranding = <ThrowOnError extends boolean = false>(options: Options<GetJurisdictionBrandingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJurisdictionBrandingResponses, GetJurisdictionBrandingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/branding',
        ...options
    });
};

/**
 * Refresh Jurisdiction Branding
 * Re-run automatic seal, color, and website lookup for one jurisdiction.
 *
 * Fields an operator set by hand are kept unless listed in ``reset_fields``.
 */
export const refreshJurisdictionBranding = <ThrowOnError extends boolean = false>(options: Options<RefreshJurisdictionBrandingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefreshJurisdictionBrandingResponses, RefreshJurisdictionBrandingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/branding/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Ordinance Version Endpoint
 * Add a new time-versioned fee/late/remittance rule snapshot for a license type configuration.
 */
export const createOrdinanceVersion = <ThrowOnError extends boolean = false>(options: Options<CreateOrdinanceVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateOrdinanceVersionResponses, CreateOrdinanceVersionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/ordinance_versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Ordinance Version Endpoint
 * Delete a historic ordinance version row.
 */
export const deleteOrdinanceVersion = <ThrowOnError extends boolean = false>(options: Options<DeleteOrdinanceVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteOrdinanceVersionResponses, DeleteOrdinanceVersionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/ordinance_versions/{ordinance_version_id}',
        ...options
    });
};

/**
 * Update Ordinance Version Endpoint
 * Update an existing ordinance history row (full replacement body).
 */
export const updateOrdinanceVersion = <ThrowOnError extends boolean = false>(options: Options<UpdateOrdinanceVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOrdinanceVersionResponses, UpdateOrdinanceVersionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/ordinance_versions/{ordinance_version_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Export Ordinances Csv Endpoint
 * Download all ordinance rows (live + historic) as CSV for round-trip import.
 */
export const exportOrdinancesCsv = <ThrowOnError extends boolean = false>(options?: Options<ExportOrdinancesCsvData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExportOrdinancesCsvResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/ordinances/export.csv',
        ...options
    });
};

/**
 * Dryrun Ordinance Import Endpoint
 * Validate and transform ordinance import rows without writing.
 */
export const dryrunOrdinanceImport = <ThrowOnError extends boolean = false>(options: Options<DryrunOrdinanceImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunOrdinanceImportResponses, DryrunOrdinanceImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/ordinances/import/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Apply Ordinance Import Endpoint
 * Upsert ordinance versions from an uploaded spreadsheet (existing jurisdictions only).
 */
export const applyOrdinanceImport = <ThrowOnError extends boolean = false>(options: Options<ApplyOrdinanceImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplyOrdinanceImportResponses, ApplyOrdinanceImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/ordinances/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lookup Jurisdiction By Fips Endpoint
 * Lookup jurisdiction by FIPS code using TigerWeb.
 */
export const lookupJurisdictionByFipsCode = <ThrowOnError extends boolean = false>(options: Options<LookupJurisdictionByFipsCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LookupJurisdictionByFipsCodeResponses, LookupJurisdictionByFipsCodeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdiction_lookups/fips/{fips_code}',
        ...options
    });
};

/**
 * Lookup Jurisdiction By Tiger Code Endpoint
 * Lookup jurisdiction by TIGER code using TigerWeb.
 */
export const lookupJurisdictionByTigerCode = <ThrowOnError extends boolean = false>(options: Options<LookupJurisdictionByTigerCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LookupJurisdictionByTigerCodeResponses, LookupJurisdictionByTigerCodeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdiction_lookups/tiger_code/{tiger_code}',
        ...options
    });
};

/**
 * Fuzzy Search Jurisdictions By Name Endpoint
 * Fuzzy search for jurisdictions by name using TigerWeb.
 *
 * ``max_results`` caps the list so a very broad name cannot pull an unbounded
 * Census page. Distinct TIGER codes are kept even when the display name matches.
 */
export const fuzzySearchJurisdictionsByName = <ThrowOnError extends boolean = false>(options: Options<FuzzySearchJurisdictionsByNameData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<FuzzySearchJurisdictionsByNameResponses, FuzzySearchJurisdictionsByNameErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdiction_lookups/fuzzy_search',
        ...options
    });
};

/**
 * Operator Get Registrant By Email Endpoint
 * Look up registrant account by email for form prefilling. Includes deleted accounts.
 */
export const operatorGetRegistrantByEmail = <ThrowOnError extends boolean = false>(options: Options<OperatorGetRegistrantByEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<OperatorGetRegistrantByEmailResponses, OperatorGetRegistrantByEmailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-by-email',
        ...options
    });
};

/**
 * List License Link Candidates Endpoint
 * List proposed matches, or search every license in this jurisdiction.
 */
export const listLicenseLinkCandidates = <ThrowOnError extends boolean = false>(options: Options<ListLicenseLinkCandidatesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListLicenseLinkCandidatesResponses, ListLicenseLinkCandidatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/{license_id}/link-candidates',
        ...options
    });
};

/**
 * Link License Endpoint
 * Link this license to another license in the same jurisdiction.
 */
export const linkLicense = <ThrowOnError extends boolean = false>(options: Options<LinkLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkLicenseResponses, LinkLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/{license_id}/links',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Operator Create License Endpoint
 * Create a license on behalf of a registrant as an operator.
 */
export const operatorCreateLicense = <ThrowOnError extends boolean = false>(options: Options<OperatorCreateLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OperatorCreateLicenseResponses, OperatorCreateLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Saved Import Mappings Endpoint
 * List saved import mappings for the current user and upload type.
 */
export const listSavedImportMappings = <ThrowOnError extends boolean = false>(options: Options<ListSavedImportMappingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListSavedImportMappingsResponses, ListSavedImportMappingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/saved-import-mappings',
        ...options
    });
};

/**
 * Create Saved Import Mapping Endpoint
 * Create a saved import mapping for the current user.
 */
export const createSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<CreateSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateSavedImportMappingResponses, CreateSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/saved-import-mappings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Saved Import Mapping Endpoint
 * Delete one saved import mapping.
 */
export const deleteSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<DeleteSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteSavedImportMappingResponses, DeleteSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/saved-import-mappings/{mapping_id}',
        ...options
    });
};

/**
 * Update Saved Import Mapping Endpoint
 * Update one saved import mapping.
 */
export const updateSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<UpdateSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateSavedImportMappingResponses, UpdateSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/saved-import-mappings/{mapping_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Apply Saved Import Mapping Endpoint
 * Preview applying one saved mapping to a specific uploaded sheet.
 */
export const applySavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<ApplySavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplySavedImportMappingResponses, ApplySavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/saved-import-mappings/apply',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get File Headers And Row Counts Endpoint
 * Get file headers and row counts for a given token.
 */
export const getTempFileHeadersAndRowCounts = <ThrowOnError extends boolean = false>(options: Options<GetTempFileHeadersAndRowCountsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTempFileHeadersAndRowCountsResponses, GetTempFileHeadersAndRowCountsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/headers',
        ...options
    });
};

/**
 * Get Temp File Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a jurisdiction file.
 */
export const getJurisdictionFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetJurisdictionFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJurisdictionFieldMappingForTempFileResponses, GetJurisdictionFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/jurisdiction_field_mapping',
        ...options
    });
};

/**
 * Get Temp File Ordinance Field Mapping
 * Infer (or load saved) column mapping for ordinance bulk import.
 */
export const getOrdinanceFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetOrdinanceFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOrdinanceFieldMappingForTempFileResponses, GetOrdinanceFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/ordinance_field_mapping',
        ...options
    });
};

/**
 * Get Temp File License Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a license file.
 */
export const getLicenseFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetLicenseFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseFieldMappingForTempFileResponses, GetLicenseFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/license_field_mapping',
        ...options
    });
};

/**
 * Get Temp File Government User Field Mapping
 * Infer or load a saved mapping for a government-user spreadsheet.
 */
export const getGovernmentUserFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentUserFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentUserFieldMappingForTempFileResponses, GetGovernmentUserFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/government_user_field_mapping',
        ...options
    });
};

/**
 * Dryrun Government User Upsert Endpoint
 * Validate a government-user spreadsheet without writing users or Auth0.
 */
export const dryrunGovernmentUserUpsert = <ThrowOnError extends boolean = false>(options: Options<DryrunGovernmentUserUpsertData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunGovernmentUserUpsertResponses, DryrunGovernmentUserUpsertErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/government_users/bulk_upsert/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upsert Government Users Endpoint
 * Create or patch government users from an uploaded spreadsheet.
 */
export const upsertGovernmentUsers = <ThrowOnError extends boolean = false>(options: Options<UpsertGovernmentUsersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UpsertGovernmentUsersResponses, UpsertGovernmentUsersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/government_users/bulk_upsert',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Dryrun License Creation Endpoint
 * Dry run license creation from uploaded file using field mappings.
 */
export const dryrunLicenseCreation = <ThrowOnError extends boolean = false>(options: Options<DryrunLicenseCreationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunLicenseCreationResponses, DryrunLicenseCreationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/bulk_create/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Licenses Endpoint
 * Create licenses from uploaded file using field mappings.
 */
export const createLicenses = <ThrowOnError extends boolean = false>(options: Options<CreateLicensesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLicensesResponses, CreateLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/bulk_create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Temp File Question Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a question file.
 */
export const getQuestionFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetQuestionFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetQuestionFieldMappingForTempFileResponses, GetQuestionFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/question_field_mapping',
        ...options
    });
};

/**
 * Get Temp File Question Group Field Mapping
 * Field mapping for a spreadsheet with question group name + license type columns.
 */
export const getQuestionGroupFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetQuestionGroupFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetQuestionGroupFieldMappingForTempFileResponses, GetQuestionGroupFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/question_group_field_mapping',
        ...options
    });
};

/**
 * Dryrun Question Creation Endpoint
 * Dry run question creation from uploaded file. Operator only.
 */
export const dryrunQuestionCreation = <ThrowOnError extends boolean = false>(options: Options<DryrunQuestionCreationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunQuestionCreationResponses, DryrunQuestionCreationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/questions/bulk_create/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Questions Endpoint
 * Create questions from uploaded file. Operator only; government users cannot upload questions.
 */
export const createQuestions = <ThrowOnError extends boolean = false>(options: Options<CreateQuestionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateQuestionsResponses, CreateQuestionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/questions/bulk_create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Dryrun Question Group Creation Endpoint
 * Dry run: parse question group rows from an uploaded file.
 */
export const dryrunQuestionGroupCreation = <ThrowOnError extends boolean = false>(options: Options<DryrunQuestionGroupCreationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunQuestionGroupCreationResponses, DryrunQuestionGroupCreationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/question-groups/bulk_create/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Question Groups Bulk Endpoint
 * Bulk-create question groups from an uploaded file (name + license type per row).
 */
export const createQuestionGroups = <ThrowOnError extends boolean = false>(options: Options<CreateQuestionGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateQuestionGroupsResponses, CreateQuestionGroupsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/question-groups/bulk_create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Temp File Party Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is a party file.
 */
export const getPartyFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetPartyFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPartyFieldMappingForTempFileResponses, GetPartyFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/party_field_mapping',
        ...options
    });
};

/**
 * Dryrun Party Creation Endpoint
 * Dry run party creation from uploaded file using field mappings.
 */
export const dryrunPartyCreation = <ThrowOnError extends boolean = false>(options: Options<DryrunPartyCreationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunPartyCreationResponses, DryrunPartyCreationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/parties/bulk_create/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Parties Endpoint
 * Create parties (name/address/contact) from uploaded file using field mappings.
 */
export const createParties = <ThrowOnError extends boolean = false>(options: Options<CreatePartiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePartiesResponses, CreatePartiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/parties/bulk_create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Temp File Case Number Field Mapping
 * Get spreadsheet field mapping for a foreclosure case-number upload file.
 */
export const getCaseNumberFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetCaseNumberFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCaseNumberFieldMappingForTempFileResponses, GetCaseNumberFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/tempfiles/{token}/case_number_field_mapping',
        ...options
    });
};

/**
 * Dryrun Case Number Import Endpoint
 * Dry-run applying foreclosure case numbers from an uploaded spreadsheet.
 */
export const dryrunCaseNumberImport = <ThrowOnError extends boolean = false>(options: Options<DryrunCaseNumberImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunCaseNumberImportResponses, DryrunCaseNumberImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/case_numbers/import/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Apply Case Number Import Endpoint
 * Apply foreclosure case numbers from an uploaded spreadsheet onto licenses.
 */
export const applyCaseNumberImport = <ThrowOnError extends boolean = false>(options: Options<ApplyCaseNumberImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplyCaseNumberImportResponses, ApplyCaseNumberImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/case_numbers/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Preview Bulk Service Transfer Endpoint
 * Dry-run bulk service transfer for mapped JSON rows (CSV download–ready).
 */
export const previewBulkServiceTransfer = <ThrowOnError extends boolean = false>(options: Options<PreviewBulkServiceTransferData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewBulkServiceTransferResponses, PreviewBulkServiceTransferErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/service_transfers/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Commit Bulk Service Transfer Endpoint
 * Commit bulk service transfers for mapped JSON rows.
 */
export const commitBulkServiceTransfer = <ThrowOnError extends boolean = false>(options: Options<CommitBulkServiceTransferData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommitBulkServiceTransferResponses, CommitBulkServiceTransferErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/licenses/service_transfers/commit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get HERA configuration
 * Get all HERA configuration settings
 */
export const getHeraConfigurationEndpointOperatorHeraConfigurationGet = <ThrowOnError extends boolean = false>(options?: Options<GetHeraConfigurationEndpointOperatorHeraConfigurationGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetHeraConfigurationEndpointOperatorHeraConfigurationGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/hera-configuration',
        ...options
    });
};

/**
 * Update HERA configuration
 * Update HERA configuration settings
 */
export const updateHeraConfigurationEndpointOperatorHeraConfigurationPut = <ThrowOnError extends boolean = false>(options: Options<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutResponses, UpdateHeraConfigurationEndpointOperatorHeraConfigurationPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/hera-configuration',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Manual Check Payments Endpoint
 * List manual check payments for the operator checks tab.
 */
export const getManualCheckPayments = <ThrowOnError extends boolean = false>(options?: Options<GetManualCheckPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetManualCheckPaymentsResponses, GetManualCheckPaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-check-payments',
        ...options
    });
};

/**
 * Get Manual Check Payment Detail Endpoint
 * Get full detail for one manual check payment (Check Received dialog).
 */
export const getManualCheckPaymentDetail = <ThrowOnError extends boolean = false>(options: Options<GetManualCheckPaymentDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetManualCheckPaymentDetailResponses, GetManualCheckPaymentDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-check-payments/{manual_transaction_id}',
        ...options
    });
};

/**
 * Cancel Manual Check Payment Endpoint
 * Cancel a manual check payment (awaiting payment only).
 */
export const cancelManualCheckPayment = <ThrowOnError extends boolean = false>(options: Options<CancelManualCheckPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelManualCheckPaymentResponses, CancelManualCheckPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-check-payments/{manual_transaction_id}/cancel',
        ...options
    });
};

/**
 * Finalise Manual Check Payment Endpoint
 * Mark a manual check payment as received with optional amount adjustments and removals.
 */
export const finaliseManualCheckPayment = <ThrowOnError extends boolean = false>(options: Options<FinaliseManualCheckPaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FinaliseManualCheckPaymentResponses, FinaliseManualCheckPaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-check-payments/{manual_transaction_id}/finalise',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark Manual Check Payment Deposited
 * Record when a finalized check reaches the trust account.
 */
export const markManualCheckPaymentDeposited = <ThrowOnError extends boolean = false>(options: Options<MarkManualCheckPaymentDepositedData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MarkManualCheckPaymentDepositedResponses, MarkManualCheckPaymentDepositedErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-check-payments/{manual_transaction_id}/deposit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Refund Allocations Endpoint
 * List refund allocations for the operator Refunds tab.
 */
export const getRefundAllocations = <ThrowOnError extends boolean = false>(options?: Options<GetRefundAllocationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRefundAllocationsResponses, GetRefundAllocationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/refund-allocations',
        ...options
    });
};

/**
 * Get Refund Allocation Detail Endpoint
 * Get detail for the refund allocation dialog.
 */
export const getRefundAllocationDetail = <ThrowOnError extends boolean = false>(options: Options<GetRefundAllocationDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetRefundAllocationDetailResponses, GetRefundAllocationDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/refund-allocations/{payment_processor_transaction_id}',
        ...options
    });
};

/**
 * Finalise Refund Allocation Endpoint
 * Apply or re-apply manual refund allocation.
 */
export const finaliseRefundAllocation = <ThrowOnError extends boolean = false>(options: Options<FinaliseRefundAllocationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FinaliseRefundAllocationResponses, FinaliseRefundAllocationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/refund-allocations/{payment_processor_transaction_id}/finalise',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Manual Invoice Payments Endpoint
 * List manual invoice payments for the operator invoices tab.
 */
export const getManualInvoicePayments = <ThrowOnError extends boolean = false>(options?: Options<GetManualInvoicePaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetManualInvoicePaymentsResponses, GetManualInvoicePaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-invoice-payments',
        ...options
    });
};

/**
 * Generate Operator Invoices Endpoint
 * Create invoices for registrants with accounts contact; only explicit Pay Later cohort licenses.
 */
export const generateOperatorInvoices = <ThrowOnError extends boolean = false>(options?: Options<GenerateOperatorInvoicesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<GenerateOperatorInvoicesResponses, GenerateOperatorInvoicesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-invoice-payments/generate',
        ...options
    });
};

/**
 * Get Manual Invoice Payment Detail Endpoint
 * Get full detail for one manual invoice payment.
 */
export const getManualInvoicePaymentDetail = <ThrowOnError extends boolean = false>(options: Options<GetManualInvoicePaymentDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetManualInvoicePaymentDetailResponses, GetManualInvoicePaymentDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-invoice-payments/{manual_transaction_id}',
        ...options
    });
};

/**
 * Get Manual Invoice Payment Pdf Endpoint
 * Generate or reuse a filled invoice document (per license-type template) and return the PDF.
 */
export const getManualInvoicePaymentPdf = <ThrowOnError extends boolean = false>(options: Options<GetManualInvoicePaymentPdfData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetManualInvoicePaymentPdfResponses, GetManualInvoicePaymentPdfErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-invoice-payments/{manual_transaction_id}/pdf',
        ...options
    });
};

/**
 * Cancel Manual Invoice Payment Endpoint
 * Cancel a manual invoice payment (awaiting payment only).
 */
export const cancelManualInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<CancelManualInvoicePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelManualInvoicePaymentResponses, CancelManualInvoicePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-invoice-payments/{manual_transaction_id}/cancel',
        ...options
    });
};

/**
 * Finalise Manual Invoice Payment Endpoint
 * Mark a manual invoice as paid (same payload as check finalise).
 */
export const finaliseManualInvoicePayment = <ThrowOnError extends boolean = false>(options: Options<FinaliseManualInvoicePaymentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FinaliseManualInvoicePaymentResponses, FinaliseManualInvoicePaymentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/manual-invoice-payments/{manual_transaction_id}/finalise',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Registrant Login Identity Operator Endpoint
 * Mark whether a registrant user is the accounts contact (invoice / billing email).
 */
export const updateRegistrantLoginIdentityOperator = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantLoginIdentityOperatorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantLoginIdentityOperatorResponses, UpdateRegistrantLoginIdentityOperatorErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-login-identities/{login_identity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Operator Registrant Account Accounts Contact Endpoint
 * Set accounts-contact for a registrant account (portal users and/or pre-login).
 */
export const updateOperatorRegistrantAccountAccountsContact = <ThrowOnError extends boolean = false>(options: Options<UpdateOperatorRegistrantAccountAccountsContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOperatorRegistrantAccountAccountsContactResponses, UpdateOperatorRegistrantAccountAccountsContactErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-accounts/{registrant_account_id}/accounts-contact',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Operator Disable Registrant User Endpoint
 * Disable an eligible registrant user from the operator portal.
 */
export const operatorDisableRegistrantUser = <ThrowOnError extends boolean = false>(options: Options<OperatorDisableRegistrantUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<OperatorDisableRegistrantUserResponses, OperatorDisableRegistrantUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-accounts/{registrant_account_id}/disable',
        ...options
    });
};

/**
 * Operator Reenable Registrant User Endpoint
 * Re-enable a disabled registrant user from the operator portal.
 */
export const operatorReenableRegistrantUser = <ThrowOnError extends boolean = false>(options: Options<OperatorReenableRegistrantUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OperatorReenableRegistrantUserResponses, OperatorReenableRegistrantUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-accounts/{registrant_account_id}/reenable',
        ...options
    });
};

/**
 * Operator Transfer Primary Ownership Endpoint
 * Transfer organization primary ownership to another linked account (operator).
 *
 * ``organization_primary_id`` must be the current primary registrant account for the org.
 * ``new_primary_account_id`` must be an active secondary linked to that primary.
 *
 * Billing stays with the existing billing member unless
 * ``move_billing_to_new_primary`` is set. Stripe customers are never moved, so
 * saved cards and bank accounts stay with the member who owns them.
 */
export const operatorTransferPrimaryOwnership = <ThrowOnError extends boolean = false>(options: Options<OperatorTransferPrimaryOwnershipData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OperatorTransferPrimaryOwnershipResponses, OperatorTransferPrimaryOwnershipErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-accounts/{organization_primary_id}/transfer-primary/{new_primary_account_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Operator Accept Pending Invite Endpoint
 * Accept a pending organization invite on behalf of the registrant account (operator).
 *
 * Same state changes as registrant ``POST /registrant/account/accept-invite``.
 */
export const operatorAcceptPendingRegistrantInvite = <ThrowOnError extends boolean = false>(options: Options<OperatorAcceptPendingRegistrantInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OperatorAcceptPendingRegistrantInviteResponses, OperatorAcceptPendingRegistrantInviteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/registrant-accounts/{registrant_account_id}/accept-invite',
        ...options
    });
};

/**
 * Create License Type Endpoint
 * Create a new license type.
 */
export const createLicenseType = <ThrowOnError extends boolean = false>(options: Options<CreateLicenseTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateLicenseTypeResponses, CreateLicenseTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license_types',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get License Type Endpoint
 * Get a license type by ID.
 */
export const getLicenseType = <ThrowOnError extends boolean = false>(options: Options<GetLicenseTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLicenseTypeResponses, GetLicenseTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license_types/{license_type_id}',
        ...options
    });
};

/**
 * Update License Type Endpoint
 * Update a license type.
 */
export const updateLicenseType = <ThrowOnError extends boolean = false>(options: Options<UpdateLicenseTypeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateLicenseTypeResponses, UpdateLicenseTypeErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license_types/{license_type_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Affected Jurisdictions Count Endpoint
 * Get the count of license type configurations that would be affected by license type status change.
 */
export const getAffectedJurisdictionsCount = <ThrowOnError extends boolean = false>(options: Options<GetAffectedJurisdictionsCountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAffectedJurisdictionsCountResponses, GetAffectedJurisdictionsCountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license_types/{license_type_id}/affected_jurisdictions_count',
        ...options
    });
};

/**
 * Cascade Jurisdiction Status Endpoint
 * Cascade the license type status change to related license type configurations.
 */
export const cascadeJurisdictionStatus = <ThrowOnError extends boolean = false>(options: Options<CascadeJurisdictionStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CascadeJurisdictionStatusResponses, CascadeJurisdictionStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license_types/{license_type_id}/cascade_jurisdiction_status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get status of all template documents for a license type
 * Returns the status of all template document types for a specific license type (whether they exist or not)
 */
export const getAllTemplateDocumentsStatus = <ThrowOnError extends boolean = false>(options: Options<GetAllTemplateDocumentsStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllTemplateDocumentsStatusResponses, GetAllTemplateDocumentsStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license-types/{license_type_id}/template-documents',
        ...options
    });
};

/**
 * Delete a template document for a license type
 * Soft deletes a template document from the system for a specific license type
 */
export const deleteTemplateDocumentEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateDocumentEndpointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTemplateDocumentEndpointResponses, DeleteTemplateDocumentEndpointErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license-types/{license_type_id}/template-documents/{document_type}',
        ...options
    });
};

/**
 * Create or get a template document for a license type
 * Creates a template document in Google Drive for a specific license type if it doesn't exist, or returns the existing one. If a deleted template exists, will prompt user for action.
 */
export const createTemplateDocumentEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateDocumentEndpointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTemplateDocumentEndpointResponses, CreateTemplateDocumentEndpointErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license-types/{license_type_id}/template-documents/{document_type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get status of all documents for a jurisdiction license type configuration
 * Returns the status of all document types for a specific jurisdiction license type configuration
 */
export const getAllJurisdictionDocumentsStatus = <ThrowOnError extends boolean = false>(options: Options<GetAllJurisdictionDocumentsStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllJurisdictionDocumentsStatusResponses, GetAllJurisdictionDocumentsStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/documents',
        ...options
    });
};

/**
 * Get Jurisdiction Configuration Question Groups
 * Get question groups assigned to a jurisdiction license type configuration.
 */
export const getJurisdictionConfigurationQuestionGroups = <ThrowOnError extends boolean = false>(options: Options<GetJurisdictionConfigurationQuestionGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJurisdictionConfigurationQuestionGroupsResponses, GetJurisdictionConfigurationQuestionGroupsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/question_groups',
        ...options
    });
};

/**
 * Update Jurisdiction Configuration Question Groups
 * Set question groups for a jurisdiction license type configuration.
 */
export const updateJurisdictionConfigurationQuestionGroups = <ThrowOnError extends boolean = false>(options: Options<UpdateJurisdictionConfigurationQuestionGroupsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateJurisdictionConfigurationQuestionGroupsResponses, UpdateJurisdictionConfigurationQuestionGroupsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/question_groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a jurisdiction document
 * Soft deletes a document from a jurisdiction license type configuration
 */
export const deleteJurisdictionDocumentEndpoint = <ThrowOnError extends boolean = false>(options: Options<DeleteJurisdictionDocumentEndpointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteJurisdictionDocumentEndpointResponses, DeleteJurisdictionDocumentEndpointErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/documents/{document_type}',
        ...options
    });
};

/**
 * Create a document for a jurisdiction license type configuration
 * Creates a document entry for a jurisdiction license type configuration. For now, uses a placeholder document ID.
 */
export const createJurisdictionDocumentEndpoint = <ThrowOnError extends boolean = false>(options: Options<CreateJurisdictionDocumentEndpointData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateJurisdictionDocumentEndpointResponses, CreateJurisdictionDocumentEndpointErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/documents/{document_type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Question Groups
 * Get all question groups for a license type and question type (active and inactive).
 */
export const getQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGet = <ThrowOnError extends boolean = false>(options: Options<GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetResponses, GetQuestionGroupsOperatorLicenseTypesLicenseTypeIdQuestionGroupsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license-types/{license_type_id}/question-groups',
        ...options
    });
};

/**
 * Create Question Group
 * Create a new question group.
 */
export const createQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPost = <ThrowOnError extends boolean = false>(options: Options<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostResponses, CreateQuestionGroupOperatorLicenseTypesLicenseTypeIdQuestionGroupsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license-types/{license_type_id}/question-groups',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Question Group
 * Soft delete a question group.
 */
export const deleteQuestionGroupOperatorQuestionGroupsGroupIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteResponses, DeleteQuestionGroupOperatorQuestionGroupsGroupIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/question-groups/{group_id}',
        ...options
    });
};

/**
 * Update Question Group
 * Update a question group (name and/or deleted_at).
 */
export const updateQuestionGroupOperatorQuestionGroupsGroupIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchResponses, UpdateQuestionGroupOperatorQuestionGroupsGroupIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/question-groups/{group_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Question Group Jurisdictions
 * Get jurisdictions that can use a question group, flagging the assigned ones.
 */
export const getQuestionGroupJurisdictions = <ThrowOnError extends boolean = false>(options: Options<GetQuestionGroupJurisdictionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetQuestionGroupJurisdictionsResponses, GetQuestionGroupJurisdictionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/question-groups/{group_id}/jurisdictions',
        ...options
    });
};

/**
 * Update Question Group Jurisdictions
 * Set which jurisdictions have a question group assigned.
 */
export const updateQuestionGroupJurisdictions = <ThrowOnError extends boolean = false>(options: Options<UpdateQuestionGroupJurisdictionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateQuestionGroupJurisdictionsResponses, UpdateQuestionGroupJurisdictionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/question-groups/{group_id}/jurisdictions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator License Fee Analysis
 * Price-point registration counts and collected fees for the license tab.
 */
export const getOperatorLicenseFeeAnalysis = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorLicenseFeeAnalysisData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorLicenseFeeAnalysisResponses, GetOperatorLicenseFeeAnalysisErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/license-fee-analysis',
        ...options
    });
};

/**
 * Get Operator Revenue Audit
 * Return live settled collections and contractual splits for finance audit.
 */
export const getOperatorRevenueAudit = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorRevenueAuditData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorRevenueAuditResponses, GetOperatorRevenueAuditErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/revenue-audit',
        ...options
    });
};

/**
 * Get Operator Revenue Audit Stripe Cash
 * Return current Stripe settlement and payout timing.
 */
export const getOperatorRevenueAuditStripeCash = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorRevenueAuditStripeCashData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorRevenueAuditStripeCashResponses, GetOperatorRevenueAuditStripeCashErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/revenue-audit/stripe-cash',
        ...options
    });
};

/**
 * Get Operator Portal Kpis
 * Period-comparison KPI tiles for the operator overview.
 */
export const getOperatorPortalKpis = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalKpisData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalKpisResponses, GetOperatorPortalKpisErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/kpis',
        ...options
    });
};

/**
 * Get Operator Portal Payment Periods
 * Four periods of received, new due, and end-of-period outstanding by rail.
 */
export const getOperatorPortalPaymentPeriods = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalPaymentPeriodsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalPaymentPeriodsResponses, GetOperatorPortalPaymentPeriodsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/payment-periods',
        ...options
    });
};

/**
 * Get Operator Portal Trends
 * Time-series for the operator portal overview (historic trends).
 */
export const getOperatorPortalTrends = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalTrendsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalTrendsResponses, GetOperatorPortalTrendsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends',
        ...options
    });
};

/**
 * Get Operator System Usage
 * Comparison roster and charts reconstructed from nightly usage snapshots.
 */
export const getOperatorSystemUsage = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorSystemUsageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorSystemUsageResponses, GetOperatorSystemUsageErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/system-usage',
        ...options
    });
};

/**
 * Get Operator System Usage Detail
 * Weekly and daily usage for one login identity.
 */
export const getOperatorSystemUsageDetail = <ThrowOnError extends boolean = false>(options: Options<GetOperatorSystemUsageDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorSystemUsageDetailResponses, GetOperatorSystemUsageDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/system-usage/{login_identity_id}',
        ...options
    });
};

/**
 * Get Operator Portal Foreclosure Vs Registrations
 * Foreclosure cases by LIS/NOD date vs new registrations for active jurisdictions.
 */
export const getOperatorPortalForeclosureVsRegistrations = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalForeclosureVsRegistrationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalForeclosureVsRegistrationsResponses, GetOperatorPortalForeclosureVsRegistrationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/foreclosure-vs-registrations',
        ...options
    });
};

/**
 * Get Operator Portal Notified Renewals
 * Renewals completed after a matching needs-attention notification.
 */
export const getOperatorPortalNotifiedRenewals = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalNotifiedRenewalsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalNotifiedRenewalsResponses, GetOperatorPortalNotifiedRenewalsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/notified-renewals',
        ...options
    });
};

/**
 * Get Operator Portal Needs Attention Compliance
 * Weekly paid and deregistered outcomes after needs-attention mail.
 */
export const getOperatorPortalNeedsAttentionCompliance = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalNeedsAttentionComplianceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalNeedsAttentionComplianceResponses, GetOperatorPortalNeedsAttentionComplianceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/needs-attention-compliance',
        ...options
    });
};

/**
 * Get Operator Portal Compliance Trends
 * Registration and renewal compliance rates over time for the operator overview.
 */
export const getOperatorPortalComplianceTrends = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalComplianceTrendsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalComplianceTrendsResponses, GetOperatorPortalComplianceTrendsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/compliance',
        ...options
    });
};

/**
 * Stream Operator Portal Trend Registrations
 */
export const streamOperatorPortalTrendRegistrations = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalTrendRegistrationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalTrendRegistrationsResponses, StreamOperatorPortalTrendRegistrationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/registrations',
        ...options
    });
};

/**
 * Stream Operator Portal Trend Inspections
 */
export const streamOperatorPortalTrendInspections = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalTrendInspectionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalTrendInspectionsResponses, StreamOperatorPortalTrendInspectionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/inspections',
        ...options
    });
};

/**
 * Stream Operator Portal Trend Payments
 */
export const streamOperatorPortalTrendPayments = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalTrendPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalTrendPaymentsResponses, StreamOperatorPortalTrendPaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/payments',
        ...options
    });
};

/**
 * Stream Operator Portal Trend Inspection Fees
 */
export const streamOperatorPortalTrendInspectionFees = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalTrendInspectionFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalTrendInspectionFeesResponses, StreamOperatorPortalTrendInspectionFeesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/inspection-fees',
        ...options
    });
};

/**
 * Stream Operator Portal Trend Refunds
 */
export const streamOperatorPortalTrendRefunds = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalTrendRefundsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalTrendRefundsResponses, StreamOperatorPortalTrendRefundsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/refunds',
        ...options
    });
};

/**
 * Stream Operator Portal Trend Remittance
 */
export const streamOperatorPortalTrendRemittance = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalTrendRemittanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalTrendRemittanceResponses, StreamOperatorPortalTrendRemittanceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/remittance',
        ...options
    });
};

/**
 * Stream Operator Portal Forecast
 */
export const streamOperatorPortalForecast = <ThrowOnError extends boolean = false>(options?: Options<StreamOperatorPortalForecastData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamOperatorPortalForecastResponses, StreamOperatorPortalForecastErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/forecast',
        ...options
    });
};

/**
 * Get Operator Portal Payment Lag
 */
export const getOperatorPortalPaymentLag = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalPaymentLagData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalPaymentLagResponses, GetOperatorPortalPaymentLagErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/trends/payment-lag',
        ...options
    });
};

/**
 * Get Operator Portal Activity
 * Recent activity for the operator portal overview.
 */
export const getOperatorPortalActivity = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorPortalActivityData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorPortalActivityResponses, GetOperatorPortalActivityErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/activity',
        ...options
    });
};

/**
 * Get Operator Hubspot Scorecard
 * HubSpot CRM counts for the operator HubSpot and Leadership dashboards.
 */
export const getOperatorHubspotScorecard = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorHubspotScorecardData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorHubspotScorecardResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/hubspot/scorecard',
        ...options
    });
};

/**
 * Get Operator Hubspot Closed Deals By Week
 * Closed-won HubSpot deals bucketed by Sunday-start week.
 */
export const getOperatorHubspotClosedDealsByWeek = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorHubspotClosedDealsByWeekData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorHubspotClosedDealsByWeekResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/hubspot/closed-deals-by-week',
        ...options
    });
};

/**
 * Get Operator Leadership Renewal Compliance
 * License-grain compliant and <30-days-overdue rates as of Pacific today.
 */
export const getOperatorLeadershipRenewalCompliance = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorLeadershipRenewalComplianceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorLeadershipRenewalComplianceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/leadership/renewal-compliance',
        ...options
    });
};

/**
 * Get Operator Leadership Receivables Overdue
 * Open checks and invoices awaiting payment for more than 30 days.
 */
export const getOperatorLeadershipReceivablesOverdue = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorLeadershipReceivablesOverdueData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorLeadershipReceivablesOverdueResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/leadership/receivables-overdue',
        ...options
    });
};

/**
 * Get Operator Leadership Registrations Renewals Initiated
 * Registration and renewal periods by first genuine payment initiation.
 */
export const getOperatorLeadershipRegistrationsRenewalsInitiated = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorLeadershipRegistrationsRenewalsInitiatedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorLeadershipRegistrationsRenewalsInitiatedResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/leadership/registrations-renewals-initiated',
        ...options
    });
};

/**
 * Get Operator Leadership Hera Remittance
 * HERA remittance dollars for this week, last week, this month, and last month.
 */
export const getOperatorLeadershipHeraRemittance = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorLeadershipHeraRemittanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorLeadershipHeraRemittanceResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/portal/leadership/hera-remittance',
        ...options
    });
};

/**
 * Get Info System Jurisdiction Summaries Endpoint
 * List jurisdictions with license types, FIPS/TIGER codes, and active/inactive counts.
 */
export const getInfoSystemJurisdictionSummaries = <ThrowOnError extends boolean = false>(options?: Options<GetInfoSystemJurisdictionSummariesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetInfoSystemJurisdictionSummariesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/info-system/jurisdictions',
        ...options
    });
};

/**
 * Get Info System Licenses Endpoint
 * List lightweight license rows for one jurisdiction and license type.
 */
export const getInfoSystemLicenses = <ThrowOnError extends boolean = false>(options: Options<GetInfoSystemLicensesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetInfoSystemLicensesResponses, GetInfoSystemLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/info-system/licenses',
        ...options
    });
};

/**
 * Get Attom Tax Assessor Status Endpoint
 * Live Athena diagnostics for incremental ATTOM tax_assessor extract partitions.
 */
export const getAttomTaxAssessorStatus = <ThrowOnError extends boolean = false>(options?: Options<GetAttomTaxAssessorStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAttomTaxAssessorStatusResponses, GetAttomTaxAssessorStatusErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/attom/tax-assessor-status',
        ...options
    });
};

/**
 * Get Attom Integration Status Endpoint
 * Fast ATTOM/Athena integration status for operator Setup.
 */
export const getAttomIntegrationStatus = <ThrowOnError extends boolean = false>(options?: Options<GetAttomIntegrationStatusData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAttomIntegrationStatusResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/attom/integration-status',
        ...options
    });
};

/**
 * Get Next Foreclosure Lender Prompt Endpoint
 * Return the next lender prompts, including a buffer of successors.
 */
export const getNextForeclosureLenderPrompt = <ThrowOnError extends boolean = false>(options?: Options<GetNextForeclosureLenderPromptData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNextForeclosureLenderPromptResponses, GetNextForeclosureLenderPromptErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-instigator/lenders/next',
        ...options
    });
};

/**
 * Submit Foreclosure Instigator Label Endpoint
 * Append one lender/case answer and return its weighted consensus.
 */
export const submitForeclosureInstigatorLabel = <ThrowOnError extends boolean = false>(options: Options<SubmitForeclosureInstigatorLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitForeclosureInstigatorLabelResponses, SubmitForeclosureInstigatorLabelErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-instigator/labels',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Undo Foreclosure Instigator Label Endpoint
 * Retract this operator's latest effective answer for the Back action.
 */
export const undoForeclosureInstigatorLabel = <ThrowOnError extends boolean = false>(options?: Options<UndoForeclosureInstigatorLabelData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UndoForeclosureInstigatorLabelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-instigator/labels/undo',
        ...options
    });
};

/**
 * Get Foreclosure Instigator Metrics Endpoint
 * Aggregate label quality for operator admins.
 */
export const getForeclosureInstigatorMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetForeclosureInstigatorMetricsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetForeclosureInstigatorMetricsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-instigator/metrics',
        ...options
    });
};

/**
 * Set Foreclosure Instigator Gold Endpoint
 * Create or update a hidden-gold lender prompt.
 */
export const setForeclosureInstigatorGold = <ThrowOnError extends boolean = false>(options: Options<SetForeclosureInstigatorGoldData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetForeclosureInstigatorGoldResponses, SetForeclosureInstigatorGoldErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-instigator/admin/gold',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Adjudicate Foreclosure Instigator Endpoint
 * Publish an expert lender-level or case-level decision.
 */
export const adjudicateForeclosureInstigator = <ThrowOnError extends boolean = false>(options: Options<AdjudicateForeclosureInstigatorData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<AdjudicateForeclosureInstigatorResponses, AdjudicateForeclosureInstigatorErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-instigator/admin/adjudicate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Foreclosure Cases Endpoint
 * List indexed ATTOM foreclosure cases, one page at a time.
 *
 * Rows carry license linkage and live-link settings. For unfiltered requests,
 * linkage is limited to jurisdictions represented on the current page.
 * ``total_count`` is the number of rows matching the current filters, not a
 * truncated cap.
 */
export const getOperatorForeclosureCases = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorForeclosureCasesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorForeclosureCasesResponses, GetOperatorForeclosureCasesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases',
        ...options
    });
};

/**
 * Get Operator Foreclosure Case Filter Values Endpoint
 * Distinct display strings for one Cases-table filter popover.
 */
export const getOperatorForeclosureCaseFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetOperatorForeclosureCaseFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorForeclosureCaseFilterValuesResponses, GetOperatorForeclosureCaseFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/filter-values',
        ...options
    });
};

/**
 * Get Operator Foreclosure Case Map Pins Endpoint
 * Pins or clusters for cases matching the current list filters.
 */
export const getOperatorForeclosureCaseMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorForeclosureCaseMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorForeclosureCaseMapPinsResponses, GetOperatorForeclosureCaseMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/map-pins',
        ...options
    });
};

/**
 * Get Operator Foreclosure Review Status Summary Endpoint
 * Jurisdiction counts by review status for the Cases overview charts.
 */
export const getOperatorForeclosureReviewStatusSummary = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorForeclosureReviewStatusSummaryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorForeclosureReviewStatusSummaryResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/review-status-summary',
        ...options
    });
};

/**
 * Get Operator Foreclosure Case Chart Data Endpoint
 * Start-date counts and review-status activity for Cases insight charts.
 *
 * Omit ``jurisdiction_ids`` for the same universe as the unfiltered case list.
 */
export const getOperatorForeclosureCaseChartData = <ThrowOnError extends boolean = false>(options?: Options<GetOperatorForeclosureCaseChartDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetOperatorForeclosureCaseChartDataResponses, GetOperatorForeclosureCaseChartDataErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/chart-data',
        ...options
    });
};

/**
 * Suggest Operator Foreclosure Case Parties Endpoint
 * Explicitly recompute OMT/AMS/registrant suggestions for one case.
 */
export const suggestOperatorForeclosureCaseParties = <ThrowOnError extends boolean = false>(options: Options<SuggestOperatorForeclosureCasePartiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SuggestOperatorForeclosureCasePartiesResponses, SuggestOperatorForeclosureCasePartiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/suggest-parties',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Suggest Operator Foreclosure Case Review Endpoint
 * Explicitly recompute review status/comment suggestions for one case.
 */
export const suggestOperatorForeclosureCaseReview = <ThrowOnError extends boolean = false>(options: Options<SuggestOperatorForeclosureCaseReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SuggestOperatorForeclosureCaseReviewResponses, SuggestOperatorForeclosureCaseReviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/suggest-review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Foreclosure License Assignment Candidates Endpoint
 * List exact address/APN license matches for selected jurisdictions.
 */
export const getOperatorForeclosureLicenseAssignmentCandidates = <ThrowOnError extends boolean = false>(options: Options<GetOperatorForeclosureLicenseAssignmentCandidatesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorForeclosureLicenseAssignmentCandidatesResponses, GetOperatorForeclosureLicenseAssignmentCandidatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/license-assignment-candidates',
        ...options
    });
};

/**
 * Assign Operator Foreclosure Licenses Endpoint
 * Revalidate and assign selected unique license matches.
 */
export const assignOperatorForeclosureLicenses = <ThrowOnError extends boolean = false>(options: Options<AssignOperatorForeclosureLicensesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignOperatorForeclosureLicensesResponses, AssignOperatorForeclosureLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/assign-licenses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Foreclosure License Matches Endpoint
 * Return the linked license or fuzzy APN/address candidates for a case.
 */
export const getOperatorForeclosureLicenseMatches = <ThrowOnError extends boolean = false>(options: Options<GetOperatorForeclosureLicenseMatchesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorForeclosureLicenseMatchesResponses, GetOperatorForeclosureLicenseMatchesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/license-matches',
        ...options
    });
};

/**
 * Link Operator Foreclosure Case To License Endpoint
 * Apply the case number to a selected foreclosure license.
 */
export const linkOperatorForeclosureCaseToLicense = <ThrowOnError extends boolean = false>(options: Options<LinkOperatorForeclosureCaseToLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkOperatorForeclosureCaseToLicenseResponses, LinkOperatorForeclosureCaseToLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/link-license',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Operator Foreclosure Case Review Endpoint
 * Update reviewed / registration-needed flags for a foreclosure case.
 */
export const updateOperatorForeclosureCaseReview = <ThrowOnError extends boolean = false>(options: Options<UpdateOperatorForeclosureCaseReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOperatorForeclosureCaseReviewResponses, UpdateOperatorForeclosureCaseReviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Foreclosure Case Review History Endpoint
 * Return newest-first review-status changes for one foreclosure case.
 */
export const getOperatorForeclosureCaseReviewHistory = <ThrowOnError extends boolean = false>(options: Options<GetOperatorForeclosureCaseReviewHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorForeclosureCaseReviewHistoryResponses, GetOperatorForeclosureCaseReviewHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/review-history',
        ...options
    });
};

/**
 * Preflight Operator Bulk Create Unregistered Endpoint
 * Check which selected foreclosure cases can become unregistered properties.
 */
export const preflightOperatorBulkCreateUnregistered = <ThrowOnError extends boolean = false>(options: Options<PreflightOperatorBulkCreateUnregisteredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreflightOperatorBulkCreateUnregisteredResponses, PreflightOperatorBulkCreateUnregisteredErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/bulk-create-unregistered-preflight',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk Create Operator Unregistered From Cases Endpoint
 * Create unregistered properties for a chunk of foreclosure cases.
 */
export const bulkCreateOperatorUnregisteredFromCases = <ThrowOnError extends boolean = false>(options: Options<BulkCreateOperatorUnregisteredFromCasesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BulkCreateOperatorUnregisteredFromCasesResponses, BulkCreateOperatorUnregisteredFromCasesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/bulk-create-unregistered',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Foreclosure Unregistered Match Endpoint
 * Return the case-number attachment or address suggestions for this case.
 */
export const getOperatorForeclosureUnregisteredMatch = <ThrowOnError extends boolean = false>(options: Options<GetOperatorForeclosureUnregisteredMatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorForeclosureUnregisteredMatchResponses, GetOperatorForeclosureUnregisteredMatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/unregistered-match',
        ...options
    });
};

/**
 * Link Operator Foreclosure Case To Unregistered Endpoint
 * Apply the case number to a selected unregistered property.
 */
export const linkOperatorForeclosureCaseToUnregistered = <ThrowOnError extends boolean = false>(options: Options<LinkOperatorForeclosureCaseToUnregisteredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkOperatorForeclosureCaseToUnregisteredResponses, LinkOperatorForeclosureCaseToUnregisteredErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/foreclosure-cases/link-unregistered',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Operator Address Resolution Lookup Endpoint
 * Resolve an address against the geocoding cache, Geocodio, and Google Maps.
 *
 * Diagnostic lookup for the operator Setup page: shows raw answers from each
 * source (including Geocodio answers the normal pipeline would reject) so the
 * operator can pick or correct the cached resolution.
 */
export const operatorAddressResolutionLookup = <ThrowOnError extends boolean = false>(options: Options<OperatorAddressResolutionLookupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OperatorAddressResolutionLookupResponses, OperatorAddressResolutionLookupErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/address-resolution/lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Operator Address Resolution Save Endpoint
 * Store an operator-chosen resolution in the geocoding cache.
 *
 * The entry is flagged as a manual override: automatic geocoding will not
 * replace it and cache reads trust it without validation or expiry.
 */
export const operatorAddressResolutionSave = <ThrowOnError extends boolean = false>(options: Options<OperatorAddressResolutionSaveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OperatorAddressResolutionSaveResponses, OperatorAddressResolutionSaveErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/address-resolution/save',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Residential Owner Access
 * Whether the operator catalog is turned on.
 */
export const getResidentialOwnerAccess = <ThrowOnError extends boolean = false>(options?: Options<GetResidentialOwnerAccessData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetResidentialOwnerAccessResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/access',
        ...options
    });
};

/**
 * List Residential Owner Jurisdictions
 * Long-Term Rental jurisdictions. Empty when the feature is off.
 */
export const listResidentialOwnerJurisdictions = <ThrowOnError extends boolean = false>(options?: Options<ListResidentialOwnerJurisdictionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListResidentialOwnerJurisdictionsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/jurisdictions',
        ...options
    });
};

/**
 * List Mailing Addresses
 */
export const listResidentialOwnerMailingAddresses = <ThrowOnError extends boolean = false>(options: Options<ListResidentialOwnerMailingAddressesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListResidentialOwnerMailingAddressesResponses, ListResidentialOwnerMailingAddressesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/mailing-addresses',
        ...options
    });
};

/**
 * Get Mailing Address
 */
export const getResidentialOwnerMailingAddress = <ThrowOnError extends boolean = false>(options: Options<GetResidentialOwnerMailingAddressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidentialOwnerMailingAddressResponses, GetResidentialOwnerMailingAddressErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/mailing-addresses/{address_id}',
        ...options
    });
};

/**
 * Update Mailing Address
 */
export const updateResidentialOwnerMailingAddress = <ThrowOnError extends boolean = false>(options: Options<UpdateResidentialOwnerMailingAddressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateResidentialOwnerMailingAddressResponses, UpdateResidentialOwnerMailingAddressErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/mailing-addresses/{address_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unlink Mailing Address
 */
export const unlinkResidentialOwnerMailingAddress = <ThrowOnError extends boolean = false>(options: Options<UnlinkResidentialOwnerMailingAddressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnlinkResidentialOwnerMailingAddressResponses, UnlinkResidentialOwnerMailingAddressErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/mailing-addresses/{address_id}/unlink',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Link Mailing Addresses
 */
export const linkResidentialOwnerMailingAddresses = <ThrowOnError extends boolean = false>(options: Options<LinkResidentialOwnerMailingAddressesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkResidentialOwnerMailingAddressesResponses, LinkResidentialOwnerMailingAddressesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/links',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Companies
 */
export const listResidentialOwnerCompanies = <ThrowOnError extends boolean = false>(options: Options<ListResidentialOwnerCompaniesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListResidentialOwnerCompaniesResponses, ListResidentialOwnerCompaniesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/companies',
        ...options
    });
};

/**
 * Get Company
 */
export const getResidentialOwnerCompany = <ThrowOnError extends boolean = false>(options: Options<GetResidentialOwnerCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidentialOwnerCompanyResponses, GetResidentialOwnerCompanyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/companies/{company_id}',
        ...options
    });
};

/**
 * Update Company
 */
export const updateResidentialOwnerCompany = <ThrowOnError extends boolean = false>(options: Options<UpdateResidentialOwnerCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateResidentialOwnerCompanyResponses, UpdateResidentialOwnerCompanyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/companies/{company_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mailing Address History
 * Return link, confirm, and enrichment history for one mailing address.
 */
export const getResidentialOwnerMailingAddressHistory = <ThrowOnError extends boolean = false>(options: Options<GetResidentialOwnerMailingAddressHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResidentialOwnerMailingAddressHistoryResponses, GetResidentialOwnerMailingAddressHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/mailing-addresses/{address_id}/history',
        ...options
    });
};

/**
 * Confirm Company Fields
 */
export const confirmResidentialOwnerCompanyFields = <ThrowOnError extends boolean = false>(options: Options<ConfirmResidentialOwnerCompanyFieldsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfirmResidentialOwnerCompanyFieldsResponses, ConfirmResidentialOwnerCompanyFieldsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/companies/{company_id}/confirm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reject Company Fields
 */
export const rejectResidentialOwnerCompanyFields = <ThrowOnError extends boolean = false>(options: Options<RejectResidentialOwnerCompanyFieldsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RejectResidentialOwnerCompanyFieldsResponses, RejectResidentialOwnerCompanyFieldsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/companies/{company_id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Merge Owner Companies
 */
export const mergeResidentialOwnerCompanies = <ThrowOnError extends boolean = false>(options: Options<MergeResidentialOwnerCompaniesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MergeResidentialOwnerCompaniesResponses, MergeResidentialOwnerCompaniesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/merges',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enqueue Refresh
 */
export const enqueueResidentialOwnerRefresh = <ThrowOnError extends boolean = false>(options: Options<EnqueueResidentialOwnerRefreshData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnqueueResidentialOwnerRefreshResponses, EnqueueResidentialOwnerRefreshErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/jobs/refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Enqueue Enrichment
 */
export const enqueueResidentialOwnerEnrichment = <ThrowOnError extends boolean = false>(options: Options<EnqueueResidentialOwnerEnrichmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EnqueueResidentialOwnerEnrichmentResponses, EnqueueResidentialOwnerEnrichmentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/jobs/enrich',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Jobs
 */
export const listResidentialOwnerJobs = <ThrowOnError extends boolean = false>(options: Options<ListResidentialOwnerJobsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListResidentialOwnerJobsResponses, ListResidentialOwnerJobsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/jobs',
        ...options
    });
};

/**
 * Cancel Job
 */
export const cancelResidentialOwnerJob = <ThrowOnError extends boolean = false>(options: Options<CancelResidentialOwnerJobData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelResidentialOwnerJobResponses, CancelResidentialOwnerJobErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/jobs/{job_id}/cancel',
        ...options
    });
};

/**
 * Latest Refresh Run
 */
export const getLatestResidentialOwnerRefreshRun = <ThrowOnError extends boolean = false>(options: Options<GetLatestResidentialOwnerRefreshRunData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLatestResidentialOwnerRefreshRunResponses, GetLatestResidentialOwnerRefreshRunErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/residential-property-owners/refresh-runs/latest',
        ...options
    });
};

/**
 * List Company Question Tabs
 * List company-question subtabs grouped by their list-column prefix.
 */
export const listCompanyQuestionTabs = <ThrowOnError extends boolean = false>(options?: Options<ListCompanyQuestionTabsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListCompanyQuestionTabsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/company-question-answers',
        ...options
    });
};

/**
 * List Company Question Answers
 * List deduplicated answers for one company-question subtab.
 */
export const listCompanyQuestionAnswers = <ThrowOnError extends boolean = false>(options: Options<ListCompanyQuestionAnswersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListCompanyQuestionAnswersResponses, ListCompanyQuestionAnswersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/company-question-answers/{tab_key}',
        ...options
    });
};

/**
 * Rewrite Company Question Answers
 * Replace a company answer on licenses that still match the active filters.
 */
export const rewriteCompanyQuestionAnswers = <ThrowOnError extends boolean = false>(options: Options<RewriteCompanyQuestionAnswersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RewriteCompanyQuestionAnswersResponses, RewriteCompanyQuestionAnswersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/company-question-answers/{tab_key}/rewrite',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Str Listings
 * List active STR marketplace listings.
 */
export const getStrListings = <ThrowOnError extends boolean = false>(options?: Options<GetStrListingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrListingsResponses, GetStrListingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-listings',
        ...options
    });
};

/**
 * Get Str Listing Filter Values
 * Distinct display values for one listing column.
 */
export const getStrListingFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetStrListingFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStrListingFilterValuesResponses, GetStrListingFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-listings/filter-values',
        ...options
    });
};

/**
 * Get Str Listing Map Pins
 * Coordinates for filtered listings. Rows without coordinates are omitted.
 */
export const getStrListingMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetStrListingMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrListingMapPinsResponses, GetStrListingMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-listings/map-pins',
        ...options
    });
};

/**
 * Get Str Properties
 * List one row per property.
 *
 * Same, two-units-at-one-address, and portion marks share a row.
 */
export const getStrProperties = <ThrowOnError extends boolean = false>(options?: Options<GetStrPropertiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrPropertiesResponses, GetStrPropertiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-properties',
        ...options
    });
};

/**
 * Get Str Property Filter Values
 * Distinct display values for one property column.
 */
export const getStrPropertyFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetStrPropertyFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStrPropertyFilterValuesResponses, GetStrPropertyFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-properties/filter-values',
        ...options
    });
};

/**
 * Get Str Property Map Pins
 * One representative pin per filtered property that has coordinates.
 */
export const getStrPropertyMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetStrPropertyMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrPropertyMapPinsResponses, GetStrPropertyMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-properties/map-pins',
        ...options
    });
};

/**
 * Get Str Property Detail
 * One catalog property with listings, regions, and licenses.
 */
export const getStrPropertyDetail = <ThrowOnError extends boolean = false>(options: Options<GetStrPropertyDetailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStrPropertyDetailResponses, GetStrPropertyDetailErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-properties/{representative_id}',
        ...options
    });
};

/**
 * Get Next Str Address Mapping
 * Return the highest-ranked property awaiting mapping.
 *
 * ``listing_city`` keeps properties whose listing city matches, ignoring
 * case and surrounding spaces. A blank listing city does not match.
 */
export const getNextStrAddressMapping = <ThrowOnError extends boolean = false>(options?: Options<GetNextStrAddressMappingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNextStrAddressMappingResponses, GetNextStrAddressMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/next',
        ...options
    });
};

/**
 * Get Str Address Mapping Cities
 * Listing cities on properties still waiting in the address-mapping queue.
 */
export const getStrAddressMappingCities = <ThrowOnError extends boolean = false>(options?: Options<GetStrAddressMappingCitiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrAddressMappingCitiesResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/cities',
        ...options
    });
};

/**
 * Get Str Address Mapping Target
 * Load a listing or property selected from a catalog.
 */
export const getStrAddressMappingTarget = <ThrowOnError extends boolean = false>(options?: Options<GetStrAddressMappingTargetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrAddressMappingTargetResponses, GetStrAddressMappingTargetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/target',
        ...options
    });
};

/**
 * Confirm Str Address Mapping
 * Save an edited address and attach ATTOM when selection did not already.
 */
export const confirmStrAddressMapping = <ThrowOnError extends boolean = false>(options: Options<ConfirmStrAddressMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfirmStrAddressMappingResponses, ConfirmStrAddressMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/confirm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lookup Str Attom Parcel
 * Look up ATTOM for a selected address and attach a single match.
 */
export const lookupStrAttomParcel = <ThrowOnError extends boolean = false>(options: Options<LookupStrAttomParcelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LookupStrAttomParcelResponses, LookupStrAttomParcelErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/attom-lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Skip Str Address Mapping
 * Defer one property from the automatic queue.
 */
export const skipStrAddressMapping = <ThrowOnError extends boolean = false>(options: Options<SkipStrAddressMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SkipStrAddressMappingResponses, SkipStrAddressMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/skip',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Undo Str Address Mapping
 * Remove the current operator's latest address decision.
 */
export const undoStrAddressMapping = <ThrowOnError extends boolean = false>(options?: Options<UndoStrAddressMappingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UndoStrAddressMappingResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/undo',
        ...options
    });
};

/**
 * Get Str Address Mapping Nearby
 * List ATTOM properties near the property centroid with one house number.
 *
 * The pin is the trusted same/portion centroid, not only the opened listing.
 * The ATTOM key stays on the server. A property with no coordinates returns
 * an explanation instead of calling ATTOM.
 */
export const getStrAddressMappingNearby = <ThrowOnError extends boolean = false>(options: Options<GetStrAddressMappingNearbyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetStrAddressMappingNearbyResponses, GetStrAddressMappingNearbyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-address-mapping/nearby',
        ...options
    });
};

/**
 * Suggest Str Unit Classifications
 * Suggest property types for listings in the current filter that have no override.
 */
export const suggestStrUnitClassifications = <ThrowOnError extends boolean = false>(options: Options<SuggestStrUnitClassificationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SuggestStrUnitClassificationsResponses, SuggestStrUnitClassificationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-unit-classifications/suggest',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set Str Listing Unit Category
 * Save or clear the property type override for one listing.
 */
export const setStrListingUnitCategory = <ThrowOnError extends boolean = false>(options: Options<SetStrListingUnitCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetStrListingUnitCategoryResponses, SetStrListingUnitCategoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-listings/{listing_id}/unit-category',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set Str Property Unit Category
 * Save or clear the property type override for every listing in a property.
 */
export const setStrPropertyUnitCategory = <ThrowOnError extends boolean = false>(options: Options<SetStrPropertyUnitCategoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetStrPropertyUnitCategoryResponses, SetStrPropertyUnitCategoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-properties/{representative_id}/unit-category',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Next Str Dedup Pair Endpoint
 * Return the next listing pairs, including a buffer of successors.
 */
export const getNextStrDedupPair = <ThrowOnError extends boolean = false>(options?: Options<GetNextStrDedupPairData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetNextStrDedupPairResponses, GetNextStrDedupPairErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-dedup/pairs/next',
        ...options
    });
};

/**
 * Submit Str Dedup Label Endpoint
 * Append one yes / no / portion / unknown answer.
 */
export const submitStrDedupLabel = <ThrowOnError extends boolean = false>(options: Options<SubmitStrDedupLabelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitStrDedupLabelResponses, SubmitStrDedupLabelErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-dedup/labels',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Undo Str Dedup Label Endpoint
 * Retract this reviewer's latest answer.
 */
export const undoStrDedupLabel = <ThrowOnError extends boolean = false>(options?: Options<UndoStrDedupLabelData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<UndoStrDedupLabelResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-dedup/labels/undo',
        ...options
    });
};

/**
 * Lookup Str Dedup Listing Endpoint
 * Load one active listing by its Hera id or by platform and marketplace id.
 */
export const lookupStrDedupListing = <ThrowOnError extends boolean = false>(options?: Options<LookupStrDedupListingData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LookupStrDedupListingResponses, LookupStrDedupListingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-dedup/listings/lookup',
        ...options
    });
};

/**
 * Load Manual Str Dedup Pair Endpoint
 * Show a looked-up listing beside the listing that stays on the other side.
 */
export const loadManualStrDedupPair = <ThrowOnError extends boolean = false>(options: Options<LoadManualStrDedupPairData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoadManualStrDedupPairResponses, LoadManualStrDedupPairErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-dedup/pairs/manual',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Str Dedup Metrics Endpoint
 * Cross-check agreement for operator admins.
 */
export const getStrDedupMetrics = <ThrowOnError extends boolean = false>(options?: Options<GetStrDedupMetricsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetStrDedupMetricsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/str-dedup/metrics',
        ...options
    });
};

/**
 * List Str Properties
 * Paginated short-term rentals for the signed-in jurisdiction.
 */
export const listGovernmentStrProperties = <ThrowOnError extends boolean = false>(options?: Options<ListGovernmentStrPropertiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListGovernmentStrPropertiesResponses, ListGovernmentStrPropertiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/str-properties',
        ...options
    });
};

/**
 * Get Str Property Filter Values
 * Distinct values for one property column in the signed-in jurisdiction.
 */
export const getGovernmentStrPropertyFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentStrPropertyFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentStrPropertyFilterValuesResponses, GetGovernmentStrPropertyFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/str-properties/filter-values',
        ...options
    });
};

/**
 * List Str Property Pins
 * Map pins for the same jurisdiction scope as the list.
 */
export const listGovernmentStrPropertyPins = <ThrowOnError extends boolean = false>(options?: Options<ListGovernmentStrPropertyPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListGovernmentStrPropertyPinsResponses, ListGovernmentStrPropertyPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/str-properties/map-pins',
        ...options
    });
};

/**
 * Get Str Property
 * One property. Foreign and missing groups return the same not-found.
 */
export const getGovernmentStrProperty = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentStrPropertyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentStrPropertyResponses, GetGovernmentStrPropertyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/str-properties/{group_id}',
        ...options
    });
};

/**
 * Search Government Users For Impersonation Endpoint
 * Search government users by email, name, or jurisdiction (operators only).
 */
export const searchGovernmentUsersForImpersonation = <ThrowOnError extends boolean = false>(options?: Options<SearchGovernmentUsersForImpersonationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SearchGovernmentUsersForImpersonationResponses, SearchGovernmentUsersForImpersonationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/impersonation/search-users',
        ...options
    });
};

/**
 * Get Government Impersonation Me Endpoint
 * Return the government user an operator is viewing as.
 */
export const getGovernmentImpersonationMe = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentImpersonationMeData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentImpersonationMeResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/impersonation/me',
        ...options
    });
};

/**
 * Get Government Jurisdiction Endpoint
 * Get the current government user's jurisdiction.
 */
export const getGovernmentJurisdiction = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentJurisdictionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentJurisdictionResponses, GetGovernmentJurisdictionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/jurisdiction',
        ...options
    });
};

/**
 * Get Government License Type Configurations Endpoint
 * Get license type configurations for the current government user's jurisdiction.
 */
export const getGovernmentLicenseTypeConfigurations = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentLicenseTypeConfigurationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentLicenseTypeConfigurationsResponses, GetGovernmentLicenseTypeConfigurationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/license_type_configurations',
        ...options
    });
};

/**
 * Create Government Ordinance Version Endpoint
 * Add a historic ordinance rule snapshot (same semantics as operator).
 */
export const createGovernmentOrdinanceVersion = <ThrowOnError extends boolean = false>(options: Options<CreateGovernmentOrdinanceVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateGovernmentOrdinanceVersionResponses, CreateGovernmentOrdinanceVersionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/ordinance_versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Government Ordinance Version Endpoint
 * Delete a historic ordinance row for the logged-in government's jurisdiction.
 */
export const deleteGovernmentOrdinanceVersion = <ThrowOnError extends boolean = false>(options: Options<DeleteGovernmentOrdinanceVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteGovernmentOrdinanceVersionResponses, DeleteGovernmentOrdinanceVersionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/ordinance_versions/{ordinance_version_id}',
        ...options
    });
};

/**
 * Update Government Ordinance Version Endpoint
 * Update a historic ordinance row for the logged-in government's jurisdiction.
 */
export const updateGovernmentOrdinanceVersion = <ThrowOnError extends boolean = false>(options: Options<UpdateGovernmentOrdinanceVersionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateGovernmentOrdinanceVersionResponses, UpdateGovernmentOrdinanceVersionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/jurisdictions/{jurisdiction_id}/license_type_configurations/{configuration_id}/ordinance_versions/{ordinance_version_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Export Government Ordinances Csv Endpoint
 * CSV of ordinance rows (live + historic) for the logged-in jurisdiction only.
 */
export const exportGovernmentOrdinancesCsv = <ThrowOnError extends boolean = false>(options?: Options<ExportGovernmentOrdinancesCsvData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExportGovernmentOrdinancesCsvResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/ordinances/export.csv',
        ...options
    });
};

/**
 * Dryrun Government Ordinance Import Endpoint
 * Validate and transform ordinance import rows for this jurisdiction only (no writes).
 */
export const dryrunGovernmentOrdinanceImport = <ThrowOnError extends boolean = false>(options: Options<DryrunGovernmentOrdinanceImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunGovernmentOrdinanceImportResponses, DryrunGovernmentOrdinanceImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/ordinances/import/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Apply Government Ordinance Import Endpoint
 * Upsert ordinance versions from a spreadsheet for this jurisdiction only.
 */
export const applyGovernmentOrdinanceImport = <ThrowOnError extends boolean = false>(options: Options<ApplyGovernmentOrdinanceImportData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplyGovernmentOrdinanceImportResponses, ApplyGovernmentOrdinanceImportErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/ordinances/import',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Government Saved Import Mappings Endpoint
 * List saved import mappings for the current user and upload type.
 */
export const listGovernmentSavedImportMappings = <ThrowOnError extends boolean = false>(options: Options<ListGovernmentSavedImportMappingsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListGovernmentSavedImportMappingsResponses, ListGovernmentSavedImportMappingsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/saved-import-mappings',
        ...options
    });
};

/**
 * Create Government Saved Import Mapping Endpoint
 * Create a saved import mapping for the current user.
 */
export const createGovernmentSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<CreateGovernmentSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateGovernmentSavedImportMappingResponses, CreateGovernmentSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/saved-import-mappings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Government Temp File Ordinance Field Mapping
 * Infer (or load saved) column mapping for ordinance bulk import.
 */
export const getGovernmentOrdinanceFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentOrdinanceFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentOrdinanceFieldMappingForTempFileResponses, GetGovernmentOrdinanceFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/tempfiles/{token}/ordinance_field_mapping',
        ...options
    });
};

/**
 * Get Government Portal Kpis
 * Period-comparison KPI tiles for the government overview.
 */
export const getGovernmentPortalKpis = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalKpisData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalKpisResponses, GetGovernmentPortalKpisErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/kpis',
        ...options
    });
};

/**
 * Get Government Portal Trends
 * Time-series for the government portal overview (historic trends).
 */
export const getGovernmentPortalTrends = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalTrendsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalTrendsResponses, GetGovernmentPortalTrendsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends',
        ...options
    });
};

/**
 * Get Government Portal Foreclosure Vs Registrations
 * Foreclosure cases by LIS/NOD date vs new registrations for this jurisdiction.
 */
export const getGovernmentPortalForeclosureVsRegistrations = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalForeclosureVsRegistrationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalForeclosureVsRegistrationsResponses, GetGovernmentPortalForeclosureVsRegistrationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/foreclosure-vs-registrations',
        ...options
    });
};

/**
 * Get Government Portal Notified Renewals
 * Renewals completed after a matching needs-attention notification.
 */
export const getGovernmentPortalNotifiedRenewals = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalNotifiedRenewalsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalNotifiedRenewalsResponses, GetGovernmentPortalNotifiedRenewalsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/notified-renewals',
        ...options
    });
};

/**
 * Get Government Portal Compliance Trends
 * Registration and renewal compliance rates over time for this jurisdiction.
 */
export const getGovernmentPortalComplianceTrends = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalComplianceTrendsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalComplianceTrendsResponses, GetGovernmentPortalComplianceTrendsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/compliance',
        ...options
    });
};

/**
 * Stream Government Portal Trend Registrations
 */
export const streamGovernmentPortalTrendRegistrations = <ThrowOnError extends boolean = false>(options?: Options<StreamGovernmentPortalTrendRegistrationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamGovernmentPortalTrendRegistrationsResponses, StreamGovernmentPortalTrendRegistrationsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/registrations',
        ...options
    });
};

/**
 * Stream Government Portal Trend Inspections
 */
export const streamGovernmentPortalTrendInspections = <ThrowOnError extends boolean = false>(options?: Options<StreamGovernmentPortalTrendInspectionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamGovernmentPortalTrendInspectionsResponses, StreamGovernmentPortalTrendInspectionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/inspections',
        ...options
    });
};

/**
 * Stream Government Portal Trend Payments
 */
export const streamGovernmentPortalTrendPayments = <ThrowOnError extends boolean = false>(options?: Options<StreamGovernmentPortalTrendPaymentsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamGovernmentPortalTrendPaymentsResponses, StreamGovernmentPortalTrendPaymentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/payments',
        ...options
    });
};

/**
 * Stream Government Portal Trend Inspection Fees
 */
export const streamGovernmentPortalTrendInspectionFees = <ThrowOnError extends boolean = false>(options?: Options<StreamGovernmentPortalTrendInspectionFeesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamGovernmentPortalTrendInspectionFeesResponses, StreamGovernmentPortalTrendInspectionFeesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/inspection-fees',
        ...options
    });
};

/**
 * Stream Government Portal Trend Refunds
 */
export const streamGovernmentPortalTrendRefunds = <ThrowOnError extends boolean = false>(options?: Options<StreamGovernmentPortalTrendRefundsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamGovernmentPortalTrendRefundsResponses, StreamGovernmentPortalTrendRefundsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/refunds',
        ...options
    });
};

/**
 * Stream Government Portal Trend Remittance
 */
export const streamGovernmentPortalTrendRemittance = <ThrowOnError extends boolean = false>(options?: Options<StreamGovernmentPortalTrendRemittanceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StreamGovernmentPortalTrendRemittanceResponses, StreamGovernmentPortalTrendRemittanceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/remittance',
        ...options
    });
};

/**
 * Get Government Portal Payment Lag
 */
export const getGovernmentPortalPaymentLag = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalPaymentLagData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalPaymentLagResponses, GetGovernmentPortalPaymentLagErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/trends/payment-lag',
        ...options
    });
};

/**
 * Get Government Portal Activity
 * Recent activity for the government portal overview.
 */
export const getGovernmentPortalActivity = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentPortalActivityData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentPortalActivityResponses, GetGovernmentPortalActivityErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/portal/activity',
        ...options
    });
};

/**
 * Update Registrant Login Identity Government Endpoint
 * Mark whether a registrant portal login receives accounts / invoice emails.
 */
export const updateRegistrantLoginIdentityGovernment = <ThrowOnError extends boolean = false>(options: Options<UpdateRegistrantLoginIdentityGovernmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateRegistrantLoginIdentityGovernmentResponses, UpdateRegistrantLoginIdentityGovernmentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/registrant-login-identities/{login_identity_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Government Registrant Account Accounts Contact Endpoint
 * Set accounts-contact for a registrant account (portal users and/or pre-login).
 */
export const updateGovernmentRegistrantAccountAccountsContact = <ThrowOnError extends boolean = false>(options: Options<UpdateGovernmentRegistrantAccountAccountsContactData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateGovernmentRegistrantAccountAccountsContactResponses, UpdateGovernmentRegistrantAccountAccountsContactErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/registrant-accounts/{registrant_account_id}/accounts-contact',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Government Foreclosure Cases Endpoint
 * List indexed ATTOM foreclosure cases for the government user's jurisdiction.
 */
export const getGovernmentForeclosureCases = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentForeclosureCasesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentForeclosureCasesResponses, GetGovernmentForeclosureCasesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases',
        ...options
    });
};

/**
 * Get Government Foreclosure Case Filter Values Endpoint
 * Distinct display strings for one Cases-table filter popover.
 */
export const getGovernmentForeclosureCaseFilterValues = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentForeclosureCaseFilterValuesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentForeclosureCaseFilterValuesResponses, GetGovernmentForeclosureCaseFilterValuesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/filter-values',
        ...options
    });
};

/**
 * Get Government Foreclosure Case Map Pins Endpoint
 * Pins or clusters for cases matching the current list filters.
 */
export const getGovernmentForeclosureCaseMapPins = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentForeclosureCaseMapPinsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentForeclosureCaseMapPinsResponses, GetGovernmentForeclosureCaseMapPinsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/map-pins',
        ...options
    });
};

/**
 * Get Government Foreclosure Case Chart Data Endpoint
 * Start-date counts and review-status activity for the government Cases page.
 */
export const getGovernmentForeclosureCaseChartData = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentForeclosureCaseChartDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentForeclosureCaseChartDataResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/chart-data',
        ...options
    });
};

/**
 * Suggest Government Foreclosure Case Parties Endpoint
 * Explicitly recompute OMT/AMS/registrant suggestions for one case.
 */
export const suggestGovernmentForeclosureCaseParties = <ThrowOnError extends boolean = false>(options: Options<SuggestGovernmentForeclosureCasePartiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SuggestGovernmentForeclosureCasePartiesResponses, SuggestGovernmentForeclosureCasePartiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/suggest-parties',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Suggest Government Foreclosure Case Review Endpoint
 * Explicitly recompute review status/comment suggestions for one case.
 */
export const suggestGovernmentForeclosureCaseReview = <ThrowOnError extends boolean = false>(options: Options<SuggestGovernmentForeclosureCaseReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SuggestGovernmentForeclosureCaseReviewResponses, SuggestGovernmentForeclosureCaseReviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/suggest-review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Government Foreclosure License Assignment Candidates Endpoint
 * List exact address/APN license matches for this jurisdiction.
 */
export const getGovernmentForeclosureLicenseAssignmentCandidates = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentForeclosureLicenseAssignmentCandidatesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentForeclosureLicenseAssignmentCandidatesResponses, GetGovernmentForeclosureLicenseAssignmentCandidatesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/license-assignment-candidates',
        ...options
    });
};

/**
 * Assign Government Foreclosure Licenses Endpoint
 * Revalidate and assign selected unique license matches.
 */
export const assignGovernmentForeclosureLicenses = <ThrowOnError extends boolean = false>(options: Options<AssignGovernmentForeclosureLicensesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AssignGovernmentForeclosureLicensesResponses, AssignGovernmentForeclosureLicensesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/assign-licenses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Government Foreclosure License Matches Endpoint
 * Return the linked license or fuzzy APN/address candidates for a case.
 */
export const getGovernmentForeclosureLicenseMatches = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentForeclosureLicenseMatchesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentForeclosureLicenseMatchesResponses, GetGovernmentForeclosureLicenseMatchesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/license-matches',
        ...options
    });
};

/**
 * Link Government Foreclosure Case To License Endpoint
 * Apply the case number to a selected foreclosure license.
 */
export const linkGovernmentForeclosureCaseToLicense = <ThrowOnError extends boolean = false>(options: Options<LinkGovernmentForeclosureCaseToLicenseData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkGovernmentForeclosureCaseToLicenseResponses, LinkGovernmentForeclosureCaseToLicenseErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/link-license',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Government Foreclosure Case Review Endpoint
 * Update reviewed / registration-needed flags for a foreclosure case.
 */
export const updateGovernmentForeclosureCaseReview = <ThrowOnError extends boolean = false>(options: Options<UpdateGovernmentForeclosureCaseReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateGovernmentForeclosureCaseReviewResponses, UpdateGovernmentForeclosureCaseReviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/review',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Government Foreclosure Case Review History Endpoint
 * Return newest-first review-status changes for one foreclosure case.
 */
export const getGovernmentForeclosureCaseReviewHistory = <ThrowOnError extends boolean = false>(options: Options<GetGovernmentForeclosureCaseReviewHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGovernmentForeclosureCaseReviewHistoryResponses, GetGovernmentForeclosureCaseReviewHistoryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/review-history',
        ...options
    });
};

/**
 * Preflight Government Bulk Create Unregistered Endpoint
 * Check which selected foreclosure cases can become unregistered properties.
 */
export const preflightGovernmentBulkCreateUnregistered = <ThrowOnError extends boolean = false>(options: Options<PreflightGovernmentBulkCreateUnregisteredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreflightGovernmentBulkCreateUnregisteredResponses, PreflightGovernmentBulkCreateUnregisteredErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/bulk-create-unregistered-preflight',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Bulk Create Government Unregistered From Cases Endpoint
 * Create unregistered properties for a chunk of foreclosure cases.
 */
export const bulkCreateGovernmentUnregisteredFromCases = <ThrowOnError extends boolean = false>(options: Options<BulkCreateGovernmentUnregisteredFromCasesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BulkCreateGovernmentUnregisteredFromCasesResponses, BulkCreateGovernmentUnregisteredFromCasesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/bulk-create-unregistered',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Government Foreclosure Unregistered Match Endpoint
 * Return the case-number attachment or address suggestions for this case.
 */
export const getGovernmentForeclosureUnregisteredMatch = <ThrowOnError extends boolean = false>(options?: Options<GetGovernmentForeclosureUnregisteredMatchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetGovernmentForeclosureUnregisteredMatchResponses, GetGovernmentForeclosureUnregisteredMatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/unregistered-match',
        ...options
    });
};

/**
 * Link Government Foreclosure Case To Unregistered Endpoint
 * Apply the case number to a selected unregistered property.
 */
export const linkGovernmentForeclosureCaseToUnregistered = <ThrowOnError extends boolean = false>(options: Options<LinkGovernmentForeclosureCaseToUnregisteredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LinkGovernmentForeclosureCaseToUnregisteredResponses, LinkGovernmentForeclosureCaseToUnregisteredErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/government/foreclosure-cases/link-unregistered',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Unregistered Properties Endpoint
 * Get all unregistered properties, optionally filtered by jurisdiction.
 */
export const getUnregisteredProperties = <ThrowOnError extends boolean = false>(options?: Options<GetUnregisteredPropertiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUnregisteredPropertiesResponses, GetUnregisteredPropertiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/',
        ...options
    });
};

/**
 * Create Unregistered Property Endpoint
 * Create a new unregistered property record.
 */
export const createUnregisteredProperty = <ThrowOnError extends boolean = false>(options: Options<CreateUnregisteredPropertyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUnregisteredPropertyResponses, CreateUnregisteredPropertyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Unregistered Property Endpoint
 * Delete an unregistered property record.
 */
export const deleteUnregisteredProperty = <ThrowOnError extends boolean = false>(options: Options<DeleteUnregisteredPropertyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteUnregisteredPropertyResponses, DeleteUnregisteredPropertyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/{unregistered_id}',
        ...options
    });
};

/**
 * Get Unregistered Property Endpoint
 * Get an unregistered property by ID.
 */
export const getUnregisteredProperty = <ThrowOnError extends boolean = false>(options: Options<GetUnregisteredPropertyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUnregisteredPropertyResponses, GetUnregisteredPropertyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/{unregistered_id}',
        ...options
    });
};

/**
 * Update Unregistered Property Endpoint
 * Update an unregistered property record.
 *
 * Only accessible to government and operator users. Registrants cannot access this endpoint.
 */
export const updateUnregisteredProperty = <ThrowOnError extends boolean = false>(options: Options<UpdateUnregisteredPropertyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateUnregisteredPropertyResponses, UpdateUnregisteredPropertyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/{unregistered_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Unregistered Saved Import Mappings Endpoint
 * List saved mappings for unregistered uploads.
 */
export const listUnregisteredSavedImportMappings = <ThrowOnError extends boolean = false>(options?: Options<ListUnregisteredSavedImportMappingsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUnregisteredSavedImportMappingsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/saved-import-mappings',
        ...options
    });
};

/**
 * Create Unregistered Saved Import Mapping Endpoint
 * Create a saved mapping for unregistered uploads.
 */
export const createUnregisteredSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<CreateUnregisteredSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUnregisteredSavedImportMappingResponses, CreateUnregisteredSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/saved-import-mappings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Unregistered Saved Import Mapping Endpoint
 * Delete one saved mapping for unregistered uploads.
 */
export const deleteUnregisteredSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<DeleteUnregisteredSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteUnregisteredSavedImportMappingResponses, DeleteUnregisteredSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/saved-import-mappings/{mapping_id}',
        ...options
    });
};

/**
 * Update Unregistered Saved Import Mapping Endpoint
 * Update one saved mapping for unregistered uploads.
 */
export const updateUnregisteredSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<UpdateUnregisteredSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateUnregisteredSavedImportMappingResponses, UpdateUnregisteredSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/saved-import-mappings/{mapping_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Apply Unregistered Saved Import Mapping Endpoint
 * Preview applying one saved mapping to an unregistered upload sheet.
 */
export const applyUnregisteredSavedImportMapping = <ThrowOnError extends boolean = false>(options: Options<ApplyUnregisteredSavedImportMappingData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApplyUnregisteredSavedImportMappingResponses, ApplyUnregisteredSavedImportMappingErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/saved-import-mappings/apply',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Temp File Unregistered Field Mapping
 * Get temp file field mapping for a file using OpenAI assuming it is an unregistered properties file.
 */
export const getUnregisteredFieldMappingForTempFile = <ThrowOnError extends boolean = false>(options: Options<GetUnregisteredFieldMappingForTempFileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUnregisteredFieldMappingForTempFileResponses, GetUnregisteredFieldMappingForTempFileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/tempfiles/{token}/field_mapping',
        ...options
    });
};

/**
 * Dryrun Unregistered Creation Endpoint
 * Dry run unregistered properties creation from uploaded file using field mappings.
 *
 * Note: Geocoding, Tiger, and APN lookup cache entries are committed even during
 * dry runs to avoid wasting API calls on subsequent runs. Only cache writes are
 * committed; all other operations (property/unregistered creation) are skipped during dry_run.
 */
export const dryrunUnregisteredCreation = <ThrowOnError extends boolean = false>(options: Options<DryrunUnregisteredCreationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DryrunUnregisteredCreationResponses, DryrunUnregisteredCreationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/bulk_create/dry_run',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Unregistered Properties Endpoint
 * Create unregistered properties from uploaded file using field mappings.
 */
export const createUnregisteredProperties = <ThrowOnError extends boolean = false>(options: Options<CreateUnregisteredPropertiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUnregisteredPropertiesResponses, CreateUnregisteredPropertiesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/bulk_create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Unregistered Comments Endpoint
 * Get all comments for an unregistered property.
 */
export const getUnregisteredComments = <ThrowOnError extends boolean = false>(options: Options<GetUnregisteredCommentsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetUnregisteredCommentsResponses, GetUnregisteredCommentsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/{unregistered_id}/comments',
        ...options
    });
};

/**
 * Create Unregistered Comment Endpoint
 * Create a comment for an unregistered property.
 */
export const createUnregisteredComment = <ThrowOnError extends boolean = false>(options: Options<CreateUnregisteredCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateUnregisteredCommentResponses, CreateUnregisteredCommentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/{unregistered_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Check Apn Registered Endpoint
 * Check if an APN is already registered (has a license) in a jurisdiction.
 *
 * Only accessible to government and operator users. Registrants cannot access this endpoint.
 */
export const checkApnRegistered = <ThrowOnError extends boolean = false>(options: Options<CheckApnRegisteredData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CheckApnRegisteredResponses, CheckApnRegisteredErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/unregistered/check_apn_registered',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Title Account
 * The signed-in title account, or the account an operator is viewing.
 */
export const getTitleAccount = <ThrowOnError extends boolean = false>(options?: Options<GetTitleAccountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTitleAccountResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account',
        ...options
    });
};

/**
 * Update Title Account
 * Update profile details. A secondary cannot change the organization address.
 */
export const updateTitleAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateTitleAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateTitleAccountResponses, UpdateTitleAccountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Title Account Users
 * Primary, secondaries, and pending invites. Disabled users are optional.
 */
export const getTitleAccountUsers = <ThrowOnError extends boolean = false>(options?: Options<GetTitleAccountUsersData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTitleAccountUsersResponses, GetTitleAccountUsersErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users',
        ...options
    });
};

/**
 * Invite Title Account User
 * Invite a secondary user. A repeat invite to the same pending email is a no-op.
 */
export const addTitleAccountUser = <ThrowOnError extends boolean = false>(options: Options<AddTitleAccountUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddTitleAccountUserResponses, AddTitleAccountUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cancel Title Account Invite
 * Cancel a pending invite. Active users are disabled on the other route.
 */
export const cancelTitleAccountInvite = <ThrowOnError extends boolean = false>(options: Options<CancelTitleAccountInviteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CancelTitleAccountInviteResponses, CancelTitleAccountInviteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users/{user_id}',
        ...options
    });
};

/**
 * Disable Title Account User
 * Disable a secondary user. The primary and the caller cannot be disabled.
 */
export const disableTitleAccountUser = <ThrowOnError extends boolean = false>(options: Options<DisableTitleAccountUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DisableTitleAccountUserResponses, DisableTitleAccountUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users/{user_id}/disable',
        ...options
    });
};

/**
 * Reenable Title Account User
 * Restore a disabled secondary user.
 */
export const reenableTitleAccountUser = <ThrowOnError extends boolean = false>(options: Options<ReenableTitleAccountUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReenableTitleAccountUserResponses, ReenableTitleAccountUserErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users/{user_id}/reenable',
        ...options
    });
};

/**
 * Make Title Account Primary
 * Transfer the primary role. Only the current primary may do this.
 */
export const makeTitleAccountPrimary = <ThrowOnError extends boolean = false>(options: Options<MakeTitleAccountPrimaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MakeTitleAccountPrimaryResponses, MakeTitleAccountPrimaryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users/{user_id}/make-primary',
        ...options
    });
};

/**
 * Update Title Account User Admin
 * Grant or revoke admin. The primary stays an admin. You cannot change yourself.
 */
export const updateTitleAccountUserAdmin = <ThrowOnError extends boolean = false>(options: Options<UpdateTitleAccountUserAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateTitleAccountUserAdminResponses, UpdateTitleAccountUserAdminErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/users/{user_id}/admin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Title Pending Invite
 * Organization name for a user who has not accepted an invite.
 */
export const getTitlePendingInvite = <ThrowOnError extends boolean = false>(options?: Options<GetTitlePendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTitlePendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/pending-invite',
        ...options
    });
};

/**
 * Accept Title Pending Invite
 * Accept a pending title-account invite.
 */
export const acceptTitlePendingInvite = <ThrowOnError extends boolean = false>(options?: Options<AcceptTitlePendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AcceptTitlePendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/accept-invite',
        ...options
    });
};

/**
 * Reject Title Pending Invite
 * Reject a pending invite and remove the pending account.
 */
export const rejectTitlePendingInvite = <ThrowOnError extends boolean = false>(options?: Options<RejectTitlePendingInviteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RejectTitlePendingInviteResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/account/reject-invite',
        ...options
    });
};

/**
 * Search Title Accounts For Impersonation
 * Operator search for a title account to open. Registrant accounts are not here.
 */
export const searchTitleAccountsForImpersonation = <ThrowOnError extends boolean = false>(options: Options<SearchTitleAccountsForImpersonationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchTitleAccountsForImpersonationResponses, SearchTitleAccountsForImpersonationErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title/impersonation/search-accounts',
        ...options
    });
};

/**
 * Search Operator Title Accounts
 * Find a title requestor by name, company, or email.
 *
 * The title-portal search accepts a title-audience token. This route accepts
 * the operator portal token.
 */
export const searchOperatorTitleAccounts = <ThrowOnError extends boolean = false>(options: Options<SearchOperatorTitleAccountsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchOperatorTitleAccountsResponses, SearchOperatorTitleAccountsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-accounts/search',
        ...options
    });
};

/**
 * Create Operator Title Account
 * Create a title requestor, or return the account that already uses this email.
 */
export const createOperatorTitleAccount = <ThrowOnError extends boolean = false>(options: Options<CreateOperatorTitleAccountData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateOperatorTitleAccountResponses, CreateOperatorTitleAccountErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-accounts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Lookup Title Request Address
 * Preview a parcel match. Failure still returns a payload the form can submit.
 */
export const lookupTitleRequestAddress = <ThrowOnError extends boolean = false>(options: Options<LookupTitleRequestAddressData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LookupTitleRequestAddressResponses, LookupTitleRequestAddressErrors, ThrowOnError>({
        url: '/public/title-requests/lookup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create Title Request
 * Save a signed-in requester's title request, and a parcel match when one exists.
 */
export const createTitleRequest = <ThrowOnError extends boolean = false>(options: Options<CreateTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTitleRequestResponses, CreateTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/title-requests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Claim Title Request
 * Confirm the email on an anonymous request and attach it when logged in.
 */
export const claimTitleRequest = <ThrowOnError extends boolean = false>(options: Options<ClaimTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClaimTitleRequestResponses, ClaimTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/title-requests/claim',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List My Title Requests
 * Requests belonging to the signed-in title account.
 */
export const listMyTitleRequests = <ThrowOnError extends boolean = false>(options?: Options<ListMyTitleRequestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListMyTitleRequestsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title-requests',
        ...options
    });
};

/**
 * Get My Title Request
 * One request owned by the signed-in title account.
 */
export const getMyTitleRequest = <ThrowOnError extends boolean = false>(options: Options<GetMyTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMyTitleRequestResponses, GetMyTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title-requests/{request_id}',
        ...options
    });
};

/**
 * Add My Title Request Comment
 * Comment on a request in the signed-in title account.
 */
export const addMyTitleRequestComment = <ThrowOnError extends boolean = false>(options: Options<AddMyTitleRequestCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddMyTitleRequestCommentResponses, AddMyTitleRequestCommentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title-requests/{request_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Request Further Title Review
 * Reopen an active-interest request so Hera reviews the property again.
 */
export const requestFurtherTitleReview = <ThrowOnError extends boolean = false>(options: Options<RequestFurtherTitleReviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequestFurtherTitleReviewResponses, RequestFurtherTitleReviewErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title-requests/{request_id}/further-request',
        ...options
    });
};

/**
 * Cancel My Title Request
 * Cancel a request in the signed-in title account and mark it inactive.
 */
export const cancelMyTitleRequest = <ThrowOnError extends boolean = false>(options: Options<CancelMyTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelMyTitleRequestResponses, CancelMyTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title-requests/{request_id}/cancel',
        ...options
    });
};

/**
 * Get My Title Request Attachment
 * Download a receipt stored on an email for a request this account owns.
 */
export const getMyTitleRequestAttachment = <ThrowOnError extends boolean = false>(options: Options<GetMyTitleRequestAttachmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMyTitleRequestAttachmentResponses, GetMyTitleRequestAttachmentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/title-requests/{request_id}/attachments/{attachment_id}',
        ...options
    });
};

/**
 * List Operator Title Requests
 * Every title request, newest first.
 */
export const listOperatorTitleRequests = <ThrowOnError extends boolean = false>(options?: Options<ListOperatorTitleRequestsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListOperatorTitleRequestsResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests',
        ...options
    });
};

/**
 * Get Operator Title Request
 * Request details plus licenses and foreclosure cases on the property.
 */
export const getOperatorTitleRequest = <ThrowOnError extends boolean = false>(options: Options<GetOperatorTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorTitleRequestResponses, GetOperatorTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}',
        ...options
    });
};

/**
 * Update Operator Title Request
 * Change status, the submitted property details, or an operator note.
 */
export const updateOperatorTitleRequest = <ThrowOnError extends boolean = false>(options: Options<UpdateOperatorTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateOperatorTitleRequestResponses, UpdateOperatorTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Cancel Operator Title Request
 * Cancel any title request and mark it inactive.
 */
export const cancelOperatorTitleRequest = <ThrowOnError extends boolean = false>(options: Options<CancelOperatorTitleRequestData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelOperatorTitleRequestResponses, CancelOperatorTitleRequestErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}/cancel',
        ...options
    });
};

/**
 * Add Operator Title Request Comment
 * Comment on any title request as an operator.
 */
export const addOperatorTitleRequestComment = <ThrowOnError extends boolean = false>(options: Options<AddOperatorTitleRequestCommentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AddOperatorTitleRequestCommentResponses, AddOperatorTitleRequestCommentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}/comments',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send Title Request Property Compliant
 * Email the edited no-known-interest message and attach the selected certificates.
 */
export const sendTitleRequestPropertyCompliant = <ThrowOnError extends boolean = false>(options: Options<SendTitleRequestPropertyCompliantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendTitleRequestPropertyCompliantResponses, SendTitleRequestPropertyCompliantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}/property-compliant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Draft Title Request Property Non Compliant
 * Draft the active-interest email, including the balance due for the licenses.
 */
export const draftTitleRequestPropertyNonCompliant = <ThrowOnError extends boolean = false>(options: Options<DraftTitleRequestPropertyNonCompliantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DraftTitleRequestPropertyNonCompliantResponses, DraftTitleRequestPropertyNonCompliantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}/property-non-compliant/draft',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send Title Request Property Non Compliant
 * Email the edited active-interest message and attach the selected certificates.
 */
export const sendTitleRequestPropertyNonCompliant = <ThrowOnError extends boolean = false>(options: Options<SendTitleRequestPropertyNonCompliantData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SendTitleRequestPropertyNonCompliantResponses, SendTitleRequestPropertyNonCompliantErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}/property-non-compliant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Operator Title Request Attachment
 * Download a receipt stored on a title-request email.
 */
export const getOperatorTitleRequestAttachment = <ThrowOnError extends boolean = false>(options: Options<GetOperatorTitleRequestAttachmentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetOperatorTitleRequestAttachmentResponses, GetOperatorTitleRequestAttachmentErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/operator/title-requests/{request_id}/attachments/{attachment_id}',
        ...options
    });
};

/**
 * List Public Communities
 * List all active jurisdictions (communities) configured in the system.
 *
 * No authentication required. Intended for the public marketing site directory.
 */
export const listPublicCommunities = <ThrowOnError extends boolean = false>(options?: Options<ListPublicCommunitiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPublicCommunitiesResponses, unknown, ThrowOnError>({
        url: '/public/communities',
        ...options
    });
};

/**
 * List Public Registration Communities
 * Active jurisdictions that have any active license type matching **marketing_key**.
 */
export const listPublicRegistrationCommunities = <ThrowOnError extends boolean = false>(options: Options<ListPublicRegistrationCommunitiesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListPublicRegistrationCommunitiesResponses, ListPublicRegistrationCommunitiesErrors, ThrowOnError>({
        url: '/public/registration-communities',
        ...options
    });
};

/**
 * Get Public Jurisdiction
 * One active jurisdiction (for registrant deep links); 404 if missing or soft-deleted.
 */
export const getPublicJurisdiction = <ThrowOnError extends boolean = false>(options: Options<GetPublicJurisdictionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicJurisdictionResponses, GetPublicJurisdictionErrors, ThrowOnError>({
        url: '/public/jurisdictions/{jurisdiction_id}',
        ...options
    });
};

/**
 * List Public License Types
 * List active license types for marketing registration deep links.
 *
 * Excludes soft-deleted types and types marked **under_development** so the
 * marketing site only offers registrant flows that are production-ready.
 *
 * **marketing_key** is derived from the type name (e.g. names containing
 * "Foreclosure", "Vacant", or "Long-Term Rental") and is stable for the
 * hera-web site to match.
 */
export const listPublicLicenseTypes = <ThrowOnError extends boolean = false>(options?: Options<ListPublicLicenseTypesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPublicLicenseTypesResponses, unknown, ThrowOnError>({
        url: '/public/license-types',
        ...options
    });
};

/**
 * Get Public Hera Configuration
 * Public support/sales contacts for marketing site footer.
 */
export const getPublicHeraConfiguration = <ThrowOnError extends boolean = false>(options?: Options<GetPublicHeraConfigurationData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetPublicHeraConfigurationResponses, unknown, ThrowOnError>({
        url: '/public/hera-configuration',
        ...options
    });
};

/**
 * List Public Jurisdiction Pages
 * Jurisdictions that get a public registration page on heraregistry.com.
 *
 * Only jurisdictions with at least one configured, production-ready license
 * type are listed; the static site builds ``/jurisdictions/{fips_code}`` for each.
 */
export const listPublicJurisdictionPages = <ThrowOnError extends boolean = false>(options?: Options<ListPublicJurisdictionPagesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPublicJurisdictionPagesResponses, unknown, ThrowOnError>({
        url: '/public/jurisdiction-pages',
        ...options
    });
};

/**
 * Get Public Jurisdiction Page
 * Registration programs, requirements, fees and branding for one jurisdiction.
 */
export const getPublicJurisdictionPage = <ThrowOnError extends boolean = false>(options: Options<GetPublicJurisdictionPageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicJurisdictionPageResponses, GetPublicJurisdictionPageErrors, ThrowOnError>({
        url: '/public/jurisdiction-pages/{fips}',
        ...options
    });
};

/**
 * Get Public Jurisdiction Page Logo
 * Jurisdiction seal for its public page (public so ``<img src>`` works).
 */
export const getPublicJurisdictionPageLogo = <ThrowOnError extends boolean = false>(options: Options<GetPublicJurisdictionPageLogoData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicJurisdictionPageLogoResponses, GetPublicJurisdictionPageLogoErrors, ThrowOnError>({
        url: '/public/jurisdiction-pages/{fips}/logo',
        ...options
    });
};

/**
 * Get Public Demo Place Seal
 * Municipal seal/logo image (public; ``<img src>`` cannot send Bearer).
 */
export const getPublicDemoPlaceSeal = <ThrowOnError extends boolean = false>(options: Options<GetPublicDemoPlaceSealData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicDemoPlaceSealResponses, GetPublicDemoPlaceSealErrors, ThrowOnError>({
        url: '/public/demo/places/{fips}/seal',
        ...options
    });
};

/**
 * List Public Demo State Top Places
 * Top jurisdictions in a US state by foreclosure count (map browse mode).
 *
 * ``is_hera_customer`` is true when an active jurisdiction row shares the
 * place FIPS (partner community), not a synthetic demo flag.
 */
export const listPublicDemoStateTopPlaces = <ThrowOnError extends boolean = false>(options: Options<ListPublicDemoStateTopPlacesData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListPublicDemoStateTopPlacesResponses, ListPublicDemoStateTopPlacesErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/states/{state}/top-places',
        ...options
    });
};

/**
 * List Public Demo Hera Customers Heatmap
 * National (or state-scoped) HERA partner choropleth with yearly counts.
 *
 * Reads precomputed ``demo_hera_customer_heatmap`` rows only (no GCS seal
 * probes, no live TIGER). Fill color encodes foreclosure count; simplified
 * boundaries are included when the offline rebuild cached them.
 */
export const listPublicDemoHeraCustomersHeatmap = <ThrowOnError extends boolean = false>(options?: Options<ListPublicDemoHeraCustomersHeatmapData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListPublicDemoHeraCustomersHeatmapResponses, ListPublicDemoHeraCustomersHeatmapErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/hera-customers/heatmap',
        ...options
    });
};

/**
 * Resolve Public Demo Place
 * Place match for the foreclosure demo (heuristic by default; operator auth).
 */
export const resolvePublicDemoPlace = <ThrowOnError extends boolean = false>(options: Options<ResolvePublicDemoPlaceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResolvePublicDemoPlaceResponses, ResolvePublicDemoPlaceErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/resolve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Resolve Public Demo Place At
 * Reverse-lookup a demo place from map click coordinates (operator auth).
 */
export const resolvePublicDemoPlaceAt = <ThrowOnError extends boolean = false>(options: Options<ResolvePublicDemoPlaceAtData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResolvePublicDemoPlaceAtResponses, ResolvePublicDemoPlaceAtErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/at',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Public Demo Place Summary
 * Yearly foreclosure counts and fee for the demo dashboard.
 */
export const getPublicDemoPlaceSummary = <ThrowOnError extends boolean = false>(options: Options<GetPublicDemoPlaceSummaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicDemoPlaceSummaryResponses, GetPublicDemoPlaceSummaryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/{fips}/summary',
        ...options
    });
};

/**
 * Get Public Demo Place Hubspot Company
 * Return the matching HubSpot company URL without creating a record.
 */
export const getPublicDemoPlaceHubSpotCompany = <ThrowOnError extends boolean = false>(options: Options<GetPublicDemoPlaceHubSpotCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicDemoPlaceHubSpotCompanyResponses, GetPublicDemoPlaceHubSpotCompanyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/{fips}/hubspot-company',
        ...options
    });
};

/**
 * Create Public Demo Place Hubspot Company
 * Create a missing HubSpot lead and return its company record URL.
 */
export const createPublicDemoPlaceHubSpotCompany = <ThrowOnError extends boolean = false>(options: Options<CreatePublicDemoPlaceHubSpotCompanyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreatePublicDemoPlaceHubSpotCompanyResponses, CreatePublicDemoPlaceHubSpotCompanyErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/{fips}/hubspot-company',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Public Demo Place Events
 * Compact foreclosure events for the map timeline.
 */
export const getPublicDemoPlaceEvents = <ThrowOnError extends boolean = false>(options: Options<GetPublicDemoPlaceEventsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicDemoPlaceEventsResponses, GetPublicDemoPlaceEventsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/{fips}/events',
        ...options
    });
};

/**
 * Get Public Demo Place Boundary
 * GeoJSON boundary for stylized map framing (cached on first fetch).
 */
export const getPublicDemoPlaceBoundary = <ThrowOnError extends boolean = false>(options: Options<GetPublicDemoPlaceBoundaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicDemoPlaceBoundaryResponses, GetPublicDemoPlaceBoundaryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/{fips}/boundary',
        ...options
    });
};

/**
 * Email Public Demo Place Summary
 * Email a jurisdiction map snapshot and end-of-year stats (operator auth).
 */
export const emailPublicDemoPlaceSummary = <ThrowOnError extends boolean = false>(options: Options<EmailPublicDemoPlaceSummaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<EmailPublicDemoPlaceSummaryResponses, EmailPublicDemoPlaceSummaryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/public/demo/places/{fips}/email-summary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Regions Endpoint
 * Regions for the requested jurisdictions.
 */
export const listJurisdictionRegions = <ThrowOnError extends boolean = false>(options?: Options<ListJurisdictionRegionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListJurisdictionRegionsResponses, ListJurisdictionRegionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions',
        ...options
    });
};

/**
 * Create Region Endpoint
 * Save a drawn, uploaded, or prompted polygon.
 */
export const createJurisdictionRegion = <ThrowOnError extends boolean = false>(options: Options<CreateJurisdictionRegionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateJurisdictionRegionResponses, CreateJurisdictionRegionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Boundary Endpoint
 * Census boundary that every region in this jurisdiction is clipped to.
 */
export const getJurisdictionRegionBoundary = <ThrowOnError extends boolean = false>(options: Options<GetJurisdictionRegionBoundaryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetJurisdictionRegionBoundaryResponses, GetJurisdictionRegionBoundaryErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/boundary',
        ...options
    });
};

/**
 * Preview Upload Endpoint
 * Parse a shapefile zip or GeoJSON and clip it to the jurisdiction.
 */
export const previewJurisdictionRegionUpload = <ThrowOnError extends boolean = false>(options: Options<PreviewJurisdictionRegionUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewJurisdictionRegionUploadResponses, PreviewJurisdictionRegionUploadErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/preview-upload',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Commit Upload Endpoint
 * Save a preview as one region or one region per named feature.
 */
export const commitJurisdictionRegionUpload = <ThrowOnError extends boolean = false>(options: Options<CommitJurisdictionRegionUploadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommitJurisdictionRegionUploadResponses, CommitJurisdictionRegionUploadErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/commit-upload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Prompt Regions Endpoint
 * Turn a description into clipped region drafts. Nothing is saved.
 */
export const promptJurisdictionRegions = <ThrowOnError extends boolean = false>(options: Options<PromptJurisdictionRegionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PromptJurisdictionRegionsResponses, PromptJurisdictionRegionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/prompt',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Command Regions Endpoint
 * Apply a chat command immediately. The response includes undo steps.
 */
export const commandJurisdictionRegions = <ThrowOnError extends boolean = false>(options: Options<CommandJurisdictionRegionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommandJurisdictionRegionsResponses, CommandJurisdictionRegionsErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/command',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download Draft Shapefile Endpoint
 * Download one preview feature as a zipped shapefile.
 */
export const downloadRegionDraftShapefile = <ThrowOnError extends boolean = false>(options: Options<DownloadRegionDraftShapefileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadRegionDraftShapefileResponses, DownloadRegionDraftShapefileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/drafts/{draft_id}/features/{feature_index}/shapefile',
        ...options
    });
};

/**
 * Delete Region Endpoint
 * Delete a disabled region. An enabled region must be turned off first.
 */
export const deleteJurisdictionRegion = <ThrowOnError extends boolean = false>(options: Options<DeleteJurisdictionRegionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteJurisdictionRegionResponses, DeleteJurisdictionRegionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/{region_id}',
        ...options
    });
};

/**
 * Update Region Endpoint
 * Rename a region, replace its polygon, or enable and disable it.
 */
export const updateJurisdictionRegion = <ThrowOnError extends boolean = false>(options: Options<UpdateJurisdictionRegionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateJurisdictionRegionResponses, UpdateJurisdictionRegionErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/{region_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download Region Shapefile Endpoint
 * Download a saved region as a zipped shapefile.
 */
export const downloadJurisdictionRegionShapefile = <ThrowOnError extends boolean = false>(options: Options<DownloadJurisdictionRegionShapefileData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadJurisdictionRegionShapefileResponses, DownloadJurisdictionRegionShapefileErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/regions/{region_id}/shapefile',
        ...options
    });
};

/**
 * Health Check Endpoint
 * Health check endpoint.
 *
 * By default checks that the route is reachable, but can be called with optional query params that specify additional checks (like DB connectivity).
 */
export const checkHealth = <ThrowOnError extends boolean = false>(options?: Options<CheckHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckHealthResponses, CheckHealthErrors, ThrowOnError>({
        url: '/health',
        ...options
    });
};

/**
 * On Auth0 Login Endpoint
 * Login webhook target called by Auth0 post-login action.
 */
export const onAuth0Login = <ThrowOnError extends boolean = false>(options: Options<OnAuth0LoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OnAuth0LoginResponses, OnAuth0LoginErrors, ThrowOnError>({
        url: '/webhooks/auth0/on_login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * On Stripe Event Endpoint
 * Webhook target called by Stripe for various events.
 *
 * This endpoint handles Stripe webhook events. It verifies the webhook signature
 * using the Stripe webhook secret to ensure the request is legitimate.
 *
 * The endpoint can handle various Stripe events such as:
 * - payment_intent.succeeded
 * - payment_intent.payment_failed
 */
export const onStripeEvent = <ThrowOnError extends boolean = false>(options: Options<OnStripeEventData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OnStripeEventResponses, OnStripeEventErrors, ThrowOnError>({
        url: '/webhooks/stripe/events',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * On Hubspot Company Event Endpoint
 * Refresh HubSpot companies after GEOID, fee, or lifecycle changes.
 *
 * HubSpot CRM app webhooks POST ``company.creation`` and
 * ``company.propertyChange`` here. Signature v3 is verified, then matching
 * companies are recalculated in the background so HubSpot's 5s timeout is
 * not blocked by remittance math.
 */
export const onHubSpotCompanyEvent = <ThrowOnError extends boolean = false>(options?: Options<OnHubSpotCompanyEventData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<OnHubSpotCompanyEventResponses, unknown, ThrowOnError>({
        url: '/webhooks/hubspot/companies',
        ...options
    });
};

/**
 * List Hubspot Company Geofips Options Endpoint
 * List Census GEOID choices for a HubSpot company name.
 */
export const listHubSpotCompanyGeofipsOptions = <ThrowOnError extends boolean = false>(options: Options<ListHubSpotCompanyGeofipsOptionsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListHubSpotCompanyGeofipsOptionsResponses, ListHubSpotCompanyGeofipsOptionsErrors, ThrowOnError>({
        url: '/webhooks/hubspot/companies/{company_id}/geofips-options',
        ...options
    });
};

/**
 * Select Hubspot Company Geofips Endpoint
 * Save the GEOID chosen on the HubSpot company card.
 */
export const selectHubSpotCompanyGeofips = <ThrowOnError extends boolean = false>(options: Options<SelectHubSpotCompanyGeofipsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SelectHubSpotCompanyGeofipsResponses, SelectHubSpotCompanyGeofipsErrors, ThrowOnError>({
        url: '/webhooks/hubspot/companies/{company_id}/geofips',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * On Hubspot Contact Event Endpoint
 * Apply HubSpot Contact Type changes to matching VPRO government users.
 */
export const onHubSpotContactEvent = <ThrowOnError extends boolean = false>(options?: Options<OnHubSpotContactEventData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<OnHubSpotContactEventResponses, unknown, ThrowOnError>({
        url: '/webhooks/hubspot/contacts',
        ...options
    });
};